{
  "common": {
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "削除",
    "edit": "編集",
    "add": "追加",
    "search": "検索",
    "loading": "読み込み中...",
    "error": "エラー",
    "success": "成功",
    "back": "戻る",
    "next": "次へ",
    "previous": "前へ",
    "close": "閉じる",
    "appName": "{brand}",
    "searchPlaceholder": "検索...",
    "connectionReconnecting": "再接続中...",
    "connectionLostClickRetry": "接続が切断されました。クリックして再試行。",
    "connectionOffline": "オフライン",
    "searchExpandedPlaceholder": "機能またはドキュメントを検索...",
    "searchPromptEmpty": "入力して機能または関連ドキュメントを検索",
    "searchSectionApplication": "アプリケーション",
    "searchSectionDocumentation": "ドキュメント",
    "searchNoFeatureResults": "このクエリに一致する機能はありません",
    "searchNoDocResults": "このクエリに一致するドキュメントはありません",
    "description": "説明",
    "preview": "プレビュー",
    "addTag": "タグを追加...",
    "searchProjects": "プロジェクトを検索...",
    "searchModels": "モデルを検索...",
    "all": "すべて",
    "favorites": "お気に入り",
    "saveChanges": "変更を保存",
    "processing": "処理中...",
    "copy": "コピー",
    "copied": "コピーしました",
    "or": "または",
    "searchResource": "{{resource}}を検索...",
    "selectAll": "すべて選択",
    "clearAll": "すべてクリア",
    "resetToDefault": "デフォルトにリセット",
    "noOptionsAvailable": "利用可能なオプションはありません",
    "noMoreItems": "これ以上の項目はありません",
    "clearSearch": "検索をクリア",
    "apply": "適用",
    "clear": "クリア",
    "yes": "はい",
    "no": "いいえ",
    "notResource": "非{{resource}}",
    "afterDate": "{{date}}以降",
    "beforeDate": "{{date}}以前",
    "removeFilter": "{{label}}フィルターを削除",
    "removeFilterWithColon": "フィルターを削除: {{label}}",
    "showResource": "{{resource}}を表示",
    "hideResource": "{{resource}}を非表示",
    "filters": "フィルター",
    "searchItem": "{{item}}を検索...",
    "searchItemAria": "{{item}}を検索",
    "searchPrompts": "プロンプトを検索...",
    "showItem": "{{item}}を表示",
    "hideItem": "{{item}}を非表示"
  },
  "productDocs": {
    "title": "Product documentation",
    "lead": "Guides for getting started, models, tools, Agent Studio, observability, and administration — served from the same site as the platform.",
    "openNewTab": "Open in new tab",
    "openSameWindow": "Open in this window",
    "hint": "Docs are not shown inside the app shell because some login or edge responses set X-Frame-Options: DENY on pages that are not meant to be embedded. Opening in a new tab or full window keeps clickjacking protection intact and is the recommended way to read documentation."
  },
  "agentStore": {
    "title": "エージェントストア",
    "subtitle": "エンタープライズ向け AI エージェントを検索してデプロイ",
    "search": "エージェントを名前で検索...",
    "manage": "管理",
    "manageTooltip": "エージェントストアを管理",
    "loading": "エージェントを読み込み中...",
    "all": "すべて",
    "allAgents": "すべてのエージェント",
    "allAgentsCount": "すべてのエージェント ({{count}})",
    "resultsFound_other": "{{count}} 件のエージェントが見つかりました",
    "view": "表示",
    "open": "開く",
    "openApp": "アプリを開く",
    "pending": "保留中",
    "subscribe": "登録",
    "unnamedAgent": "エージェント",
    "categoryOther": "その他",
    "noDescription": "説明はありません",
    "noAgents": "エージェントが見つかりません",
    "noAgentsInCategory": "{{category}} にエージェントが見つかりません",
    "tryAdjusting": "検索条件またはフィルター条件を変更してください"
  },
  "catalogFilters": {
    "filters": "フィルター",
    "filtersApplied": "フィルター ({{count}} 件適用)",
    "clearAll": "すべてクリア",
    "creator": "作成者",
    "allCreators": "すべての作成者",
    "searchCreators": "作成者を検索...",
    "rating": "評価",
    "allRatings": "すべての評価",
    "rating5": "星5",
    "rating4Up": "星4以上",
    "rating3Up": "星3以上",
    "allOf": "すべての{{label}}"
  },
  "nav": {
    "home": "ホーム",
    "ideate": "意思決定インテリジェンスプラットフォーム",
    "solutions": "ソリューション",
    "agentStore": "エージェントストア",
    "projects": "プロジェクト",
    "data": "データ",
    "agentStudio": "エージェントスタジオ",
    "agentWorkflows": "エージェントワークフロー",
    "registry": "レジストリ",
    "registryUnified": "レジストリ",
    "aiTransparency": "AI 透明性",
    "workflowStore": "ワークフローストア",
    "workflowRegistry": "ワークフローレジストリ",
    "agentDeployments": "エージェントデプロイメント",
    "workflowDeployments": "ワークフローデプロイメント",
    "workflowStoreBrowse": "ワークフローを閲覧",
    "workflowStoreManage": "ワークフローストア管理",
    "workflowStoreAbout": "ワークフロー詳細",
    "simulations": "シミュレーション",
    "evalsSimulations": "評価とシミュレーション",
    "monitoring": "モニタリング",
    "cache": "キャッシュ",
    "agentEvals": "エージェント評価",
    "evalTemplates": "評価テンプレート",
    "benchmarks": "ベンチマーク",
    "environments": "環境",
    "evaluations": "評価",
    "agents": "エージェント",
    "models": "モデル",
    "tools": "ツール",
    "prompts": "プロンプト",
    "skills": "スキル",
    "knowledge": "ナレッジ",
    "connections": "接続",
    "docs": "ドキュメント",
    "admin": "管理",
    "platformAdmin": "プラットフォーム管理",
    "settings": "設定",
    "chat": "チャット",
    "goToHome": "ホームへ",
    "userMenu": "ユーザーメニュー",
    "account": "アカウント",
    "switchRole": "ロール切替",
    "tenant": "テナント",
    "logout": "ログアウト",
    "help": "ヘルプ",
    "helpDocumentation": "ヘルプとドキュメント",
    "themeDarkModeTitle": "ダークモード",
    "themeLightModeTitle": "ライトモード",
    "themeSwitchToDarkAria": "ダークモードに切り替え",
    "themeSwitchToLightAria": "ライトモードに切り替え",
    "sections": {
      "agentDevelop": "エージェント開発",
      "observability": "オブザーバビリティ",
      "agentOps": "エージェント運用",
      "resources": "リソース",
      "admin": "管理",
      "aiBlueprints": "ブループリント",
      "enterpriseOntology": "エンタープライズオントロジー"
    },
    "ontologyCanvas": "オントロジーキャンバス",
    "dataModels": "データモデル",
    "kpiLibrary": "KPIライブラリ",
    "migrationsStudio": "マイグレーションスタジオ",
    "dataPipelines": "データスタジオ",
    "pipelineDesigner": "MLスタジオ",
    "dataExplorer": "データエクスプローラー",
    "dataObservability": "データオブザーバビリティ",
    "switchToDataflow": "{brand} オントロジースタジオ",
    "blueprints": "ブループリント",
    "autopilot": "意思決定プラットフォーム",
    "brandMilkyway": "{brand}",
    "brandPlatform": "{brand} Platform",
    "switchToMilkyway": "{brand}",
    "switchToPlatform": "{brand} Platform"
  },
  "settings": {
    "title": "設定",
    "description": "アカウント設定と環境設定を管理",
    "profile": "ユーザープロフィール",
    "appearance": "外観",
    "language": "言語",
    "languageDescription": "希望する言語を選択",
    "theme": "テーマ",
    "light": "ライト",
    "dark": "ダーク",
    "appearanceHeading": "外観",
    "appearanceSubtitle": "ワークスペースの見た目をカスタマイズ",
    "colorTheme": "カラーテーマ",
    "colorThemeDescription": "アプリのカラーパレットを選択",
    "displayModeSection": "表示モード",
    "displayModeDescription": "ライトモードとダークモードを選択",
    "themeDefaultBadge": "既定",
    "loadingAppearance": "外観設定を読み込み中...",
    "notifications": {
      "title": "通知"
    },
    "integrations": {
      "title": "連携"
    }
  },
  "models": {
    "title": "モデル",
    "addModel": "モデルを追加",
    "editModel": "モデルを編集",
    "modelName": "モデル名",
    "provider": "プロバイダー",
    "baseUrl": "ベースURL",
    "chat": "チャット",
    "deleteConfirm": "このモデルを削除してもよろしいですか？",
    "noModels": "モデルが見つかりません",
    "filterProvider": "プロバイダー",
    "filterStatus": "ステータス",
    "filterCreator": "作成者",
    "statusActive": "アクティブ",
    "statusDeprecated": "非推奨",
    "columnModelName": "モデル名",
    "columnProvider": "プロバイダー",
    "columnStatus": "ステータス",
    "columnAccess": "アクセス",
    "columnCreatedBy": "作成者",
    "columnCreatedAt": "作成日時",
    "columnUpdatedAt": "更新日時",
    "columnActions": "アクション",
    "actionChat": "チャット",
    "actionTestConnection": "接続テスト",
    "actionSetDefault": "デフォルトに設定",
    "actionRemoveDefault": "デフォルト解除",
    "actionManageAccess": "アクセス管理",
    "actionExport": "エクスポート",
    "actionEdit": "編集",
    "actionDelete": "削除",
    "bulkExportSelected": "選択項目をエクスポート",
    "bulkDeleteSelected": "選択項目を削除",
    "modelArena": "モデルアリーナ",
    "modelArenaTitle": "モデルアリーナで2つのモデルを比較",
    "pricingCatalog": "価格カタログ",
    "pricingCatalogTitle": "100万トークンあたりのUSD価格インターバルの表示と編集",
    "deleteModalTitle": "モデルの削除",
    "deleteModalMessage": "「{{name}}」を削除してもよろしいですか？この操作は取り消せません。",
    "bulkDeleteModalTitle": "選択したモデルを削除",
    "bulkDeleteModalMessage": "選択した {{count}} 件のモデルを削除してもよろしいですか？この操作は取り消せません。",
    "bulkDeleteModalConfirm": "{{count}} 件のモデルを削除",
    "loadingModels": "モデルを読み込み中...",
    "favorites": "お気に入り",
    "filterBarTitle": "フィルター",
    "searchPlaceholder": "モデルを検索...",
    "defaultModelTooltip": "デフォルトモデル",
    "pricing": {
      "title": "価格カタログ",
      "description": "100万トークンあたりのUSD — 表示中のモデルのうち最も安価な入力順に並べ替え。プロバイダーの比較には {{endpoint}} を使用してください。",
      "descriptionPrefix": "100万トークンあたりのUSD — 表示中のモデルのうち最も安価な入力順に並べ替え。プロバイダーの比較には",
      "descriptionSuffix": "を使用してください。",
      "allProviders": "すべてのプロバイダー",
      "fromInput": "最安 ${{price}}/in",
      "fromInputTooltip": "最安 ${{price}} / 100万入力 (表示中のモデル)",
      "viewMore": "他 {{count}} 件を表示",
      "searchPlaceholder": "モデルまたはプロバイダーを検索…",
      "emptyMessage": "モデルが見つかりません。",
      "loadingMessage": "価格カタログを読み込み中…",
      "loadModelsFailed": "モデルの読み込みに失敗しました",
      "harvestSuccess": "価格の収集が完了しました: {{summary}}",
      "harvestFailed": "価格の収集に失敗しました",
      "modelsPriced": "{{count}} 件のモデルの価格設定完了",
      "modelsPriced_plural": "{{count}} 件のモデルの価格設定完了",
      "skippedCount": "{{count}} 件スキップ",
      "errorsCount": "{{count}} 件のエラー",
      "errorsCount_plural": "{{count}} 件のエラー",
      "viewHistory": "履歴を表示",
      "noPricing": "価格なし",
      "live": "有効",
      "notOpenEnded": "期限設定あり",
      "notOpenEndedTooltip": "最新の行は終了済み期間です。今後の価格設定のためにオープンな期間が存在することを確認してください。",
      "columns": {
        "model": "モデル",
        "inputRate": "入力レート",
        "outputRate": "出力レート",
        "interval": "期間",
        "source": "ソース"
      },
      "history": {
        "title": "価格履歴",
        "subtitle": "完全な価格履歴。アクティブなカタログ行が最初に表示されます。手動インターバルおよび収集されたレートは編集可能です（編集は手動オーバーライドになります）。手動インターバルのみ削除できます。",
        "currentCatalogRate": "現在のカタログレート",
        "liveOpenEnded": "有効 (期限なし)",
        "notOpenEnded": "期限設定あり",
        "notOpenEndedTooltip": "期限なしのインターバルがありません。フォールバックとして最新のクローズド期間を表示しています。",
        "searchPlaceholder": "ソース、日付、レートを検索…",
        "emptyMessage": "検索に一致する価格履歴がありません。",
        "loadingMessage": "価格履歴を読み込み中…",
        "failedToLoad": "価格履歴の読み込みに失敗しました",
        "refresh": "更新",
        "addManualInterval": "手動インターバルを追加",
        "activeRate": "アクティブレート",
        "historical": "履歴",
        "effectiveFrom": "適用開始日",
        "effectiveUntil": "適用終了日",
        "unit": "単位",
        "inputRate": "入力レート",
        "outputRate": "出力レート",
        "source": "ソース",
        "deleteModalTitle": "価格インターバルを削除",
        "deleteModalMessage": "この手動価格インターバルを削除してもよろしいですか？この操作は取り消せません。",
        "delete": "削除",
        "intervalAdded": "価格インターバルを追加しました",
        "intervalUpdated": "価格インターバルを更新しました",
        "intervalDeleted": "価格インターバルを削除しました",
        "failedToAdd": "価格インターバルの追加に失敗しました",
        "failedToUpdate": "価格インターバルの更新に失敗しました",
        "failedToDelete": "価格インターバルの削除に失敗しました",
        "units": {
          "perMinute": "分あたり",
          "perMillionChars": "100万文字あたり",
          "perMillionTokens": "100万トークンあたり"
        }
      },
      "modal": {
        "addTitle": "価格インターバルを追加",
        "editTitle": "価格インターバルを編集",
        "model": "モデル",
        "selectModel": "モデルを選択...",
        "effectiveFrom": "適用開始日",
        "effectiveUntil": "適用終了日",
        "effectiveUntilHelp": "任意 — 現在有効な価格（期限なし）にする場合は空のままにします。",
        "unit": "単位",
        "unitOptions": {
          "tokens": "100万トークンあたり (LLM / 埋め込み)",
          "minute": "分あたり (STT / 音声)",
          "chars": "100万文字あたり (TTS)"
        },
        "fieldLabels": {
          "usdPerMinute": "USD / 分",
          "outputPriceOptional": "出力価格 (任意)",
          "inputPriceOptional": "入力価格 (任意)",
          "usdPer1MChars": "USD / 100万文字",
          "inputUsdPer1MTokens": "入力 USD / 100万トークン",
          "outputUsdPer1MTokens": "出力 USD / 100万トークン"
        },
        "validation": {
          "selectModel": "モデルを選択してください",
          "effectiveFromRequired": "適用開始日は必須です",
          "effectiveFromFormat": "適用開始日は YYYY-MM-DD 形式である必要があります",
          "effectiveUntilFormat": "適用終了日は YYYY-MM-DD 形式である必要があります",
          "effectiveUntilAfterFrom": "適用終了日は適用開始日以降である必要があります",
          "inputNonNegative": "入力USDは0以上の数値である必要があります",
          "outputNonNegative": "出力USDは0以上の数値である必要があります"
        },
        "cancel": "キャンセル",
        "save": "インターバルを保存",
        "add": "インターバルを追加",
        "saving": "保存中..."
      }
    },
    "form": {
      "addTitle": "モデルを追加",
      "editTitle": "モデルを編集",
      "loadingQuota": "クォータを読み込み中...",
      "modelType": "モデルタイプ",
      "cannotChangeTypeAfterCreation": "作成後は変更できません ({{type}})",
      "provider": "プロバイダー",
      "providerTooltip": "AIプロバイダーを選択してください。選択したモデルタイプと互換性のある {{count}} 件のプロバイダーを表示しています。",
      "showingEmbeddingProviders": "埋め込みをサポートする {{count}} 件のプロバイダーを表示中",
      "showingTypeProviders": "{{count}} 件の {{type}} プロバイダーを表示中",
      "providerLockedTooltip": "作成後にプロバイダーを変更することはできません。",
      "selectModel": "モデルを選択",
      "optionalTemplate": "(任意のテンプレート)",
      "discoverFallbackTooltip": "ライブワークスペースエンドポイントには上記の「検出」を優先してください。テンプレートはフォールバックです。",
      "availableModelsTooltip": "利用可能な {{provider}} {{type}} モデルから選択 ({{count}} 件利用可能)",
      "selectAModel": "モデルを選択",
      "selectATypeModel": "{{type}} モデルを選択",
      "discovered": "検出済み",
      "baseUrl": "ベースURL",
      "baseUrlTooltip": "OllamaやLM Studioなどのローカルプロバイダーで必須です。クラウドプロバイダーの場合は空のままにしてください。",
      "apiKeyRef": "APIキー参照",
      "apiKeyRefTooltip": "プロバイダーAPIキーを保持する環境変数名（バックエンドデプロイメントで設定）。",
      "displayName": "表示名",
      "displayNameModelIdSetTooltip": "モデルIDは上記で選択したモデルから設定されます。",
      "displayNameAutoGeneratedTooltip": "モデルが選択されていない場合、モデルIDは表示名から自動生成されます。",
      "fullModelNamePreview": "完全なモデル名のプレビュー:",
      "displayNamePlaceholder": "例: Chat Completion",
      "apiVersion": "APIバージョン",
      "apiVersionTooltip": "ゲートウェイで必要なAPIバージョン",
      "paramProfile": "パラメータプロファイル",
      "defaultParams": "デフォルトパラメータ (JSON)",
      "defaultParamsTooltip": "リクエストごとにモデルに送信されるデフォルトパラメータを含むオプションのJSONオブジェクト (例: temperature、max_tokens)。",
      "testSuccess": "✓ 接続テスト成功",
      "testFailed": "✗ 接続テスト失敗",
      "modelResponse": "モデルの応答:",
      "testing": "テスト中...",
      "testConnection": "接続をテスト",
      "testConnectionTitle": "保存前に接続をテスト",
      "addModel": "モデルを追加",
      "adding": "追加中...",
      "saving": "保存中...",
      "quotaExceeded": "モデルのクォータを超過しました",
      "noChangesToSave": "保存する変更はありません",
      "selectProvider": "プロバイダーを選択"
    },
    "tags": {
      "llm": "テキスト",
      "image": "画像",
      "embedding": "埋め込み",
      "audio": "音声",
      "video": "動画",
      "reranker": "リランカー",
      "tts": "音声合成",
      "stt": "音声認識"
    },
    "tagDescriptions": {
      "llm": "テキストモデルはチャットやテキスト補完タスクの言語応答を生成します",
      "image": "画像モデルは視覚的コンテンツを生成、編集、または分析します",
      "embedding": "埋め込みモデルはテキストをベクトルに変換し、セマンティック検索や類似度マッチングを行います",
      "audio": "オーディオモデルは音声や音楽を処理および生成します",
      "video": "動画モデルは動画コンテンツを生成および編集します",
      "reranker": "リランキングモデルはクエリとの関連性に基づいてドキュメントを評価および順序付けします",
      "tts": "音声合成モデルはテキストから音声を生成します（チャットやテキスト補完用ではありません）",
      "stt": "文字起こしモデルは音声をテキストに変換します（チャットやテキスト補完用ではありません）"
    },
    "emptyState": {
      "permissionDenied": "モデルを表示する権限がありません。アクセスするには管理者に問い合わせてください。",
      "noResultsSearch": "検索に一致するモデルが見つかりませんでした。",
      "default": "モデルが見つかりません。最初のモデルを作成して開始してください。"
    }
  },
  "chat": {
    "title": "チャット",
    "placeholder": "メッセージを入力...",
    "send": "送信",
    "modelNotSelected": "モデルが選択されていません",
    "modelNotFound": "モデルが見つかりません",
    "failedToLoad": "モデルの読み込みに失敗しました",
    "failedToSend": "メッセージの送信に失敗しました",
    "ollamaNotRunning": "Ollamaに接続できません。Ollamaが実行されていることを確認してください：ollama serve",
    "modelNotFoundOllama": "モデルが見つからないか、Ollamaが実行されていません。Ollamaのインストールを確認してください。",
    "modelArena": {
      "title": "モデルアリーナ",
      "vs": "VS",
      "selectModel": "モデルを選択",
      "startConversation": "会話を開始",
      "processing": "処理中...",
      "recording": "録音中...",
      "record": "録音",
      "stop": "停止",
      "or": "または",
      "uploadAudio": "音声をアップロード",
      "query": "クエリ",
      "documents": "ドキュメント（1行に1つ、最低2つ）",
      "compare": "比較",
      "enterInput": "入力...",
      "noImageOrText": "画像またはテキストが返されませんでした",
      "noVideoReturned": "動画が返されませんでした",
      "copied": "コピーしました",
      "copy": "コピー",
      "copyResponse": "応答をコピー",
      "startRecording": "録音開始",
      "stopRecording": "録音停止",
      "cannotChangeModel": "チャット開始後はモデルを変更できません",
      "cannotChangeType": "チャット開始後はモデルタイプを変更できません",
      "noModelsAvailable": "利用可能なモデルがありません",
      "addAnotherModel": "比較するモデルを追加してください",
      "onlyOneModelAvailable": "利用可能なモデルが1つしかありません。モデルアリーナには2つの異なるモデルが必要です。",
      "sameModelSelected": "両側に同じモデルを選択しています。比較するには別のモデルを選択してください。",
      "startBeforeRating": "セッションを評価する前に会話を開始してください",
      "restoreView": "分割表示に戻す",
      "expandLeft": "左パネルを拡大",
      "expandRight": "右パネルを拡大",
      "selectModel2": "モデルを選択...",
      "searchModels": "モデルを検索...",
      "syncedToBoth": "{{placeholder}}（両方に同期）",
      "placeholders": {
        "searchQuery": "検索クエリを入力...",
        "rerankDocs": "ドキュメント1のテキスト...\nドキュメント2のテキスト...\nドキュメント3のテキスト...",
        "tts": "合成するテキストを入力...",
        "image": "生成する画像を説明...",
        "video": "生成する動画を説明...（数分かかる場合があります）"
      },
      "types": {
        "llm": "テキスト",
        "image": "画像",
        "audio": "オーディオ",
        "video": "動画",
        "reranker": "リランク",
        "tts": "音声合成",
        "stt": "文字起こし"
      },
      "typeDescriptions": {
        "llm": "テキストモデルはチャットや補完タスク向けの言語応答を生成します",
        "image": "画像モデルはテキストプロンプトから画像を生成または編集します",
        "audio": "オーディオモデルは非音声のオーディオコンテンツを処理または生成します",
        "video": "動画モデルは動画コンテンツを生成または分析します",
        "reranker": "リランクモデルは取得したドキュメントを並べ替え、RAGの関連性を向上させます",
        "tts": "音声合成モデルはテキストから音声を生成します",
        "stt": "文字起こしモデルは音声をテキストに変換します"
      }
    },
    "newChat": "新しいチャット",
    "newSession": "新しいチャット",
    "endOfSessions": "セッション終了",
    "noSessionsYet": "モデルアリーナセッションがまだありません",
    "startNewConversation": "新しい会話を開始",
    "startConversation": "会話を開始",
    "startConversationWithModel": "このモデルで会話を開始",
    "configuration": "設定",
    "collapseConfig": "折りたたむ",
    "expandConfig": "設定",
    "backToModels": "モデルに戻る",
    "refreshSessions": "セッションを更新",
    "activeSessionEmpty": "アクティブセッションが空です",
    "newModelArena": "新しいモデルアリーナ",
    "loadingDot": "読み込み中...",
    "loadingMore": "さらに読み込み中...",
    "sessionRenamed": "セッションの名前を変更しました",
    "failedToRename": "セッションの名前変更に失敗しました",
    "sessionDeleted": "セッションが正常に削除されました",
    "failedToDelete": "セッションの削除に失敗しました",
    "deleteSession": "モデルアリーナセッションを削除",
    "deleteSessionConfirm": "このモデルアリーナセッションを削除してもよろしいですか？両方の個別モデルセッションも削除されます。この操作は元に戻せません。",
    "rename": "名前を変更",
    "delete": "削除",
    "save": "保存",
    "cancel": "キャンセル",
    "selectPrompt": "プロンプトを選択...",
    "searchPrompts": "プロンプトを検索...",
    "selectSkills": "スキルを選択...",
    "searchSkills": "スキルを検索...",
    "version": "バージョン",
    "rateSession": "セッションを評価",
    "rateThisSession": "このセッションを評価",
    "updateFeedback": "フィードバックを更新",
    "helpful": "役に立った",
    "notHelpful": "役に立たなかった",
    "rated": "評価: {{value}}/10",
    "feedbackProvided": "フィードバック提供済み",
    "startBeforeRating": "評価する前に会話を開始してください",
    "selectHelpful": "送信する前に「役に立った」または「役に立たなかった」を選択してください",
    "failedToSaveComparisonFeedback": "比較フィードバックの保存に失敗しました",
    "feedbackSubmitted": "フィードバックが正常に送信されました",
    "failedToSubmitSessionFeedback": "セッションフィードバックの送信に失敗しました",
    "promptTemplate": "プロンプトテンプレート",
    "skills": "スキル",
    "model": "モデル",
    "sttModel": "音声認識（添付ファイル）",
    "knowledge": "ナレッジ",
    "tools": "ツール",
    "settings": "設定"
  },
  "admin": {
    "title": "管理",
    "users": "ユーザー",
    "roles": "ロール",
    "pending": "保留中",
    "active": "アクティブ"
  },
  "solutions": {
    "title": "ソリューション",
    "subtitle": "リポジトリとコードを共有し、QA・UAT・本番へのリンクをすばやく開けます。",
    "addSolution": "ソリューションを追加",
    "dialogTitle": "ソリューションを追加",
    "editDialogTitle": "ソリューションを編集",
    "submit": "カタログに追加",
    "submitEdit": "変更を保存",
    "empty": "まだソリューションがありません。最初の1件を追加してチームの参照を早くしましょう。",
    "openGithub": "GitHub リポジトリを開く",
    "editSolution": "ソリューションを編集",
    "deleteSolution": "ソリューションを削除",
    "deleteSelected": "選択を削除",
    "openEditor": "エディターを開く",
    "sourceGithub": "GitHub URL",
    "sourceCode": "コードファイル",
    "codeHint": "作成後はコードエディターに移動し、ファイルの追加・編集ができます。",
    "shortcutHint": "ヒント: Ctrl / ⌘ + Enter で送信します。",
    "toast": {
      "created": "カタログにソリューションを追加しました。",
      "updated": "ソリューションを更新しました。",
      "deleted": "ソリューションを削除しました。",
      "bulkDeleted": "{{deleted}} 件のソリューションを削除しました。{{skipped}} 件をスキップしました。",
      "conflict": "ほかの場所で変更されています。最新を読み込むにはページを更新してください。"
    },
    "fields": {
      "name": "ソリューション名",
      "description": "説明",
      "githubUrl": "GitHub リポジトリ URL",
      "sourceType": "ソース種別",
      "tags": "タグ",
      "owner": "所有者"
    },
    "placeholders": {
      "description": "短い概要（2〜3行）"
    },
    "validation": {
      "nameRequired": "名前は必須です。",
      "nameTooLong": "名前は{{max}}文字以内にしてください。",
      "descriptionTooLong": "説明は{{max}}文字以内にしてください。",
      "githubRequired": "GitHub URL は必須です。",
      "githubInvalid": "有効な https の GitHub リポジトリ URL を入力してください。",
      "urlInvalid": "有効な http(s) URL である必要があります。"
    },
    "confirmDeleteTitle": "ソリューションを削除",
    "confirmDeleteMessage": "「{{name}}」を削除しますか？ソリューションとすべてのファイルが完全に削除されます。",
    "confirmBulkDeleteTitle": "選択したソリューションを削除",
    "confirmBulkDeleteMessage": "{{count}} 件のソリューションを削除しますか？ソリューションとすべてのファイルが完全に削除されます。",
    "editor": {
      "explorer": "エクスプローラー",
      "newFile": "新しいファイル",
      "noFiles": "ファイルはまだありません。",
      "addFirstFile": "ファイルを追加",
      "selectFile": "エクスプローラーでファイルを選んで編集を開始します。",
      "noFileSelected": "ファイルが選択されていません",
      "saveChanges": "変更を保存",
      "saved": "保存しました",
      "unsavedChanges": "未保存の変更",
      "deleteFile": "ファイルを削除",
      "confirmDelete": "「{{file}}」を削除しますか？元に戻せません。",
      "delete": "削除",
      "fileExists": "このパスのファイルは既に存在します。",
      "notFound": "ソリューションが見つかりません。",
      "backToList": "ソリューション一覧へ",
      "settings": "設定",
      "metadataTitle": "ソリューション設定",
      "metadataSaved": "設定を保存しました。"
    }
  },
  "tenant": {
    "switch": "テナントを切り替える",
    "subdomain": "サブドメイン:"
  },
  "home": {
    "tabs": {
      "overview": "概要",
      "agents": "エージェント",
      "workflows": "ワークフロー",
      "evals": "評価",
      "sessions": "セッション",
      "cost": "コスト",
      "platform": "プラットフォーム"
    },
    "dateRangeAriaLabel": "ダッシュボードの日付範囲",
    "sectionInfoAriaLabel": "セクション情報",
    "viewLabel": "{{label}}を表示",
    "loading": "ダッシュボードを読み込み中...",
    "loadFailed": "データの読み込みに失敗しました",
    "retry": "再試行",
    "noDataAvailable": "利用可能なデータがありません",
    "noData": "データなし",
    "quickActions": {
      "createAgent": "エージェントを作成",
      "newWorkflow": "新しいワークフロー",
      "runEval": "評価を実行",
      "aiAgentBuilder": "AIエージェントビルダー",
      "aiWorkflowsBuilder": "AIワークフロービルダー",
      "agentStore": "エージェントストア",
      "tools": "ツール"
    },
    "activity": {
      "title": "最近のアクティビティ",
      "export": "エクスポート",
      "filterAll": "すべて",
      "filterUpdate": "更新",
      "filterCreate": "作成",
      "filterDelete": "削除",
      "noActivityFound": "アクティビティが見つかりません",
      "actionCreate": "作成",
      "actionUpdate": "更新",
      "actionDelete": "削除",
      "actionRead": "読み取り",
      "resourceIdTitle": "リソースID",
      "viewAll": "すべて表示"
    },
    "overview": {
      "kpi": {
        "totalAgents": "エージェント総数",
        "totalAgentsHintDefault": "選択した期間内に作成",
        "totalAgentsHintAllTenants": "選択した期間内に作成 · 全テナント · アーカイブ済みを除く",
        "totalAgentsHintStudio": "選択した期間内に作成 · エージェントスタジオと同じ範囲",
        "totalWorkflows": "ワークフロー総数",
        "activeUsers": "アクティブユーザー",
        "activeDeployments": "アクティブなデプロイ",
        "activeDeploymentsHint": "選択した期間内に作成されたアクティブなデプロイ",
        "sessions": "セッション",
        "evalRuns": "評価実行回数",
        "toolCalls": "ツール呼び出し回数",
        "archivedDelta": "アーカイブ済み",
        "totalProjects": "プロジェクト総数",
        "activeProjects": "アクティブなプロジェクト",
        "modelsAvailable": "利用可能なモデル",
        "toolsAvailable": "利用可能なツール",
        "activeConnections": "アクティブな接続",
        "pendingApprovals": "承認待ち",
        "actionNeeded": "対応が必要"
      },
      "funnel": {
        "active": "アクティブ",
        "deployments": "デプロイ"
      },
      "series": {
        "agentsCreated": "作成されたエージェント",
        "projects": "プロジェクト",
        "sessions": "セッション",
        "workflows": "ワークフロー",
        "evals": "評価",
        "medianRuntime": "中央実行時間（ミリ秒）",
        "retryRate": "再試行率 %",
        "slaBreaches": "SLA違反"
      },
      "platformTrendTitle": "プラットフォームの傾向",
      "platformTrendSubtitle": "プラットフォームエンティティの成長と活動の推移",
      "loadingPlatformTrend": "プラットフォームの傾向を読み込み中...",
      "loadingActivity": "アクティビティを読み込み中...",
      "quickActionsTitle": "クイックアクション",
      "adoptionHealthTitle": "導入状況と健全性",
      "adoptionFunnelTitle": "導入ファネル",
      "adoptionFunnelSubtitle": "セットアップからアクティブな利用までのプロジェクトの流れ",
      "adoptionFunnelInfo": "プロジェクトが作成からアクティブなデプロイ、セッション利用へと進む様子を示します。各バーは、その段階に到達したプロジェクトの数を表します。",
      "topRiskSignalTitle": "最重要リスクシグナル",
      "topRiskSignalSubtitle": "プラットフォームで最も重大なリスクと健全性アラート",
      "topRiskSignalInfo": "ワークフローの失敗率とセッションアクティビティの傾向に基づき、現在最も重大なプラットフォームリスクを表示します。グラフはSLA違反の件数を示します。",
      "riskSeverityWarn": "警告",
      "noActiveRiskSignal": "アクティブなリスクシグナルはありません",
      "metricFallback": "指標",
      "workflowHealthTitle": "ワークフローの健全性",
      "workflowHealthSubtitle": "実行のパフォーマンスと信頼性の指標",
      "workflowHealthInfo": "ワークフロー実行の健全性を追跡します。中央実行時間は処理速度を示し、再試行率は信頼性の問題を示し、SLA違反は失敗またはタイムアウトした実行を示します。",
      "actionableHighlightsTitle": "対応が必要なハイライト",
      "actionableHighlightsSubtitle": "アクティビティと推奨事項で上位のエンティティ",
      "actionableHighlightsInfo": "セッションアクティビティと評価カバレッジで上位のプロジェクトです。\n\nヘルスステータス:\n• 良好: > 0 セッション, > 0 評価実行\n• 警告: > 0 セッション, 0 評価実行\n• 不良: 0 セッション\n\n各行にはセッション数、評価実行回数、プラットフォームの導入または品質を改善するための推奨アクションが表示されます。",
      "noHighlightsYet": "ハイライトはまだありません",
      "table": {
        "entity": "エンティティ",
        "type": "タイプ",
        "sessions": "セッション",
        "evalRuns": "評価実行回数",
        "failurePercent": "失敗率 %",
        "health": "健全性",
        "recommendedAction": "推奨アクション"
      }
    },
    "na": "該当なし",
    "agents": {
      "kpi": {
        "draft": "下書き",
        "published": "公開済み",
        "registered": "登録済み",
        "deployed": "デプロイ済み",
        "storeListings": "ストア掲載数"
      },
      "sections": {
        "byEnvironment": "環境別エージェント",
        "byStatus": "エージェントステータス",
        "registryStatus": "登録ステータス",
        "deploymentPipeline": "デプロイパイプライン",
        "byProjectsTitle": "プロジェクト別エージェント",
        "byProjectsSubtitle": "プロジェクト間のエージェントの分布"
      },
      "barName": "エージェント"
    },
    "workflows": {
      "kpi": {
        "executions": "実行回数",
        "successRate": "成功率",
        "activeSchedules": "アクティブなスケジュール"
      },
      "sections": {
        "executionStatus": "実行ステータス",
        "triggerSource": "トリガー元",
        "executionVolumeTitle": "実行ボリューム",
        "executionVolumeSubtitle": "選択した期間内のワークフロー実行総数",
        "successRateTrendTitle": "成功率の推移",
        "successRateTrendSubtitle": "成功した実行の割合の推移",
        "scheduleOverview": "スケジュール概要",
        "recentExecutions": "最近の実行"
      },
      "noRecentExecutions": "最近の実行はありません",
      "series": {
        "executions": "実行回数",
        "successPercent": "成功率 %"
      },
      "statusActive": "アクティブ",
      "statusPaused": "一時停止中",
      "everySeconds": "{{seconds}}秒ごと",
      "table": {
        "workflow": "ワークフロー",
        "type": "タイプ",
        "schedule": "スケジュール",
        "status": "ステータス",
        "nextRun": "次回実行",
        "trigger": "トリガー",
        "duration": "所要時間",
        "started": "開始"
      }
    },
    "evals": {
      "kpi": {
        "totalEvalSessions": "評価セッション総数",
        "totalEvalSessionsHint": "選択した期間内に作成されたセッション（日付フィルターを反映）。",
        "avgEvalQualityScore": "平均評価品質スコア",
        "avgEvalQualityScoreHint": "選択した期間内の評価セッション全体の平均サマリー指標スコア。",
        "passRate": "合格率",
        "passRateHint": "選択した期間内でスコアが70%以上のサマリー指標の割合。"
      },
      "zones": {
        "poor": "不良",
        "fair": "普通",
        "good": "良好"
      },
      "sections": {
        "averageScoreTitle": "平均評価品質スコア",
        "sessionsByStatus": "ステータス別セッション",
        "sessionsTrendTitle": "評価セッションの推移",
        "sessionsTrendSubtitle": "評価セッション数の推移",
        "frameworkDistribution": "フレームワーク分布",
        "topEvaluatedAgents": "評価上位エージェント"
      },
      "series": {
        "evalSessions": "評価セッション"
      },
      "table": {
        "agent": "エージェント",
        "evalSessions": "評価セッション",
        "latestScore": "最新スコア",
        "framework": "フレームワーク"
      }
    },
    "sessions": {
      "kpi": {
        "activeSessionsInPeriod": "アクティブセッション（期間内）",
        "activeSessionsHint": "選択した期間内に1件以上のメッセージまたはターンがあったセッション。",
        "avgTurnsPerSession": "平均ターン数 / セッション",
        "avgTurnsHint": "選択した期間内にアクティブだったセッションにおける、セッションあたりの平均会話ターン数。",
        "messages": "メッセージ",
        "avgLatency": "平均レイテンシー",
        "avgCostPerCall": "平均コスト / 呼び出し",
        "avgCostPerCallHint": "コストタブと一致します（LLMログ＋利用イベント）。"
      },
      "sections": {
        "byEnvironment": "環境別セッション",
        "byEnvironmentSubtitle": "さまざまな環境にわたるアクティブセッションの分布。",
        "visibilityDistribution": "公開範囲の分布",
        "visibilityDistributionSubtitle": "公開範囲レベル別のセッションの内訳。",
        "sessionTrendTitle": "セッションの推移",
        "sessionTrendSubtitle": "選択した期間の日次セッション数。",
        "messagesTrendTitle": "メッセージの推移",
        "messagesTrendSubtitle": "全セッションの日次メッセージ量。",
        "tokenUsageTitle": "トークン使用量",
        "tokenUsageSubtitle": "コストタブと同じ日次合計です（LLMログ＋利用イベント）。",
        "latencyTrendTitle": "レイテンシーの推移",
        "latencyTrendSubtitle": "平均および分位レイテンシーの推移。",
        "topAgentsBySessions": "セッション数上位エージェント"
      },
      "series": {
        "tokens": "トークン",
        "avgLatency": "平均レイテンシー",
        "p90Latency": "P90レイテンシー",
        "p95Latency": "P95レイテンシー",
        "p99Latency": "P99レイテンシー"
      },
      "table": {
        "agent": "エージェント",
        "sessions": "セッション",
        "messages": "メッセージ",
        "avgLatency": "平均レイテンシー",
        "avgTokens": "平均トークン数"
      }
    },
    "cost": {
      "kpi": {
        "totalTokens": "トークン総数",
        "inputTokens": "入力トークン",
        "outputTokens": "出力トークン",
        "cachedTokens": "キャッシュ済みトークン",
        "estCost": "推定コスト",
        "llmCalls": "LLM呼び出し回数",
        "avgTokensPerCall": "平均トークン数/呼び出し",
        "dailyAvgCost": "日次平均コスト",
        "peakUsageDate": "ピーク利用日",
        "peakTokens": "ピークトークン数",
        "dailyAvgTokens": "日次平均トークン数",
        "avgCostPerCall": "平均コスト/呼び出し"
      },
      "sections": {
        "tokenUsageTrendTitle": "トークン使用量の推移",
        "tokenUsageTrendSubtitle": "処理されたトークン量の推移",
        "costTrendTitle": "コストの推移",
        "costTrendSubtitle": "推定運用コストの推移",
        "tokensByServiceTitle": "サービス別トークン",
        "tokensByServiceSubtitle": "システムサービス別の総トークン使用量",
        "costByServiceTitle": "サービス別推定コスト",
        "costByServiceSubtitle": "システムサービス別の財務影響内訳",
        "tokensByConsumerTitle": "利用者別トークン",
        "tokensByConsumerSubtitle": "API利用者別のトークン消費量",
        "costByConsumerTitle": "利用者別推定コスト",
        "costByConsumerSubtitle": "API利用者別のコスト内訳",
        "tokenDistByModelTitle": "モデル別トークン分布",
        "tokenDistByModelSubtitle": "AIモデル別のトークン使用比率",
        "costByModelTitle": "モデル別コスト見積もり",
        "costByModelSubtitle": "各AIモデルに起因する推定費用",
        "tokensByProjectTitle": "プロジェクト別トークン消費量",
        "tokensByProjectSubtitle": "登録プロジェクトごとの総使用トークン数",
        "costByProjectTitle": "プロジェクト別推定コスト",
        "costByProjectSubtitle": "プロジェクト別のAI利用に関する財務内訳",
        "tokensByAgentTitle": "エージェント別トークン消費量",
        "tokensByAgentSubtitle": "個々のAIエージェント別のトークン使用量",
        "costByAgentTitle": "エージェント別推定コスト",
        "costByAgentSubtitle": "特定のAIエージェントの財務影響",
        "tokensByWorkflowTitle": "ワークフロー別トークン消費量",
        "tokensByWorkflowSubtitle": "自動化されたワークフローが処理したトークン量",
        "costByWorkflowTitle": "ワークフロー別推定コスト",
        "costByWorkflowSubtitle": "AIワークフロー実行に起因するコスト",
        "tokensByEnvironmentTitle": "環境別トークン消費量",
        "tokensByEnvironmentSubtitle": "デプロイ環境別の使用状況指標",
        "costByEnvironmentTitle": "環境別推定コスト",
        "costByEnvironmentSubtitle": "デプロイ環境別の財務内訳",
        "tokensByUsersTitle": "ユーザー別トークン消費量",
        "tokensByUsersSubtitle": "個々のエンドユーザーが使用したトークン量",
        "costByUsersTitle": "ユーザー別推定コスト",
        "costByUsersSubtitle": "特定ユーザーに起因する運用費用",
        "topCostDriversTitle": "上位コスト要因",
        "topCostDriversSubtitle": "プラットフォームコストに最も寄与する高消費エージェント"
      },
      "noDataRange": {
        "projectToken": "この期間のプロジェクト別トークンデータはありません。",
        "projectCost": "この期間のプロジェクト別コストデータはありません。",
        "agentToken": "この期間のエージェント別トークンデータはありません。",
        "agentCost": "この期間のエージェント別コストデータはありません。",
        "workflowToken": "この期間のワークフロー別トークンデータはありません。",
        "workflowCost": "この期間のワークフロー別コストデータはありません。",
        "environmentToken": "この期間の環境別トークンデータはありません。",
        "environmentCost": "この期間の環境別コストデータはありません。",
        "userToken": "この期間のユーザー別トークンデータはありません。",
        "userCost": "この期間のユーザー別コストデータはありません。"
      },
      "barName": {
        "tokens": "トークン",
        "usd": "USD",
        "models": "モデル"
      },
      "table": {
        "agent": "エージェント",
        "totalTokens": "トークン総数",
        "inputTokens": "入力トークン",
        "outputTokens": "出力トークン",
        "estCost": "推定コスト"
      }
    },
    "platform": {
      "kpi": {
        "totalTenants": "テナント総数",
        "totalUsers": "ユーザー総数",
        "rejectedUsers": "却下されたユーザー"
      },
      "sections": {
        "userGrowthTitle": "ユーザー数の推移",
        "usersByRoleTitle": "ロール別ユーザー",
        "approvalDecisionsTitle": "承認結果",
        "userStatusDistributionTitle": "ユーザーステータス分布",
        "auditActivityTitle": "監査アクティビティ",
        "tenantOverviewTitle": "テナント概要"
      },
      "series": {
        "newUsers": "新規ユーザー",
        "approved": "承認済み",
        "rejected": "却下"
      },
      "table": {
        "tenant": "テナント",
        "users": "ユーザー",
        "projects": "プロジェクト",
        "agents": "エージェント",
        "created": "作成日"
      }
    }
  },
  "blueprints": {
    "common": {
      "all": "すべて",
      "cancel": "キャンセル",
      "deepThinkingDesc": "徹底的な分析",
      "deepThinkingLabel": "ディープシンキング",
      "delete": "削除",
      "deleteBlueprintMessage": "「{{name}}」を削除しますか？この操作は元に戻せません。",
      "deleteBlueprintTitle": "ブループリントを削除しますか？",
      "dismiss": "閉じる",
      "expressModeDesc": "高速で直接的な生成",
      "expressModeLabel": "エクスプレスモード",
      "loading": "ブループリントを読み込み中...",
      "modeDeep": "ディープ",
      "modeFast": "ファスト",
      "noProjectsFound": "プロジェクトが見つかりません。プロジェクトを作成して選択してください。",
      "noSystemBlueprints": "システムブループリントはありません。",
      "proceed": "続行",
      "removeAttachedFile": "添付ファイルを削除",
      "scopeLibrary": "カスタム",
      "scopeSystem": "システム",
      "searchAriaLabel": "ブループリントを検索",
      "searchPlaceholder": "ブループリントを検索…",
      "searchSelectProjectPlaceholder": "プロジェクトを検索して選択...",
      "selectProjectLabel": "開始するにはプロジェクトが必要です：",
      "selectProjectTitle": "プロジェクトを選択",
      "selectThinkingModeTitle": "思考モードを選択",
      "sourceAriaLabel": "ブループリントのソース",
      "stopRecording": "録音を停止",
      "systemBadge": "システム",
      "systemBadgeTitle": "プラットフォームスターター — 読み取り専用",
      "targetAgent": "エージェント",
      "targetWorkflow": "ワークフロー",
      "thinkingModeHeader": "思考モード",
      "uploadFile": "ファイルをアップロード",
      "voiceInput": "音声入力"
    },
    "list": {
      "activeBlueprintsTitle": "有効なブループリント",
      "addToSpotlight": "スポットライトに追加",
      "archive": "アーカイブ",
      "archiveBlueprintMessage": "「{{name}}」をアーカイブしますか？アクティブな一覧から非表示になります。",
      "archiveBlueprintTitle": "ブループリントをアーカイブしますか？",
      "archivedBlueprintsTitle": "アーカイブ済みブループリント",
      "backTitle": "戻る",
      "cardActionsAriaLabel": "カードの操作",
      "catalogScopeTitle": "ブループリントカタログの範囲",
      "closeAriaLabel": "閉じる",
      "delete": "削除",
      "done": "完了",
      "edit": "編集",
      "errorCount": "エラー {{count}} 件",
      "export": "エクスポート",
      "filters": {
        "status": "ステータス",
        "draft": "下書き",
        "pendingReview": "レビュー待ち",
        "pending": "保留中",
        "approved": "承認済み",
        "archived": "アーカイブ済み",
        "industry": "ドメイン",
        "creator": "作成者"
      },
      "filtersTitle": "フィルター",
      "fork": "フォーク",
      "goBackAriaLabel": "戻る",
      "importAriaLabel": "ブループリントをインポート",
      "importCompleteHeading": "インポート完了",
      "importErrorSubtitle": "一部の項目をインポートできませんでした。詳細は以下をご覧ください。",
      "importFinishedWithErrorsHeading": "エラーを伴ってインポートが完了しました",
      "importSuccessSubtitle": "ブループリントは下書きとしてインポートされ、確認の準備ができています。",
      "importTitle": "YAMLからブループリントをインポート",
      "loadingMore": "追加のブループリントを読み込み中...",
      "newBlueprint": "新規ブループリント",
      "noBlueprintsMatchFilters": "フィルターに一致するブループリントがありません。",
      "noBlueprintsYet": "まだブループリントがありません。",
      "pageSubtitle": "会話型ワークフローとエージェントビルダーのプロセス仕様",
      "pageTitle": "ブループリント",
      "refreshAriaLabel": "リストを更新",
      "refreshTitle": "更新",
      "removeFromSpotlight": "スポットライトから削除",
      "spotlightBadgeTitle": "スポットライト {{rank}} — DIPランディングページに最初に表示（クイックスタート）",
      "spotlightFullTitle": "スポットライトが満杯です（最大 {{max}}）。先に1つ削除してください。",
      "statCreated": "作成済み",
      "statFailed": "失敗",
      "statSkipped": "スキップ",
      "systemCreatorFallback": "システム",
      "toasts": {
        "addedToSpotlight": "ブループリントをDIPスポットライトに追加しました",
        "archiveFailed": "アーカイブに失敗しました",
        "blueprintArchived": "ブループリントをアーカイブしました",
        "blueprintDeleted": "ブループリントを削除しました",
        "blueprintExported": "ブループリントをエクスポートしました",
        "blueprintForked": "ブループリントをフォークしました",
        "blueprintImported": "ブループリントをインポートしました",
        "blueprintUnarchived": "ブループリントのアーカイブを解除しました",
        "couldNotAddToSpotlight": "スポットライトに追加できませんでした",
        "couldNotRemoveFromSpotlight": "スポットライトから削除できませんでした",
        "deleteFailed": "削除に失敗しました",
        "exportFailed": "エクスポートに失敗しました",
        "forkFailed": "フォークに失敗しました",
        "importCompletedWithErrors": "エラーを伴ってインポートが完了しました",
        "importFailed": "インポートに失敗しました",
        "importedWithWarnings": "警告 {{count}} 件でブループリントをインポートしました",
        "removedFromSpotlight": "DIPスポットライトから削除しました",
        "unarchiveFailed": "アーカイブ解除に失敗しました"
      },
      "typeAgent": "エージェント",
      "typeTabsAriaLabel": "ブループリントの種類",
      "typeWorkflow": "ワークフロー",
      "unarchive": "アーカイブ解除",
      "unarchiveBlueprintMessage": "「{{name}}」を下書き状態に戻しますか？",
      "unarchiveBlueprintTitle": "ブループリントのアーカイブを解除しますか？",
      "warningCount": "警告 {{count}} 件"
    }
  },
  "ideate": {
    "aiPrefix": "AI",
    "backToPlatformAriaLabel": "Decision Intelligence Platformに戻る",
    "blueprintDeletedToast": "ブループリントを削除しました",
    "blueprintFallback": "ブループリント",
    "blueprintLaunchHeader": "ブループリント起動",
    "buildWithBlueprint": "ブループリントで構築",
    "chooseProjectPlaceholder": "プロジェクトを選択…",
    "complianceAriaLabel": "コンプライアンス要件",
    "complianceLabel": "コンプライアンス",
    "couldNotOpenSharedSession": "共有セッションを開けませんでした",
    "deleteFailedToast": "削除に失敗しました",
    "deleteSessionMessage": "このセッションを削除してもよろしいですか？この操作は元に戻せません。",
    "deleteSessionTitle": "セッションを削除",
    "deployAriaLabel": "{{brand}}で{{name}}をデプロイ",
    "deployWithDip": "Decision Intelligence Platformでデプロイ",
    "deployWithDipAriaLabel": "Decision Intelligence Platformで{{name}}をデプロイ",
    "deployWithTitle": "{{brand}}でデプロイ",
    "guidedLaunchDesc": "詳細なウェブ調査、明確化、LLM検証",
    "guidedLaunchLabel": "ガイド付き起動",
    "importHeader": "インポート",
    "importN8nDesc": "既存のn8n JSONをAI Workflowsに取り込む",
    "importN8nLabel": "n8nワークフローをインポート",
    "lookingForBlueprints": "このドメインのブループリントを検索中…",
    "moreIndustries": "その他",
    "noBlueprintsAvailable": "利用可能なブループリントがありません。ブループリントを追加してお試しください。",
    "noBlueprintsForFilter": "このフィルターに該当するブループリントがありません。",
    "noBlueprintsForIndustry": "このドメインのブループリントがありません。",
    "placeholderAgent": "作成するエージェントを説明してください...",
    "placeholderWorkflow": "自動化するユースケースを説明してください...",
    "placeholderWorkflowShort": "自動化するワークフローを説明してください...",
    "preBuiltBlueprints": "既製のブループリント",
    "quickLaunchDesc": "調査をスキップし、ブループリントのガイドラインとKPIをそのまま使用",
    "quickLaunchLabel": "クイック起動",
    "requireOptTitle": "{{label}}を必須にする",
    "spotlightBadgeTitleShort": "DIPランディングページに最初に表示（クイックスタート）",
    "spotlightRank": "スポットライト {{rank}}",
    "tagline": "発見する。再構築する。最適化する。本番稼働へ",
    "untitledSession": "無題のセッション",
    "uploadDocumentOrImage": "ドキュメントまたは画像をアップロード",
    "compliance": {
      "soc2": "SOC 2 / SOX",
      "gdpr": "GDPR / データレジデンシー",
      "hipaa": "HIPAA",
      "pii": "PIIマスキングが必要"
    }
  },
  "ontology": {
    "canvasTitle": "オントロジーキャンバス",
    "canvasSubtitle": "ソースからML分析までのエンドツーエンドのデータリネージ",
    "dataModelsTitle": "データモデル",
    "dataModelsSubtitle": "業界横断のエンタープライズデータモデルカタログ",
    "kpiLibraryTitle": "KPIライブラリ",
    "kpiLibrarySubtitle": "ビジネスKPI定義とメトリクスカタログ",
    "migrationsStudioTitle": "移行スタジオ",
    "migrationsStudioSubtitle": "AI移行エージェント、検証、リネージを1つのワークスペースでディスカバリーからカットオーバーまでオーケストレーション。",
    "pipelinesTitle": "データスタジオ",
    "pipelinesSubtitle": "移行の引き継ぎ、オーケストレーターワークフロー、KPI連動処理を1つのカタログに",
    "observabilityTitle": "データオブザーバビリティ",
    "observabilitySubtitle": "パイプラインの健全性監視とデータ鮮度の追跡",
    "nodesSelected": "{{count}} 件のノードを選択中",
    "overview": "概要",
    "lineage": "リネージ",
    "buildTimeline": "ビルドタイムライン",
    "dataHealth": "データの健全性",
    "allFamilies": "すべてのファミリー",
    "allTypes": "すべてのタイプ",
    "mustHave": "必須",
    "goodToHave": "推奨",
    "totalKpis": "KPI総数",
    "families": "ファミリー",
    "export": "CSVエクスポート",
    "exportCard": "エクスポート…",
    "exportCardTitleDataModel": "データモデルをエクスポート",
    "exportCardTitleOntology": "オントロジーをエクスポート",
    "exportCardTitleKpi": "KPIをエクスポート",
    "exportCardSubtitle": "ファイル形式を選択してダウンロードしてください。",
    "exportCardDownload": "ダウンロード",
    "exportCardCancel": "キャンセル",
    "exportFormatPortableJson": "ポータブルJSON（データモデル作成経由でラウンドトリップ）",
    "exportFormatPortableYaml": "ポータブルYAML（JSONと同じ内容）",
    "exportFormatDdl": "SQL DDL",
    "exportFormatDrawio": "Draw.io XML",
    "exportFormatTurtle": "Turtle (.ttl)",
    "exportFormatRdfXml": "RDF/XML",
    "exportFormatJsonLd": "JSON-LD",
    "version": "バージョン",
    "versions": "バージョン一覧",
    "latest": "最新",
    "compareVersions": "比較",
    "neo4jGraph": "ネットワークグラフ",
    "diffAdded": "追加",
    "diffRemoved": "削除",
    "diffUnchanged": "変更なし",
    "diffNoChanges": "変更はありません",
    "diffSelectTwo": "比較する2つの異なるバージョンを選択してください。",
    "exportFormatCsv": "CSV（別インスタンスへのインポート用）",
    "exportFormatKpiJson": "JSONスナップショット（バックアップ／ツール用）",
    "exportKpiJsonNote": "CSVはKPIライブラリのCSVインポートに対応しています。JSONはバックアップや外部ツール用で、JSONインポートは現時点では未対応です。",
    "healthy": "正常",
    "degraded": "低下",
    "critical": "重大",
    "running": "実行中",
    "completed": "完了",
    "failed": "失敗",
    "scheduled": "予定",
    "published": "公開済み",
    "draft": "下書き",
    "impactAnalysis": "影響分析",
    "impactActive": "影響あり",
    "viewDataSample": "データサンプルを表示",
    "resourceOverview": "リソース概要",
    "pipelineDrawerCode": "コード",
    "pipelineDrawerRuns": "実行履歴",
    "pipelineDrawerMetadata": "メタデータ",
    "pipelineDrawerNoCode": "このノードにはまだ変換コードが登録されていません。リポジトリを接続するか、パイプラインビルダーから公開してください。",
    "pipelineDrawerNoPipeline": "このノードにリンクされたデータパイプラインが見つかりませんでした。",
    "pipelineDrawerNoRuns": "リンクされたパイプラインの実行履歴はありません。",
    "pipelineDrawerNoMetadata": "変換スクリプト以外に追加のパラメータはありません。",
    "pipelineLinkedJob": "リンクされたパイプライン",
    "pipelineNodeParams": "パラメータ",
    "nodeInfoSection": "ノード情報",
    "unknownHealth": "不明",
    "sourceChip": "ソース",
    "dataExplorer": "データエクスプローラー",
    "openInDataExplorerAriaLabel": "データエクスプローラーで開く",
    "pipelineRunHistoryUnavailable": "パイプラインの実行履歴はバックエンドからまだ提供されていません。",
    "viewSample": "サンプルを表示",
    "metadataSectionTitle": "メタデータ",
    "kvOwner": "所有者",
    "kvDescription": "説明",
    "kvPipeline": "パイプライン",
    "kvSchedule": "スケジュール",
    "kvUpdated": "更新日時",
    "kvType": "タイプ",
    "kvLastUpdated": "最終更新",
    "category": {
      "data_source": "データソース",
      "data_extract": "データ抽出",
      "pipeline_builder_dataset": "パイプラインビルダーデータセット",
      "python_transform": "Python変換",
      "python_script_transform": "Pythonスクリプト変換",
      "virtual_table": "仮想テーブル",
      "fusion_sync": "Fusion同期",
      "fusion_sheet": "Fusionシート",
      "kpi_node": "KPIノード",
      "ml_model": "MLモデル"
    },
    "stage": {
      "source": "ソース",
      "ingestion": "取り込み",
      "transformation": "変換",
      "kpi": "KPI層",
      "ml_analytics": "ML＆分析"
    },
    "toolbar": {
      "tools": "ツール",
      "layout": "レイアウト",
      "undo": "元に戻す",
      "redo": "やり直す",
      "clean": "クリーンアップ",
      "select": "選択",
      "expand": "展開",
      "color": "色",
      "find": "検索",
      "remove": "削除",
      "align": "整列",
      "flow": "フロー"
    },
    "legend": {
      "categoryLegend": "カテゴリ凡例",
      "closeLegend": "凡例を閉じる"
    },
    "studio": {
      "loadingOntologies": "オントロジーを読み込み中…",
      "loadingPrevOntologies": "以前のオントロジーを読み込み中…",
      "loadingMoreOntologies": "追加のオントロジーを読み込み中…",
      "industryFilterLabel": "業界",
      "allIndustries": "すべての業界",
      "domainFilterLabel": "ドメイン",
      "allDomains": "すべてのドメイン",
      "subdomainFilterLabel": "サブドメイン",
      "allSubdomains": "すべてのサブドメイン",
      "failedToDeleteOntology": "オントロジーの削除に失敗しました",
      "ontologyImportedToast": "オントロジー「{{name}}」をインポートしました",
      "pageTitle": "オントロジースタジオ",
      "pageSubtitle": "データモデルからAIでOWL/TTLオントロジーを閲覧、インポート、作成できます。プロファイラーによって生成されたオントロジーは、Migration Studioでのプロファイリング完了後、自動的にここに表示されます。",
      "evaluateButton": "評価",
      "createOntologyButton": "オントロジーを作成",
      "ontologiesKpiLabel": "オントロジー",
      "yourOntologiesHeading": "あなたのオントロジー",
      "importTooltipBold": "インポート",
      "importTooltipRest": "してOWL/TTLファイルを新しいオントロジーとして登録します。プロファイラーワークフローで生成されたオントロジーはここに自動的に登録されます。",
      "filtersTitle": "フィルター",
      "searchPlaceholder": "オントロジーを検索…",
      "clearSearchAriaLabel": "検索をクリア",
      "noOntologiesMatch": "検索に一致するオントロジーがありません。OWL/TTLをインポートするか、データモデルからAIで作成してオントロジーを作成するか、Migration Studioでプロファイラーを実行してオントロジーを自動登録してください。",
      "ontologyActionsAriaLabel": "{{name}} のオントロジー操作",
      "renameMenuItem": "名前を変更",
      "industryTagsMenuItem": "業界タグ",
      "deleteMenuItem": "削除",
      "owlFileBadge": "OWLファイル",
      "versionsCount": "{{count}} 件のバージョン",
      "classesLabel": "クラス",
      "individualsLabel": "個体",
      "removeFromCatalogTitle": "カタログから削除",
      "removeFromCatalogMessage": "「{{name}}」をOntology Studioから削除しますか？このオントロジーは論理削除されます（カタログから削除されます）。OWLビューアーへの直接リンクは、再インポートするまで見つからない場合があります。",
      "couldNotExportOntology": "オントロジーをエクスポートできませんでした",
      "industryTagsUpdated": "業界タグを更新しました",
      "couldNotUpdateIndustryTags": "業界タグを更新できませんでした",
      "industryDialogTitle": "業界タグ",
      "industryDialogSubtitle": "{{name}} のカタログフィルターとバッジ。",
      "unspecifiedOption": "未指定",
      "industryFieldLabel": "業界",
      "saveButton": "保存",
      "savingButton": "保存中…",
      "closeAriaLabel": "閉じる",
      "renameDialogTitle": "OWLオントロジーの名前を変更",
      "renameDialogSubtitle": "カードやリストに表示される名前（最大 {{maxLength}} 文字）。",
      "nameFieldLabel": "名前",
      "nameRequiredError": "名前は必須です",
      "nameMustContainLetterError": "名前には少なくとも1つの文字または数字を含める必要があります",
      "renameFailedError": "名前の変更に失敗しました"
    },
    "justNow": "たった今",
    "hoursAgo": "{{hours}}時間前",
    "daysAgo": "{{days}}日前",
    "chooser": {
      "subtitle": "既存のOWL/TTLファイルをインポートするか、登録済みのデータモデルとコンピテンシー質問からAIで高密度なオントロジーを作成します。",
      "buildWithAiTitle": "AIでオントロジーを構築",
      "buildWithAiDesc": "データモデルを選び、コンピテンシー質問を確認し、OWLを生成します",
      "uploadTitle": "OWL/TTLをアップロード",
      "uploadDesc": "既存のオントロジーファイルをアップロード"
    },
    "import": {
      "title": "OWL/TTLオントロジーをインポート",
      "subtitle": "Turtle（.ttl）、OWL、RDF/XML、またはJSON-LDファイルをアップロードしてオントロジーを作成します。",
      "industryHint": "カタログカードに保存され、データモデルやKPIと合わせたフィルタリングに使用されます。",
      "nameLabel": "オントロジー名（任意）",
      "namePlaceholder": "ファイルから自動検出されたタイトルを上書き",
      "nameHint": "カタログカードに表示されます。空欄の場合はOWLファイルのタイトルを使用します。",
      "ontologyNameFieldLabel": "オントロジー名",
      "dropPrompt": "TTL/OWLファイルをここにドロップするか、クリックして参照",
      "filePreviewHeader": "ファイルプレビュー",
      "importingButton": "インポート中...",
      "importButton": "オントロジーをインポート",
      "importFailed": "インポートに失敗しました"
    },
    "builder": {
      "backToStudioAriaLabel": "オントロジースタジオに戻る",
      "pageTitle": "AIでオントロジーを構築",
      "pageSubtitle": "オントロジーに名前を付け、データモデルを選択し、コンピテンシー質問を確認したうえで、OWLを合成しカタログに登録します。更新しても安全です — セッションはいつでも再度開けます。",
      "loadFailed": "データモデルの読み込みに失敗しました",
      "resumeFailed": "オントロジーセッションを再開できませんでした",
      "sessionDiscarded": "セッションを破棄しました",
      "discardFailed": "セッションの破棄に失敗しました",
      "nameSpecialCharsError": "オントロジー名を特殊文字のみにすることはできません",
      "domainSpecialCharsError": "ドメインを特殊文字のみにすることはできません",
      "subdomainSpecialCharsError": "サブドメインを特殊文字のみにすることはできません",
      "enterNamePrompt": "続行するにはオントロジー名を入力してください",
      "enterDomainPrompt": "続行するにはドメインを入力してください",
      "selectDataModelPrompt": "続行するにはデータモデルを選択してください",
      "selectOntologyLlmPrompt": "続行するにはオントロジーLLMを選択してください",
      "startFailed": "オントロジービルダーの開始に失敗しました",
      "updateCqFailed": "コンピテンシー質問の更新に失敗しました",
      "sendMessageFailed": "メッセージの送信に失敗しました",
      "synthesisFailed": "合成に失敗しました",
      "registeredToast": "{{name}} を登録しました",
      "ontologyFallback": "オントロジー",
      "registrationFailed": "登録に失敗しました",
      "dataModelFilterLabel": "データモデル",
      "selectDataModelPlaceholder": "データモデルを選択…",
      "noDataModelsRegistered": "登録済みのデータモデルがありません",
      "modeFilterLabel": "モード",
      "modeGuided": "ガイド付き — 各コンピテンシー質問を確認",
      "modeExpress": "エクスプレス — より速い承認フロー",
      "ontologyLlmFilterLabel": "オントロジーLLM",
      "selectOntologyLlmPlaceholder": "オントロジーLLMを選択…",
      "noChatModelsRegistered": "登録済みのチャットモデルがありません",
      "enrichmentLlmFilterLabel": "拡充用LLM",
      "selectEnrichmentLlmPlaceholder": "拡充用LLMを選択（任意）…",
      "stepSourceTitle": "ソース",
      "stepSourceDesc": "オントロジーに名前を付け、概念を定義するデータモデルを選択します",
      "stepQuestionsTitle": "質問",
      "stepQuestionsDesc": "そのモデルに基づくコンピテンシー質問を承認・却下・調整します",
      "stepOntologyTitle": "オントロジー",
      "stepOntologyDesc": "OWLクラス、プロパティ、プロファイル検証済みの公理を合成します",
      "stepRegisterTitle": "登録",
      "stepRegisterDesc": "StudioとエージェントのためにオントロジーカタログにPublishします",
      "sourceFormSubtitle": "オントロジーに名前を付け、その概念の基盤となるデータモデルを選択してください。",
      "ontologyNameLabel": "オントロジー名",
      "ontologyNamePlaceholder": "例：特許ドメインオントロジー",
      "domainLabel": "ドメイン",
      "domainPlaceholder": "例：ヘルスケア、知的財産",
      "subdomainLabel": "サブドメイン",
      "subdomainPlaceholder": "例：クレーム、特許審査",
      "loadingModels": "モデルを読み込み中…",
      "loadingChatModels": "チャットモデルを読み込み中…",
      "enrichToggleTitle": "OWL合成前にメタデータを拡充する",
      "enrichToggleDesc": "クラスを生成する前に、LLMを使用して定義とラベルを拡張します。",
      "startBuildingButton": "構築を開始",
      "backToBuilderAriaLabel": "「AIでオントロジーを構築」に戻る",
      "ontologyBuilderFallback": "オントロジービルダー",
      "dataModelFallback": "データモデル",
      "chatEmptyLine1": "ここからオントロジーインタビューが始まります。",
      "chatEmptyLine2": "提案されたコンピテンシー質問を確認し、ビジネスが回答すべき内容を承認してください。",
      "roleYou": "あなた",
      "roleAssistant": "アシスタント",
      "workingStatus": "処理中…",
      "startingSessionStatus": "セッションを開始しています…",
      "synthesizingStatus": "合成中",
      "chatInputPlaceholder": "自由に発言してください — ビジネス上の質問を記述するか、「すべて承認」「次へ」「進める」など…",
      "expandSidePanel": "サイドパネルを展開",
      "collapseSidePanel": "サイドパネルを折りたたむ",
      "reflectionHeading": "振り返りと評価",
      "scoreFallback": "スコア {{score}}",
      "addMoreQuestionsButton": "オントロジーの質問をさらに追加",
      "registerLead": "オントロジーに名前を付けてカタログに公開します。下のドラフトグラフをプレビューしてから、登録前にプロファイルのリントを確認してください。",
      "graphReviewNudge": "ヒント：登録前に上のOntoGrafまたはNeo4jを開いて構造を確認してください。",
      "industryLabel": "業界",
      "registerToCatalogButton": "カタログに登録",
      "resumingSession": "オントロジーセッションを再開中…"
    },
    "viewer": {
      "loadSummaryFailed": "概要の読み込みに失敗しました",
      "generatingSummary": "オントロジーの概要を生成中…",
      "retry": "再試行",
      "regenerateSummaryTitle": "概要を再生成",
      "regenerateButton": "再生成",
      "classesLabel": "クラス",
      "objectPropsLabel": "オブジェクトプロパティ",
      "dataPropsLabel": "データプロパティ",
      "individualsLabel": "個体",
      "aboutThisOntology": "このオントロジーについて",
      "cachedSummary": "キャッシュされた概要",
      "overview": "概要",
      "noSummaryYet": "まだ概要がありません。「再生成」を使用して作成してください。",
      "propertiesLabel": "プロパティ",
      "moreCount": "他 {{count}} 件",
      "showLess": "表示を減らす",
      "tab": {
        "about": "オントロジーについて",
        "ontograf": "OntoGraf",
        "neo4j-graph": "ネットワークグラフ",
        "object-properties": "オブジェクトプロパティ",
        "data-properties": "データプロパティ",
        "annotation-properties": "注釈",
        "individuals": "個体",
        "compare": "比較"
      },
      "group": {
        "about": "概要",
        "explore": "探索",
        "compare": "比較"
      },
      "ontologyNotFound": "オントロジーが見つかりません",
      "couldNotLoadOntology": "オントロジーを読み込めませんでした",
      "backButton": "戻る",
      "noGraphData": "利用可能なグラフデータがありません",
      "compareNeedsTwoVersions": "バージョン比較にはこのファミリーに少なくとも2つのバージョンが必要です。",
      "backToOntologies": "オントロジー一覧",
      "builtWithAi": "AIで構築",
      "ontologyViewsAriaLabel": "オントロジービュー",
      "viewGroupsAriaLabel": "ビューグループ",
      "exploreViewsAriaLabel": "探索ビュー",
      "faqTitle": "FAQ",
      "configureFaqAriaLabel": "FAQを設定",
      "exportTurtleTitle": "Turtleとしてエクスポート",
      "classHierarchyAriaLabel": "クラス階層",
      "expandClassHierarchy": "クラス階層を展開",
      "showClassHierarchy": "クラス階層を表示",
      "collapseClassHierarchy": "クラス階層を折りたたむ",
      "collapseHierarchyPanel": "階層パネルを折りたたむ",
      "askOntologyTitle": "オントロジーに質問",
      "askOntologySubtitle": "クラス、プロパティ、関係を検索します。",
      "askOntologyGreeting": "このオントロジーのクラス、階層、関係について質問してください。",
      "loading": "読み込み中...",
      "name": "名前",
      "domain": "ドメイン",
      "range": "範囲",
      "characteristics": "特性",
      "kind": {
        "object": "オブジェクト",
        "data": "データ",
        "annotation": "注釈"
      },
      "noPropertiesForClass": "このクラスの{{kind}}プロパティはありません。",
      "noPropertiesFound": "{{kind}}プロパティが見つかりません。",
      "iriLabel": "IRI",
      "unspecified": "(未指定)",
      "annotationsLabel": "注釈",
      "typesLabel": "タイプ",
      "viewLabel": "表示",
      "groupedByClass": "クラスごとにグループ化",
      "flatList": "フラットリスト",
      "loadingIndividuals": "個体を読み込み中…",
      "noIndividualsForClass": "このクラスの個体はありません。",
      "noIndividualsFound": "個体が見つかりません。",
      "dataPropertiesLabel": "データプロパティ",
      "objectPropertiesLabel": "オブジェクトプロパティ"
    },
    "dataModels": {
      "cancel": "キャンセル",
      "close": "閉じる",
      "description": "説明",
      "industryVertical": "業界分野",
      "modelName": "モデル名",
      "nameInvalidChars": "モデル名には英数字、スペース、ハイフン、アンダースコアのみ使用できます",
      "nameNeedsAlphanumeric": "モデル名には英数字を含める必要があります",
      "nameRequired": "モデル名は必須です",
      "save": "保存",
      "saving": "保存中…",
      "selectIndustry": "業界を選択",
      "status": {
        "draft": "下書き",
        "published": "公開済み"
      },
      "createDialog": {
        "addColumn": "列を追加",
        "addEntity": "エンティティを追加",
        "back": "戻る",
        "columnNamePlaceholder": "列名",
        "columns": "列",
        "continue": "次へ",
        "createFailed": "データモデルを作成できませんでした",
        "createModel": "モデルを作成",
        "createdSummary": "{{name}} は {{count}} 件のエンティティを持つ下書きとして作成されました。",
        "createdSummaryWithColumns": "{{name}} は {{count}} 件のエンティティと {{columns}} 件の列を持つ下書きとして作成されました。",
        "createdTitle": "データモデルを作成しました",
        "creating": "作成中...",
        "descriptionPlaceholder": "このデータモデルの目的と範囲を記述してください...",
        "dimension": "ディメンション",
        "done": "完了",
        "duplicateEntityName": "同じエンティティ名は既に追加されています",
        "enterModelName": "モデル名を入力してください",
        "entityNameInvalidChars": "エンティティ名には英数字とアンダースコアのみ使用できます",
        "entityNameNeedsAlphanumeric": "エンティティ名には英数字を含める必要があります",
        "entityNamePlaceholder": "エンティティ名（例: Customer）",
        "fillOutField": "この項目を入力してください。",
        "foreignKey": "外部キー",
        "missingIndustry": "業界が未選択です",
        "missingModelName": "モデル名が未入力です",
        "modelNamePlaceholder": "例: 共通小売データモデル",
        "modelNameRequired": "モデル名 *",
        "modelSummary": "モデルの概要",
        "needMoreEntities": "関係を定義するには、エンティティを2つ以上追加してください。",
        "noColumnsYet": "まだ列がありません。作成時は任意です — 後でモデル詳細画面から追加できます。",
        "noEntitiesYet": "まだエンティティが追加されていません。上のフィールドに入力してテーブルを追加してください。",
        "nullable": "NULL許可",
        "primaryKey": "主キー",
        "removeColumn": "列を削除",
        "removeEntity": "{{name}} を削除",
        "selectIndustryVertical": "業界分野を選択してください",
        "step1Desc": "名前、業界、説明",
        "step1Label": "基本情報",
        "step2Desc": "テーブルと列を追加",
        "step2Intro": "エンティティ（テーブル）を追加し、それぞれの列を定義してください。",
        "step2Label": "エンティティの定義",
        "step3Desc": "外部キーとリンクを定義",
        "step3Intro": "エンティティ間の関係を定義してください。",
        "step3Label": "リレーションシップ",
        "step4Desc": "検証して公開",
        "step4Label": "確認して作成",
        "subtitle": "新しいエンタープライズデータモデルを定義",
        "summaryColumns": "列（命名済み）:",
        "summaryEntities": "エンティティ:",
        "summaryIndustry": "業界:",
        "summaryName": "名前:",
        "summaryRelationships": "リレーションシップ:",
        "title": "データモデルを作成",
        "typePlaceholder": "型"
      },
      "detail": {
        "add": "追加",
        "addColumnTitle": "列を追加",
        "back": "戻る",
        "backToDataModels": "データモデル一覧に戻る",
        "cardinality": "カーディナリティ",
        "chooseBothTables": "両方のテーブルを選択してください",
        "columnNameRequired": "列名は必須です",
        "couldNotAddRelationship": "リレーションシップを追加できませんでした",
        "couldNotApplyDdl": "DDLを適用できませんでした",
        "couldNotDeleteColumn": "列を削除できませんでした",
        "couldNotDeleteRelationship": "リレーションシップを削除できませんでした",
        "couldNotLoadDdl": "DDLエクスポートを読み込めませんでした",
        "couldNotSaveColumn": "列を保存できませんでした",
        "couldNotUpdateRelationship": "リレーションシップを更新できませんでした",
        "dataType": "データ型",
        "ddlCouldNotExportYet": "-- DDLをまだエクスポートできません。\n",
        "ddlUnavailableLargeModel": "-- 大規模モデルの場合、DDLエクスポートはエクスポートメニューから利用できます。\n",
        "ddlValidationPassed": "DDL検証に合格しました",
        "deleteColumnAria": "列 {{name}} を削除",
        "deleteColumnMessage": "この操作でデータモデルエンティティから列が削除されます。",
        "deleteColumnTitle": "列を削除",
        "deleteRelationshipAria": "リレーションシップを削除",
        "deleteRelationshipMessage": "この関係をモデルから削除します。",
        "deleteRelationshipTitle": "リレーションシップを削除",
        "diagramExported": "図をエクスポートしました",
        "drawioDownloaded": "Draw.io図をダウンロードしました",
        "drawioExportFailed": "Draw.ioのエクスポートに失敗しました",
        "editColumnAria": "列 {{name}} を編集",
        "editColumnTitle": "列を編集",
        "editRelationshipAria": "リレーションシップを編集",
        "editRelationshipTitle": "リレーションシップを編集",
        "exportFailed": "エクスポートに失敗しました",
        "fkColumnSource": "FK列（ソース）",
        "foreignKeys": "外部キー",
        "jsonSnapshotDownloaded": "JSONスナップショットをダウンロードしました",
        "modelNotFound": "モデルが見つかりません",
        "modelUpdatedFromDdl": "DDLからモデルを更新しました",
        "name": "名前",
        "noColumnsYet": "まだ列がありません。追加してこのエンティティを定義してください。",
        "noDirectRelationships": "直接的なリレーションシップはありません",
        "nothingToExport": "エクスポートする内容がありません",
        "nullableColumns": "NULL許可の列",
        "optional": "任意",
        "optionalCapitalized": "任意",
        "primaryKeys": "主キー",
        "recordCount": "レコード数",
        "relationshipAdded": "リレーションシップを追加しました",
        "snapshotExportFailed": "スナップショットのエクスポートに失敗しました",
        "svgExportFailed": "SVGエクスポートに失敗しました",
        "svgExported": "SVGをエクスポートしました",
        "tab": {
          "columns": "列",
          "relationships": "リレーションシップ",
          "stats": "統計"
        },
        "tooManyTablesForImage": "このモデルには{{count}}個のテーブルがあり、ブラウザで画像として描画するには大きすぎます。代わりに「Draw.ioとしてエクスポート」を使用してください。",
        "validation": "検証",
        "validationFailed": "検証に失敗しました",
        "viewMode": "表示",
        "modifyMode": "編集",
        "searchTablesPlaceholder": "テーブルと列を検索…",
        "filterErDiagramAriaLabel": "ER図をフィルター",
        "exportAsPng": "PNGとしてエクスポート",
        "exportAsSvg": "SVGとしてエクスポート",
        "exportJsonSnapshot": "JSONスナップショットをエクスポート",
        "exportAsDrawio": "Draw.ioとしてエクスポート",
        "relationshipButton": "リレーションシップ",
        "modelMetricsAriaLabel": "モデル指標",
        "entitiesLabel": "エンティティ",
        "entAbbrev": "ent",
        "relationshipsLabel": "リレーションシップ",
        "relAbbrev": "rel",
        "totalRecordsLabel": "総レコード数",
        "recAbbrev": "rec",
        "linkedKpisLabel": "リンクされたKPI",
        "kpiAbbrev": "KPI",
        "noEntitiesYet": "まだエンティティがありません",
        "noEntitiesDescription": "左側でDDLを適用するか、モデルをインポートしてこの図を作成してください。",
        "askDataModelTitle": "データモデルに質問",
        "askDataModelSubtitle": "エンティティ、列、リレーションシップを検索します。",
        "askDataModelGreeting": "このデータモデルのテーブル、列、リレーションシップ、統計について質問してください。",
        "addRelationshipTitle": "リレーションシップを追加",
        "addRelationshipSubtitle": "From → To ・ ソーステーブルの任意のFK列",
        "fromTable": "From テーブル",
        "toTable": "To テーブル",
        "selectEllipsis": "選択…",
        "fkColumnOnSource": "FK列（ソース側）",
        "optionalLowercase": "任意",
        "ddlRefreshTitle": "サーバーエクスポートからエディターを置き換え",
        "ddlRefresh": "更新",
        "ddlSwitchToModifyValidate": "検証するには編集モードに切り替えてください",
        "ddlValidate": "検証",
        "ddlSwitchToModifyApply": "適用するには編集モードに切り替えてください",
        "ddlApply": "適用"
      },
      "editDialog": {
        "invalidName": "無効なモデル名です",
        "saveChanges": "変更を保存",
        "subtitle": "名前、業界、説明を更新",
        "title": "データモデルを編集",
        "updateFailed": "データモデルを更新できませんでした",
        "updated": "データモデルを更新しました"
      },
      "importDialog": {
        "analyzing": "分析中...",
        "chooseFile": "ファイルを選択",
        "chooseFiles": "ファイルを選択",
        "close": "閉じる",
        "createFromSampleData": "サンプルデータから作成",
        "createdSummary": "「{{name}}」を作成しました: エンティティ{{entities}}件、列{{columns}}件、リレーションシップ{{relationships}}件。",
        "csvFilesLabel": "CSVファイル（テーブルごとに1つ、最大30個）",
        "downloadSampleHint": "期待されるレイアウトを確認するにはサンプルファイルをダウンロードしてください",
        "excelWorkbook": "Excelワークブック",
        "fileLabel": "ファイル: {{name}} ({{size}} KB)",
        "formatContent": "{{label}} の内容",
        "import": "インポート",
        "importAsDataModel": "データモデルとしてインポート",
        "importFailed": "インポートに失敗しました",
        "importFailedTitle": "インポート失敗",
        "importFormat": "インポート形式",
        "importSuccessful": "インポート成功",
        "importWithVisionModel": "ビジョンモデルでインポート",
        "importedSummary": "「{{name}}」をインポートしました: エンティティ{{entities}}件、列{{columns}}件、リレーションシップ{{relationships}}件。",
        "importing": "インポート中...",
        "inferredModelNamePlaceholder": "推論されたモデルの名前",
        "loadSample": "サンプルを読み込む",
        "mediaFileTypes": "ファイル（PNG, JPEG, GIF, WebP, PDF, TXT, MD）",
        "mediaHelp": "ER図のスクリーンショット、エクスポートされたPDF、または非構造化テキストをアップロードしてください。処理は{{brand}}プラットフォーム上のテナントモデルを使用します。大きなファイルは数分かかる場合があります。",
        "modelNameOptional": "モデル名（任意）",
        "noFormatsAvailable": "サーバーから利用可能なインポート形式がありません。",
        "noImportModelConfigured": "インポートモデルが設定されていません。",
        "noImportModelLlmHint": "このタブを使用する前に、テナント管理者に管理 → 一般設定 → エンタープライズオントロジーでLLMを選択するよう依頼してください。",
        "noImportModelVisionHint": "このタブを使用する前に、テナント管理者に管理 → 一般設定 → エンタープライズオントロジーでビジョン対応LLMを選択するよう依頼してください。",
        "overrideTitleNoName": "ファイルに明確な名前がない場合はタイトルを上書き",
        "overrideTitlePlaceholder": "自動検出されたタイトルを上書き",
        "placeholderCsv": "UTF-8のCSVを貼り付けるか、.csvをアップロードしてください。表形式（1行目=列名、任意の2行目=型）またはデータディクショナリ形式（テーブル名/列名/データ型/任意の主キー/参照先テーブル）のいずれかです。",
        "placeholderDbml": "DBML（テーブル定義とRef行）を貼り付けてください...",
        "placeholderDdl": "CREATE TABLE文をここに貼り付けてください...",
        "placeholderDrawio": "Draw.ioのXMLコンテンツを貼り付けてください...",
        "placeholderJson": "{{brand}}ポータブルJSONを貼り付けてください — データモデルのエクスポート → ポータブルJSON（エンティティ+リレーションシップ）と同じ形式です。",
        "placeholderJsonSchema": "定義を含むJSON Schemaを貼り付けてください...",
        "placeholderMermaid": "erDiagramブロックを貼り付けてください...",
        "placeholderPlantuml": "@startuml形式のエンティティ図を貼り付けてください...",
        "placeholderXlsx": "Excelインポートはファイルアップロードのみ対応しています。各シートは1つのテーブル（ヘッダー行=列名）、データディクショナリ形式（テーブル/列/型の行）、またはRelationshipsシート（From Table / To Table / Foreign Key Column）のいずれかです。",
        "sampleCsv": "サンプルCSV",
        "sampleHelp": "代表的なサンプルデータを含む1つ以上のCSVファイルをアップロードしてください。システムは列名と値を分析し、エンティティ、データ型、主キー/外部キー、テーブル間のリレーションシップを推論します。",
        "sampleXlsx": "サンプルXLSX",
        "subtitle": "構造化形式、画像・ドキュメント、またはサンプルCSVデータからの推論",
        "tabMedia": "画像・ドキュメント",
        "tabSample": "サンプルデータから",
        "tabStructured": "構造化形式",
        "title": "データモデルをインポート",
        "uploadFile": "ファイルをアップロード",
        "warningPrefix": "警告:",
        "xlsxHelp": "表示されている各シートは1つ以上のテーブルになります。表形式のシートは1行目を列名として使用し、データディクショナリシート（テーブル名+列名+データ型、任意の主キー/参照先テーブル/カーディナリティ）は各行を論理列として展開します。明示的なエッジにはRelationshipsシート（From Table, To Table, Foreign Key Column, 任意のCardinality）を使用するか、ディクショナリのFK行にReferenced Tableを指定してください。README、Templateなどの説明用シート名や_で始まる名前はスキップされます。残りのFKは、ワークブック内にターゲットが存在する場合、列名（例: store_sk → store）から推論されます。"
      },
      "industryTagDialog": {
        "subtitle": "{{name}} のカタログバッジとフィルター",
        "title": "業界タグ",
        "updateFailed": "業界タグを更新できませんでした",
        "updated": "業界タグを更新しました"
      },
      "list": {
        "actionClone": "複製",
        "actionDelete": "削除",
        "actionEdit": "編集",
        "actionIndustryTags": "業界タグ",
        "actionPublish": "公開",
        "allCreators": "すべての作成者",
        "allIndustries": "すべての業界",
        "clearSearch": "検索をクリア",
        "cloneFailed": "データモデルを複製できませんでした",
        "clonedAs": "「{{name}}」として複製しました",
        "createDataModel": "データモデルを作成",
        "creator": "作成者",
        "deleteDialogMessage": "この操作でデータモデルがカタログから削除されます。関連するKPI参照は更新が必要になる場合があります。",
        "deleteDialogTitle": "データモデルを削除",
        "deleteFailed": "データモデルを削除できませんでした",
        "deleted": "データモデルを削除しました",
        "emptyDescription": "データモデルを作成またはインポートして開始してください。",
        "emptyTitle": "データモデルはまだありません",
        "entities": "エンティティ",
        "exportFailed": "データモデルをエクスポートできませんでした",
        "filters": "フィルター",
        "import": "インポート",
        "industry": "業界",
        "kpis": "KPI",
        "loadFailed": "データモデルの読み込みに失敗しました",
        "loading": "データモデルを読み込み中…",
        "loadingMore": "データモデルをさらに読み込み中…",
        "loadingPrev": "以前のデータモデルを読み込み中…",
        "noMatchDescription": "別の検索語や業界フィルターを試すか、新しいモデルを作成してください。",
        "noMatchTitle": "一致するデータモデルがありません",
        "publishFailed": "公開できませんでした",
        "published": "データモデルを公開しました",
        "refresh": "更新",
        "refreshError": "カタログを更新できませんでした",
        "refreshList": "一覧を更新",
        "relationships": "リレーションシップ",
        "searchPlaceholder": "データモデルを検索…",
        "statEntities": "エンティティ",
        "statLinkedKpis": "関連KPI",
        "statModels": "モデル",
        "statPublished": "公開済み",
        "unableToLoad": "カタログを読み込めませんでした"
      },
      "erFlow": {
        "entityType": {
          "dimension": "ディメンション",
          "fact": "ファクト",
          "bridge": "ブリッジ",
          "aggregate": "集計"
        },
        "columnsCount": "{{count}} 列",
        "loadingEllipsis": "読み込み中…",
        "showMore": "もっと見る",
        "showLess": "少なく表示",
        "resetViewTitle": "表示とハイライトをリセット",
        "resetView": "表示をリセット",
        "hintReadOnly": "読み取り専用プレビュー · スクロールしてパン · ズームボタンを使用",
        "hintModify": "編集：列の右側のドット（FK側）から別のテーブルの列の左側のドットへドラッグ · ",
        "hintClickTable": "テーブルをクリックして詳細を表示 · ",
        "hintPanZoom": "スクロールしてパン · ズームボタンを使用 · ドラッグしてテーブルを移動"
      }
    },
    "optional": "オプション",
    "type": "タイプ",
    "kpiAllListView": "すべてのKPI",
    "kpiLibrary": {
      "all": "すべて",
      "allCollections": "すべてのコレクション",
      "allDataTypes": "すべてのデータ型",
      "allIndustries": "すべての業界",
      "andMoreErrors": "...他{{count}}件",
      "askAboutKpis": "KPIについて質問する",
      "backToFamilies": "ファミリーに戻る",
      "browseMode": "表示モード",
      "cardActions": "カードの操作",
      "chatGreeting": "KPI名、定義、ファミリー、データ型、データモデルへのリンクについて質問してください。",
      "chatSubtitleCollection": "このコレクション内の定義とファミリー。",
      "chatSubtitleFamily": "このファミリー内の定義。",
      "clearFiltersAndSearch": "フィルターと検索をクリア",
      "closeAria": "閉じる",
      "collection": "コレクション",
      "collectionCardMenu": "コレクションカードメニュー",
      "collectionsView": "コレクション表示",
      "couldNotLoadCatalog": "カタログを読み込めませんでした",
      "createCollection": "コレクションを作成",
      "createFamily": "ファミリーを作成",
      "createKpi": "KPIを作成",
      "dataType": "データ型",
      "delete": "削除",
      "dismiss": "閉じる",
      "editDetails": "詳細を編集",
      "editLinkedDataModel": "リンクされたデータモデルを編集",
      "enterpriseOntology": "エンタープライズオントロジー",
      "family": "ファミリー",
      "familiesCount": "{{count}}ファミリー",
      "filters": "フィルター",
      "importCompleteLabel": "インポート完了:",
      "importCreatedSkipped": "{{created}}件作成、{{skipped}}件スキップ",
      "importCsv": "CSVをインポート",
      "industry": "業界",
      "industryTags": "業界タグ",
      "internalIdNotePrefix": "内部ID",
      "internalIdNoteSuffix": "は変わりません。CSVインポートやリンクは壊れません。",
      "kpiType": "KPIタイプ",
      "kpisCount": "{{count}}件のKPI",
      "legacySuffix": "{{domain}}（旧）",
      "linkDataModel": "データモデルをリンク",
      "linkFamilyToModel": "このKPIファミリーを参照データモデルにリンクします",
      "linkedDataModel": "リンクされたデータモデル",
      "linkedDataModelTooltip": "リンクされたデータモデル: {{name}}",
      "linkedModelFallback": "リンクされたモデル",
      "loadingLibrary": "KPIライブラリを読み込んでいます...",
      "noCollectionsDesc": "コレクションを作成するか、CSVをインポートして開始してください。",
      "noCollectionsMatchTitle": "検索に一致するコレクションがありません",
      "noCollectionsTitle": "まだKPIコレクションがありません",
      "noDataFound": "データが見つかりません",
      "noFamiliesDesc": "ファミリーを作成するか、CSVをインポートして開始してください。",
      "noFamiliesMatchTitle": "検索に一致するファミリーがありません",
      "noFamiliesTitle": "このコレクションにはKPIファミリーがありません",
      "noKpisMatch": "フィルターに一致するKPIがありません。検索やフィルターを調整するか、定義をインポートしてください。",
      "noMatchDesc": "別の検索語を試すか、フィルターをクリアしてください。",
      "none": "なし",
      "precisionYes": "精度（あり）",
      "rename": "名前を変更",
      "rowActions": "行の操作",
      "save": "保存",
      "saving": "保存中…",
      "searchPlaceholder": "コレクション、ファミリー、KPI名、定義、説明を検索...",
      "selectCollection": "コレクションを選択...",
      "selectFamily": "ファミリーを選択...",
      "selectIndustry": "業界を選択…",
      "selectType": "タイプを選択...",
      "totalCollections": "コレクション合計",
      "viewDetails": "詳細を表示",
      "viewKpiDetails": "KPI詳細を表示",
      "columns": {
        "actions": "操作",
        "costPositive": "コスト＋",
        "dataType": "データ型",
        "definition": "定義",
        "description": "説明",
        "family": "ファミリー",
        "kpiName": "KPI名",
        "kpiType": "KPIタイプ",
        "precision": "精度"
      },
      "createCollectionDialog": {
        "descriptionAlnumError": "説明には有効なテキストを含める必要があり、特殊文字や絵文字だけで構成することはできません",
        "descriptionPlaceholder": "このKPIコレクションの簡単な説明",
        "displayNameAlnumError": "表示名には少なくとも1つの文字または数字を含める必要があります",
        "displayNameCharsError": "表示名には文字、数字、スペース、ハイフン、アンダースコアのみ使用できます",
        "displayNamePlaceholder": "例: 小売KPI",
        "displayNameRequired": "表示名 *",
        "nameAlnumError": "名前には少なくとも1つの文字または数字を含める必要があります",
        "nameCharsError": "名前には文字、数字、アンダースコアのみ使用できます",
        "namePlaceholder": "例: retail_kpis",
        "nameRequired": "名前 *",
        "title": "新しいコレクションを作成"
      },
      "createFamilyDialog": {
        "collectionRequired": "KPIコレクション *",
        "displayNamePlaceholder": "顧客レベルKPI",
        "displayNameRequired": "表示名 *",
        "namePlaceholder": "例: COSMOS_CUSTOMER_LEVEL_KPIS",
        "nameRequired": "名前 *",
        "title": "新しいKPIファミリーを作成"
      },
      "createKpiDialog": {
        "collectionRequired": "コレクション *",
        "costPositiveCheckbox": "コスト＋（はい/いいえ）",
        "create": "KPIを作成",
        "dataTypePlaceholder": "string",
        "definitionPlaceholder": "技術的な定義または計算に関する注記",
        "descriptionPlaceholder": "簡単な要約",
        "familyRequired": "ファミリー *",
        "kpiNamePlaceholder": "例: CUSTOMER_ATC_RATE",
        "kpiNameRequired": "KPI名 *",
        "precisionCheckbox": "精度（はい/いいえ）",
        "title": "新しいKPIを作成"
      },
      "collectionIndustryDialog": {
        "subtitle": "「{{name}}」とKPIカタログでの表示方法に適用されます。",
        "title": "コレクションの業界タグ"
      },
      "deleteCollectionDialog": {
        "message": "これにより、コレクションおよびその中のすべてのKPIファミリーとKPI定義が削除されます。このコレクションを参照していた移行プロジェクトのKPIコレクションターゲットは自動的にクリアされます。",
        "title": "KPIコレクションを削除"
      },
      "deleteFamilyDialog": {
        "message": "「{{name}}」を削除してもよろしいですか？このファミリー内のすべてのKPIも削除され、元に戻せません。",
        "title": "ファミリーを削除"
      },
      "deleteKpiDialog": {
        "message": "「{{name}}」を削除してもよろしいですか？元に戻せません。",
        "title": "KPIを削除"
      },
      "detailPopup": {
        "closeAria": "閉じる",
        "costPositive": "コスト＋",
        "dataType": "データ型",
        "definition": "定義",
        "description": "説明",
        "linkedModel": "リンクされたモデル",
        "no": "いいえ",
        "precision": "精度",
        "tags": "タグ",
        "yes": "はい"
      },
      "domainDialog": {
        "missingIndustry": "業界が未選択です",
        "updateFailed": "業界タグを更新できませんでした"
      },
      "editFamilyDialog": {
        "descriptionPlaceholder": "このKPIファミリーが対象とする内容を記述してください…",
        "title": "KPIファミリーを編集",
        "titleLabel": "タイトル",
        "titlePlaceholder": "例: 売上KPI",
        "updateFailed": "ファミリーを更新できませんでした"
      },
      "errors": {
        "createCollectionFailed": "コレクションの作成に失敗しました",
        "createFamilyFailed": "ファミリーの作成に失敗しました",
        "createKpiFailed": "KPIの作成に失敗しました",
        "csvImportFailed": "CSVのインポートに失敗しました",
        "deleteCollectionFailed": "KPIコレクションを削除できませんでした",
        "deleteFamilyFailed": "ファミリーの削除に失敗しました",
        "deleteKpiFailed": "KPIの削除に失敗しました",
        "exportFailed": "KPIをエクスポートできませんでした",
        "loadFailed": "KPIライブラリを読み込めませんでした。"
      },
      "familyIndustryDialog": {
        "subtitle": "「{{name}}」に適用されます。",
        "title": "KPIファミリーの業界タグ"
      },
      "importDialog": {
        "appliedToFamiliesNote": "このインポートで作成または変更されたKPIファミリーに適用されます。",
        "chooseCsvFile": "CSVファイルを選択",
        "close": "閉じる",
        "dataTypeHelp": "— 例：string、decimalなど。省略された値は名前と定義から推測されます。",
        "definitionHelp": "— 技術的な定義;",
        "descriptionHelp": "— 簡単な要約。",
        "domainHelp": "— 行単位のオプションのドメイン（デフォルトはインポートドメイン）。",
        "familyCreatedNote": "インポート中に作成されたファミリーはこのコレクションに配置されます。空の場合は「Default」がデフォルトになります。",
        "familyDisplayHelp": "— ファミリーの作成または更新時にUIに表示されます。",
        "familyKpiHelp": "— ファミリーグループとKPIシンボルの安定した識別子。",
        "industryOptional": "業界（任意）",
        "kpiCollection": "KPIコレクション",
        "kpiTypeDefault": "（デフォルト: 必須）。",
        "linkDataModelOptional": "データモデルをリンク（任意）",
        "or": "または",
        "or2": "（または",
        "overridesDomainNote": "個々のCSV行のドメイン列を上書きします。",
        "precisionCostHelp": "）— はい/いいえ。省略した場合、両方ともデフォルトで「はい」になります。",
        "requiredColumns": "必須列:",
        "title": "CSVからKPIをインポート"
      },
      "linkDialog": {
        "noneHint": "「なし」を選択すると、このファミリーをERモデルから切り離します。エージェントスタジオとブループリントはこのリンクを使用してKPIをエンティティと整合させます。",
        "referenceDataModel": "参照データモデル",
        "subtitle": "「{{name}}」の参照データモデルを選択してください。",
        "title": "KPIファミリーをデータモデルにリンク",
        "updateFailed": "データモデルのリンクを更新できませんでした"
      },
      "renameCollectionDialog": {
        "displayName": "表示名",
        "placeholder": "例: 小売KPI",
        "renameFailed": "コレクションの名前を変更できませんでした",
        "title": "コレクション名を変更"
      },
      "toasts": {
        "collectionDeleted": "KPIコレクションを削除しました",
        "collectionRenamed": "コレクション名を変更しました",
        "dataModelLinkRemoved": "データモデルのリンクを削除しました",
        "dataModelLinked": "データモデルをリンクしました",
        "familyUpdated": "ファミリーを更新しました",
        "industryTagsUpdated": "業界タグを更新しました"
      },
      "createCollectionButton": "コレクションを作成",
      "importCsvButton": "CSVをインポート"
    },
    "dataStudio": {
      "list": {
        "newPipeline": "新規パイプライン",
        "typeLabel": "タイプ",
        "statusLabel": "ステータス",
        "allTypes": "すべてのタイプ",
        "allStatus": "すべてのステータス",
        "columnPipeline": "パイプライン",
        "columnType": "タイプ",
        "columnStatus": "ステータス",
        "columnRoute": "ソース → ターゲット",
        "columnSchedule": "スケジュール",
        "columnUpdated": "更新日時",
        "columnActions": "操作",
        "actionOpen": "開く",
        "actionDelete": "削除",
        "deleteDialogTitle": "パイプラインを削除",
        "deleteDialogMessage": "このパイプラインは Data Studio から削除されます。この操作は元に戻せません。",
        "deleted": "パイプライン「{{name}}」を削除しました",
        "deleteFailed": "パイプラインを削除できませんでした",
        "migrationLinkTitle": "移行元：{{id}}",
        "migrationLinkText": "移行",
        "statsPipelines": "パイプライン",
        "emptyNoPipelines": "Data Studio にはまだ何もありません。パイプラインは通常、完了した移行プロジェクトから昇格されるか、上の「新規パイプライン」から作成されます。",
        "emptyNoMatches": "フィルターに一致する項目がありません。検索またはフィルター条件を調整してください。",
        "filtersTitle": "フィルター",
        "searchPlaceholder": "カタログを検索...",
        "loadErrorTitle": "Data Studio カタログの読み込みに失敗しました",
        "retry": "再試行"
      },
      "status": {
        "pending": "保留中",
        "terminating": "終了中"
      },
      "createDialog": {
        "title": "パイプラインを作成",
        "subtitleChoose": "開始するにはパイプラインタイプを選択してください",
        "subtitleMode": "{{mode}} パイプライン",
        "steps": {
          "type": {
            "label": "パイプラインタイプ",
            "description": "パイプラインモードを選択"
          },
          "sourceTarget": {
            "label": "ソースとターゲット",
            "description": "エンドポイントを選択"
          },
          "configuration": {
            "label": "設定",
            "description": "スケジュールとオプション"
          },
          "review": {
            "label": "確認",
            "description": "確認して作成"
          }
        },
        "modes": {
          "migrate": {
            "label": "移行",
            "description": "AIを活用した移行 — Migrations Studioを開く"
          },
          "orchestrator": {
            "label": "オーケストレーターワークフロー",
            "description": "ビジュアルDAGデザイナー — Databricks、Vertex AI、Airflowへデプロイ"
          },
          "map": {
            "label": "マップ",
            "description": "ソースとターゲットのスキーマ間のフィールドレベルマッピング"
          },
          "transform": {
            "label": "変換",
            "description": "転送中にSQLまたはPythonの変換を適用"
          },
          "custom": {
            "label": "カスタム",
            "description": "コードエディタで完全に設定可能なパイプライン"
          }
        },
        "createdTitle": "パイプラインを作成しました",
        "createdDesc": "{{name}}（{{mode}}）を下書きとして保存しました。",
        "pipelineNameLabel": "パイプライン名",
        "pipelineNamePlaceholder": "例：{{source}} → {{target}} {{mode}}",
        "sourceSystemLabel": "ソースシステム",
        "sourceSystemPlaceholder": "例：Postgres prod, Snowflake DWH",
        "targetDestinationLabel": "ターゲット宛先",
        "targetDestinationPlaceholder": "例：BigQuery curated, S3 lake",
        "modeSuffix": "{{mode}} モード",
        "change": "変更",
        "scheduleLabel": "スケジュール",
        "scheduleSelectPlaceholder": "スケジュールを選択",
        "batchSizeLabel": "バッチサイズ",
        "retryOnFailureLabel": "失敗時に再試行",
        "retryEnabled": "有効（3回再試行）",
        "retryDisabled": "無効",
        "transformationSqlLabel": "変換SQL",
        "customPipelineCodeLabel": "カスタムパイプラインコード",
        "transformSqlPlaceholder": "SELECT\n  customer_id,\n  SUM(amount) as total_spend,\n  COUNT(*) as txn_count\nFROM source_table\nGROUP BY customer_id",
        "customCodePlaceholder": "# カスタムパイプラインロジック\n import pandas as pd\n\ndef transform(df):\n    return df",
        "summaryTitle": "パイプラインの概要",
        "summaryName": "名前：",
        "summaryType": "タイプ：",
        "summarySchedule": "スケジュール：",
        "summaryBatchSize": "バッチサイズ：",
        "summaryRetry": "再試行：",
        "retryAttempts": "3回の試行",
        "back": "戻る",
        "done": "完了",
        "continue": "続行",
        "creating": "作成中…",
        "createPipeline": "パイプラインを作成"
      },
      "detail": {
        "configured": "設定済み",
        "error": "エラー",
        "start": "開始",
        "end": "終了",
        "sourceNodeType": "ソース",
        "targetNodeType": "ターゲット",
        "extractNodeLabel": "抽出と検証",
        "parserNodeType": "パーサー",
        "notFoundTitle": "パイプラインが見つかりません",
        "backToPipelines": "パイプライン一覧に戻る",
        "typeLabel": "タイプ",
        "batchSizeLabel": "バッチサイズ",
        "retryOnFailureLabel": "失敗時の再試行",
        "updatedLabel": "更新日時",
        "yes": "はい",
        "no": "いいえ",
        "transformationSqlLabel": "変換SQL",
        "customCodeLabel": "カスタムコード"
      }
    }
  },
  "pipelineDesigner": {
    "list": {
      "searchPlaceholder": "デザインを検索...",
      "emptyMessage": "オーケストレーターワークフローはまだありません",
      "newWorkflow": "新規オーケストレーターワークフロー",
      "columnName": "名前",
      "columnDescription": "説明",
      "columnStatus": "ステータス",
      "columnUpdatedAt": "更新日時",
      "columnCreatedAt": "作成日時",
      "columnActions": "操作",
      "actionEdit": "編集",
      "actionDelete": "削除",
      "createFailed": "デザインの作成に失敗しました",
      "deleteFailed": "デザインの削除に失敗しました",
      "deletedToast": "デザイン「{{name}}」を削除しました",
      "filterStatusLabel": "ステータス",
      "deleteDialogTitle": "デザインを削除",
      "deleteDialogMessage": "「{{name}}」を削除してもよろしいですか?この操作は元に戻せません。",
      "deleteDialogConfirm": "デザインを削除",
      "cancel": "キャンセル"
    },
    "status": {
      "draft": "下書き",
      "published": "公開済み",
      "pending": "保留中",
      "running": "実行中",
      "success": "成功",
      "failed": "失敗",
      "cancelled": "キャンセル済み",
      "terminating": "終了中",
      "timed_out": "タイムアウト",
      "unknown": "不明"
    },
    "canvas": {
      "loading": "デザインを読み込み中...",
      "tabCanvas": "キャンバス",
      "tabRuns": "実行",
      "tabSettings": "設定",
      "publishButton": "公開して実行",
      "publishDisabledTitle": "公開するには「設定」タブでオーケストレーター接続を選択してください。",
      "settingsTitle": "デザイン設定",
      "orchestratorRuntimeTitle": "オーケストレーターランタイム",
      "orchestratorRuntimeDesc": "公開にはターゲットタイプに一致するテナントのオーケストレーター接続が必要です。認証情報はコネクタから解決され、グラフには保存されません。",
      "targetOrchestratorLabel": "ターゲットオーケストレーター",
      "saveFailed": "デザインの保存に失敗しました",
      "validationFailed": "デザインの検証に失敗しました",
      "publishFailed": "公開に失敗しました"
    },
    "createDialog": {
      "title": "新規オーケストレーターワークフロー",
      "closeAria": "ダイアログを閉じる",
      "nameLabel": "デザイン名",
      "namePlaceholder": "例: nightly-feature-batch",
      "descriptionLabel": "説明(任意)",
      "descriptionPlaceholder": "カタログ用の簡単な概要",
      "orchestratorLabel": "ターゲットオーケストレーター",
      "orchestratorHint": "公開して実行は現在、Databricks Workflows 用の Enterprise Ontology パブリッシャーを使用します。Vertex AI と Airflow は計画中です。",
      "cancel": "キャンセル",
      "create": "作成",
      "creating": "作成中…"
    },
    "publishDialog": {
      "title": "公開して実行",
      "selectConnectionWarning": "公開する前に「設定」タブで<1>オーケストレーター接続</1>を選択してください。実行レイヤーはそのコネクタから認証情報を解決します。",
      "translateJobText": "これにより <1>{{designName}}</1> は <2>{{orchestratorType}}</2> ジョブに変換され、作成後すぐに実行がトリガーされます。",
      "notebookParamsLabel": "ノートブックパラメータ(任意の JSON)",
      "cancel": "キャンセル",
      "publish": "公開して実行",
      "publishing": "公開中...",
      "orchestratorFallback": "オーケストレーター"
    },
    "nodeConfig": {
      "nodeTitle": "{{type}} ノード",
      "noConfigurableProps": "このノードには設定可能なプロパティがありません。",
      "taskConfigTitle": "タスク設定",
      "labelLabel": "ラベル",
      "labelPlaceholder": "タスク名",
      "notebookPathLabel": "ノートブックパス",
      "notebookPathPlaceholder": "/notebooks/my_notebook.py",
      "notebookPathHint": "Git リポジトリのルートからの相対パス。",
      "timeoutLabel": "タイムアウト(秒)",
      "maxRetriesLabel": "最大リトライ回数",
      "retryOnTimeoutLabel": "タイムアウト時に再試行"
    },
    "canvasEditor": {
      "addTask": "タスクを追加",
      "saveNow": "今すぐ保存",
      "allChangesSaved": "すべての変更が保存されました",
      "saving": "保存中…",
      "saveFailedUseSaveNow": "保存に失敗しました — 「今すぐ保存」を使用してください",
      "unsavedWillAutoSave": "未保存 — 自動的に保存されます",
      "delete": "削除",
      "newTaskLabel": "新規タスク"
    },
    "gitSource": {
      "title": "Git ソース",
      "repoUrlLabel": "リポジトリ URL",
      "repoUrlPlaceholder": "https://github.com/org/repo",
      "providerLabel": "プロバイダー",
      "branchLabel": "ブランチ",
      "branchPlaceholder": "main",
      "branchError": "有効なブランチ名を入力してください(英数字、/、-、_、. のみ)。"
    },
    "runs": {
      "noRuns": "実行はまだありません。デザインを公開して実行を作成してください。",
      "colStatus": "ステータス",
      "colRunId": "実行 ID",
      "colStarted": "開始",
      "colDuration": "所要時間",
      "colExternal": "外部",
      "colActions": "操作",
      "runningLabel": "実行中...",
      "view": "表示",
      "cancel": "キャンセル"
    },
    "runDetail": {
      "loading": "実行詳細を読み込み中...",
      "title": "実行詳細",
      "runId": "実行 ID",
      "externalRunId": "外部実行 ID",
      "started": "開始",
      "completed": "完了",
      "viewInOrchestrator": "オーケストレーターで表示",
      "cancelling": "キャンセル中...",
      "cancelRun": "実行をキャンセル",
      "taskStates": "タスクの状態"
    },
    "orchestratorConnection": {
      "label": "オーケストレーター接続",
      "loadingConnections": "接続を読み込み中…",
      "optionalSelectToEnable": "任意 — 選択すると公開して実行を有効化します",
      "noConnections": "このオーケストレータータイプの接続はありません。",
      "addOneLink": "接続 → オーケストレーターで追加してください"
    },
    "nodes": {
      "start": "開始",
      "end": "終了",
      "untitledTask": "無題のタスク"
    }
  },
  "agentStudio": {
    "loading": "エージェントスタジオを読み込み中...",
    "permissionDeniedMessage": "このページを表示する権限がありません。管理者にお問い合わせください。",
    "untitledAgent": "無題のエージェント",
    "fallbackAgentName": "エージェント",
    "ok": "OK",
    "closeDialogAriaLabel": "ダイアログを閉じる",
    "list": {
      "columnAgentName": "エージェント名",
      "columnProject": "プロジェクト",
      "columnVersion": "バージョン",
      "columnStatus": "ステータス",
      "columnCreator": "作成者",
      "columnCreatedAt": "作成日時",
      "columnUpdatedAt": "更新日時",
      "columnActions": "操作",
      "registeredToRegistryTitle": "レジストリに登録済み",
      "emptyFavorites": "お気に入りのエージェントはまだありません — 一覧でスターを付けてブックマークしてください",
      "emptyArchived": "アーカイブされたエージェントはありません",
      "emptyDefault": "エージェントが見つかりません",
      "filterFavoritesTitle": "お気に入りで絞り込み",
      "allAgents": "すべてのエージェント",
      "favorites": "お気に入り",
      "catalogTitle": "エージェントカタログ",
      "activeAgentsTitle": "アクティブなエージェント",
      "archivedAgentsTitle": "アーカイブ済みエージェント",
      "guidedTourTitle": "エージェントスタジオのガイドツアー",
      "autoTune": "Auto Tune",
      "createAgent": "エージェントを作成",
      "exportSelected": "選択項目をエクスポート",
      "archiveSelected": "選択項目をアーカイブ",
      "exportFileName": "Agent_Studio",
      "exportFileNameArchived": "Agent_Studio_Archived"
    },
    "filters": {
      "status": "ステータス",
      "registryStatus": "レジストリステータス",
      "draft": "下書き",
      "published": "公開済み",
      "registered": "登録済み",
      "unregistered": "未登録",
      "project": "プロジェクト",
      "creator": "作成者"
    },
    "actions": {
      "restoreToDraft": "下書きに復元",
      "view": "表示",
      "chat": "チャット",
      "traces": "トレース",
      "logs": "ログ",
      "exportYaml": "エクスポート (YAML)",
      "exportJson": "エクスポート (JSON)",
      "evaluate": "評価",
      "viewEvaluationRuns": "評価実行を表示",
      "registerToRegistry": "レジストリに登録",
      "registrationPending": "登録保留中",
      "unregisterFromRegistry": "レジストリから登録解除",
      "clone": "複製",
      "archive": "アーカイブ"
    },
    "backLabels": {
      "traces": "トレース",
      "blueprint": "ブループリント"
    },
    "publishDialog": {
      "title": "エージェントを公開",
      "confirmHeading": "公開してもよろしいですか？",
      "confirmDescription": "公開するとこのエージェントが利用可能になります。エージェントをアーカイブすることで元に戻せます。",
      "agentLabel": "エージェント:",
      "frameworkLabel": "フレームワーク:",
      "nodesLabel": "ノード:",
      "publishButton": "エージェントを公開"
    },
    "archiveDialog": {
      "title": "エージェントをアーカイブ",
      "publishedHeading": "このエージェントは公開済みです",
      "publishedDescription": "アーカイブするには、まずエージェントストアの掲載を終了し、モニタリングでデプロイをアーカイブし、まだ登録されている場合はエージェントレジストリから登録解除してください。これらが完了するとアーカイブ一覧に移動します。",
      "confirmMessage": "「{{name}}」をアーカイブしてもよろしいですか？",
      "checkingDependencies": "依存関係を確認中…",
      "archiveButton": "エージェントをアーカイブ",
      "draftConfirmMessage": "「{{name}}」をアーカイブしますか？アーカイブ一覧に表示され、下書きに復元するか完全に削除できます。"
    },
    "deleteDialog": {
      "title": "エージェントを削除",
      "confirmMessage": "「{{name}}」を完全に削除しますか？システムから削除され、元に戻せません。"
    },
    "bulkArchive": {
      "title_one": "エージェントをアーカイブ",
      "title_other": "エージェントをアーカイブ",
      "confirmMessage": "{{count}} 件のエージェントをアーカイブしますか？アーカイブ一覧に表示され、下書きに復元するか完全に削除できます。",
      "confirmButton": "アーカイブ",
      "failureMessage": "エージェントのアーカイブに失敗しました",
      "blockedMessage": "「{{name}}」にはアーカイブ前に解消が必要な依存関係があります。"
    },
    "blockedDialogs": {
      "cannotArchiveTitle": "まだエージェントをアーカイブできません",
      "cannotUnregisterTitle": "まだレジストリから削除できません",
      "unregisterDependenciesMessage": "エージェントストアの掲載を削除し、デプロイをアーカイブしてから、このエージェントをエージェントレジストリから削除してください。",
      "dependenciesMustBeCleared": "先に依存関係を解消する必要があります。"
    },
    "registerDialog": {
      "title": "レジストリに登録",
      "submitHeading": "管理者承認のために送信",
      "submitDescription": "テナント管理者に登録リクエストを送信します。一般設定 → リクエスト承認で管理者が承認するまで、エージェントレジストリに表示されません。",
      "confirmMessage": "「{{name}}」の登録リクエストを送信しますか？",
      "metadata": "メタデータ",
      "submitting": "送信中...",
      "submitRequest": "リクエストを送信"
    },
    "deletePrerequisites": {
      "stillRegistered": "このエージェントはまだエージェントレジストリに登録されています。",
      "activeStoreListing": "このエージェントには有効なエージェントストア掲載があります。",
      "nonArchivedDeployments": "まだアーカイブされていないエージェントデプロイがあります。",
      "clearBeforeArchive": "{{details}} アーカイブする前にこれらを解消してください。"
    },
    "blockerMessages": {
      "registry": "アーカイブする前に、このエージェントをエージェントレジストリから登録解除してください。",
      "agent_store": "アーカイブする前に、このエージェントの有効なエージェントストア掲載を終了してください。",
      "agent_deployments": "アーカイブする前に、モニタリングでこのエージェントのすべてのデプロイをアーカイブしてください。",
      "agent_store_unregister": "エージェントレジストリから削除する前に、有効なエージェントストア掲載を終了してください。",
      "agent_deployments_unregister": "エージェントレジストリから削除する前に、モニタリングですべてのデプロイをアーカイブしてください。"
    },
    "blockerNav": {
      "registry": "エージェントレジストリを開く",
      "workflow_registry": "ワークフローレジストリを開く",
      "agent_store": "エージェントストアを開く（管理）",
      "agent_deployments": "モニタリングを開く — デプロイ",
      "workflow_store": "ワークフローストアを開く（管理）",
      "workflow_deployments": "モニタリングを開く — デプロイ",
      "running_executions": "実行を開く"
    }
  },
  "projects": {
    "status": {
      "active": "アクティブ",
      "draft": "下書き",
      "archived": "アーカイブ済み",
      "error": "エラー",
      "pending": "保留中"
    },
    "list": {
      "permissionDeniedMessage": "プロジェクトを表示する権限がありません。管理者にお問い合わせください。",
      "loading": "プロジェクトを読み込んでいます...",
      "columnName": "プロジェクト名",
      "columnMembers": "メンバー",
      "columnStatus": "ステータス",
      "columnActions": "アクション",
      "filterCreatorLabel": "作成者",
      "actionOpen": "開く",
      "actionConfigure": "設定",
      "actionEdit": "編集",
      "actionDelete": "削除",
      "bulkDeleteSelected": "選択項目を削除",
      "emptyMessage": "プロジェクトが見つかりません",
      "createProject": "プロジェクトを作成",
      "setupWizard": "セットアップウィザード",
      "setupWizardTooltip": "セットアップウィザード - YAMLファイルをインポートしてプロジェクトを作成",
      "deleteDialogTitle": "プロジェクトを削除",
      "deleteDialogMessage": "「{{name}}」を削除してもよろしいですか？この操作は元に戻せません。",
      "fetchingDependenciesMessage": "プロジェクトの依存関係を取得しています…",
      "forceDeleteDialogTitle": "強制削除の確認",
      "forceDeleteDialogMessage": "強制削除を行うと、「{{name}}」およびすべてのエージェント、デプロイメント、エージェントストアの掲載、シミュレーション、プロンプト、スキル、ツール、その他のプロジェクトデータが完全に削除されます。この操作は元に戻せません。",
      "forceDeleteConfirmLabel": "プロジェクトを強制削除",
      "bulkDeleteDialogTitle": "選択したプロジェクトを削除",
      "bulkDeleteConfirmMessage_other": "{{count}}件のプロジェクトを削除してもよろしいですか？この操作は元に戻せません。",
      "bulkDeleteConfirmLabel_other": "{{count}}件のプロジェクトを削除",
      "forceDeleteSuccessToast": "プロジェクト「{{name}}」を強制削除しました",
      "forceDeleteErrorToast": "強制削除に失敗しました。残っている依存関係を削除するか、もう一度お試しください。",
      "noProjectsSelectedWarning": "プロジェクトが選択されていません",
      "bulkDeletePartialWarning": "{{deleted}}件のプロジェクトを削除しました。{{skipped}}件失敗: {{errors}}",
      "bulkDeleteSuccessToast": "{{deleted}}件のプロジェクトを削除しました",
      "bulkDeleteErrorToast": "プロジェクトの削除に失敗しました",
      "andOthers": "他{{count}}件"
    },
    "createDialog": {
      "title": "新規プロジェクトを作成",
      "closeAriaLabel": "ダイアログを閉じる",
      "loadingQuota": "クォータを読み込んでいます...",
      "quotaLabel": "プロジェクト",
      "nameLabel": "プロジェクト名 *",
      "namePlaceholder": "プロジェクト名を入力",
      "descriptionLabel": "説明",
      "descriptionPlaceholder": "プロジェクトの簡単な説明",
      "descriptionEmojiError": "説明に絵文字を含めることはできません。プレーンテキストのみを使用してください。",
      "quotaExceededTitle": "プロジェクトのクォータを超過しています",
      "creating": "作成中..."
    },
    "editDialog": {
      "title": "プロジェクトを編集",
      "closeAriaLabel": "ダイアログを閉じる",
      "nameLabel": "プロジェクト名 *",
      "descriptionLabel": "説明",
      "saving": "保存中...",
      "saveChanges": "変更を保存"
    },
    "actions": {
      "view": "表示",
      "edit": "編集",
      "chat": "チャット",
      "traces": "トレース",
      "logs": "ログ",
      "evaluate": "評価",
      "viewEvaluationRuns": "評価実行を表示",
      "cloneInAgentStudio": "エージェントスタジオで複製",
      "openInAgentStudio": "エージェントスタジオで開く",
      "manageArchiveInStudio": "Studioでアーカイブを管理",
      "open": "開く",
      "runs": "実行",
      "editCanvas": "キャンバスを編集",
      "viewInStudio": "Studioで表示",
      "testChat": "テスト / チャット",
      "deployInRegistry": "Registryでデプロイ",
      "guardrails": "ガードレール",
      "chatDetail": "チャット / 詳細",
      "runtimeSettings": "ランタイム設定",
      "openInMonitoring": "Monitoringで開く"
    },
    "detail": {
      "notFound": "プロジェクトが見つかりません",
      "backToProjectsButton": "プロジェクトに戻る",
      "backToProjectsAriaLabel": "プロジェクトに戻る",
      "viewOnlyBadge": "閲覧のみ",
      "tabsAriaLabel": "プロジェクト詳細タブ",
      "tabs": {
        "overview": "概要",
        "agents": "エージェント",
        "workflows": "ワークフロー",
        "registry": "レジストリ",
        "evals": "評価",
        "deployments": "デプロイ"
      }
    },
    "overview": {
      "hubSubtitle": "プロジェクトハブ",
      "noTabsAvailable": "あなたの役割で利用できる詳細タブはありません。",
      "openInBrand": "{{brand}} で {{label}} を開く",
      "cards": {
        "agents": "エージェント",
        "workflows": "ワークフロー",
        "registry": "登録済み",
        "evals": "評価エージェント",
        "deployments": "アクティブなデプロイ"
      }
    },
    "members": {
      "title": "メンバー",
      "refreshTooltip": "メンバーリストを更新",
      "addMemberButton": "メンバーを追加",
      "selectedCount": "{{count}} 件選択中",
      "changeRoleButton": "ロールを変更",
      "remove": "削除",
      "clearButton": "クリア",
      "selectAllButton": "すべて選択",
      "noMembersYet": "メンバーはまだいません",
      "selectAll": "すべて選択",
      "deselectAll": "すべて選択解除",
      "unknown": "不明",
      "creatorBadge": "作成者",
      "role": {
        "member": "メンバー",
        "admin": "管理者",
        "viewer": "閲覧者",
        "creator": "作成者"
      },
      "memberSince": "{{date}} からのメンバー",
      "changeRoleTitle": "ロールを変更",
      "memberFallbackName": "メンバー",
      "select": "選択",
      "deselect": "選択解除",
      "removeMembersTitle": "メンバーを削除",
      "removeMemberTitle": "メンバーを削除",
      "removeMembersMessage": "このプロジェクトから {{count}} 人のメンバーを削除してもよろしいですか？この操作は元に戻せません。",
      "removeMemberMessage": "このプロジェクトから「{{name}}」を削除してもよろしいですか？この操作は元に戻せません。",
      "changeRoleForCount_other": "{{count}} 人のメンバーのロールを変更",
      "selectNewRoleLabel": "新しいロールを選択",
      "updating": "更新中...",
      "updateRole": "ロールを更新",
      "loadErrorFallback": "メンバーを読み込めませんでした。ページを更新してください。",
      "selectAtLeastOneUserError": "少なくとも1人のユーザーを選択してください",
      "addedSuccessToast_other": "{{count}} 人のメンバーを追加しました",
      "removedSuccessToast": "メンバーを削除しました",
      "roleUpdatedSuccessToast": "メンバーのロールを更新しました",
      "bulkRoleUpdatedWithErrorsToast": "{{updated}} 人のメンバーを更新しました。{{errorCount}} 件のエラーが発生しました。",
      "bulkRoleUpdatedSuccessToast": "{{updated}} 人のメンバーのロールを更新しました",
      "bulkRemovedWithErrorsToast": "{{removed}} 人のメンバーを削除しました。{{errorCount}} 件のエラーが発生しました。",
      "bulkRemovedSuccessToast": "{{removed}} 人のメンバーを削除しました"
    },
    "configure": {
      "tabsAriaLabel": "プロジェクト設定タブ",
      "tabs": {
        "members": "メンバー",
        "orchestrators": "オーケストレーター",
        "prompts": "プロンプト",
        "models": "モデル",
        "tools": "ツール",
        "skills": "スキル",
        "knowledge": "ナレッジ",
        "graph": "グラフ",
        "vector": "ベクトル",
        "storage": "ストレージ"
      }
    },
    "setupWizard": {
      "title": "プロジェクト セットアップ ウィザード",
      "projectFieldLabel": "プロジェクト",
      "projectFieldPlaceholder": "プロジェクトを選択...",
      "projectFieldRequiredLabel": "プロジェクト *",
      "projectNameFieldName": "プロジェクト名",
      "projectNameFieldRequiredLabel": "プロジェクト名 *",
      "projectNamePlaceholder": "素晴らしいプロジェクト",
      "orDivider": "または",
      "createNewProject": "新規プロジェクトを作成",
      "descriptionFieldLabel": "説明",
      "descriptionPlaceholder": "簡単な説明...",
      "filesImportedIntoSelectedProject": "ファイルは選択したプロジェクトにインポートされます",
      "dropzoneAriaLabel": "YAML ファイルをアップロードします。ここにファイルをドラッグ&ドロップするか、クリックまたは Enter か Space を押して参照してください。",
      "dropzoneText": "ここにファイルをドロップするか、クリックして参照してください",
      "dropzoneHint": ".yaml、.yml — エージェント、モデル、ツール、プロンプト、スキル、ナレッジ、コネクタ、IAM",
      "validFilesCount": "{{count}} 件の有効なファイル",
      "filesWithErrorsCount": "{{count}} 件でエラー",
      "noAgentYamlWarning": "エージェントの YAML が検出されませんでした。エージェント構成の追加をご検討ください。",
      "reviewStepTitle": "インポート順序の確認",
      "reviewStepDescription": "依存関係に基づいて、次の順序でファイルがインポートされます。",
      "filesWithErrorsSkipped": "エラーのある {{count}} 件のファイルはスキップされます",
      "importingStepTitle": "インポート中...",
      "importingProgress": "{{total}} 件中 {{current}} 件目をインポート中: {{fileName}}",
      "importActions": {
        "created": "作成済み",
        "matched": "一致",
        "failed": "失敗"
      },
      "completeStepTitleSuccess": "セットアップが完了しました！",
      "completeStepTitleWithErrors": "セットアップはエラーありで完了しました",
      "completeStepDescription": "プロジェクトは次のエンティティでセットアップされました。",
      "summaryBadges": {
        "created": "+{{count}} 件作成",
        "matched": "{{count}} 件一致",
        "failed": "{{count}} 件失敗"
      },
      "errorsHeading": "エラー：",
      "steps": {
        "selectProject": "プロジェクトの選択",
        "addFiles": "ファイルの追加",
        "review": "確認",
        "import": "インポート"
      },
      "creatingLabel": "作成中...",
      "createAndContinue": "作成して続行",
      "continueLabel": "続行",
      "reviewImport": "インポートを確認",
      "startImport": "インポート開始",
      "importingLabel": "インポート中...",
      "goToProject": "プロジェクトへ移動",
      "entityTypes": {
        "agent": "エージェント",
        "model": "モデル",
        "tool": "ツール",
        "prompt": "プロンプト",
        "skill": "スキル",
        "knowledge": "ナレッジ",
        "connector": "コネクタ",
        "iam": "IAM",
        "bundle": "バンドル",
        "unknown": "不明"
      },
      "toasts": {
        "dropYamlFiles": "YAML ファイルをドロップしてください",
        "enterProjectName": "プロジェクト名を入力してください",
        "projectCreated": "プロジェクト「{{name}}」を作成しました",
        "selectProject": "プロジェクトを選択してください",
        "projectSelected": "プロジェクト「{{name}}」を選択しました",
        "addAtLeastOneFile": "少なくとも 1 つの YAML ファイルを追加してください",
        "noValidYamlFiles": "有効な YAML ファイルが見つかりません",
        "projectNotCreated": "プロジェクトが作成されていません",
        "noValidFilesToImport": "インポートする有効なファイルがありません",
        "importReportedFailure": "{{name}} のインポートで失敗が報告されました",
        "allImportedSuccessfully": "すべてのエンティティが正常にインポートされました！",
        "importPermissionError": "権限が不足しているためインポートに失敗しました。管理者にお問い合わせください。",
        "importCompletedWithErrors": "インポートが {{count}} 件のエラーで完了しました"
      },
      "unknownProject": "不明"
    },
    "agentsTab": {
      "agentStatusTitle": "エージェントのステータス",
      "activeAgentsTitle": "アクティブなエージェント",
      "archivedAgentsTitle": "アーカイブされたエージェント",
      "openInAgentStudio": "エージェントスタジオで開く",
      "noArchivedAgents": "このプロジェクトにアーカイブされたエージェントはありません。",
      "noAgents": "このプロジェクトにエージェントはありません。",
      "goToAgentStudio": "エージェントスタジオへ移動",
      "archiveDialogTitle": "{{count}} 件のエージェントをアーカイブ",
      "archiveDialogMessage": "{{count}} 件のエージェントをアーカイブしますか？ アーカイブ済みに表示され、そこから下書きに戻すか完全に削除できます。",
      "archiveButtonLabel": "アーカイブ",
      "archivedWithSkippedToast": "{{deleted}} 件のエージェントをアーカイブしました。アクティブな依存関係のため {{skipped}} 件をスキップしました。",
      "archivedToast": "{{count}} 件のエージェントをアーカイブしました",
      "exportSelected": "選択項目をエクスポート",
      "archiveSelected": "選択項目をアーカイブ",
      "columns": {
        "name": "名前",
        "status": "ステータス",
        "framework": "フレームワーク",
        "creator": "作成者",
        "createdAt": "作成日",
        "updatedAt": "更新日",
        "actions": "操作"
      },
      "searchPlaceholder": "エージェントを検索…"
    },
    "workflowsTab": {
      "statusPublished": "公開済み",
      "columns": {
        "workflow": "ワークフロー",
        "status": "ステータス",
        "schedule": "スケジュール",
        "controls": "操作",
        "creator": "作成者",
        "runs": "実行回数",
        "createdAt": "作成日",
        "tags": "タグ",
        "actions": "操作"
      },
      "registeredToRegistryAtVersion": "レジストリに v{{version}} で登録済み",
      "registeredToRegistry": "レジストリに登録済み",
      "scheduleActive": "スケジュール有効",
      "schedulePaused": "スケジュール一時停止中",
      "notScheduled": "未スケジュール",
      "draftCadenceTooltip": "下書きに周期が保存されています。公開するとスケジュールが開始されます（{{cadence}}）。",
      "neverRun": "未実行",
      "lastRunTitle": "最終実行",
      "searchPlaceholder": "ワークフローを検索…",
      "clearSearch": "検索をクリア",
      "totalWorkflows": "合計ワークフロー数 {{count}}",
      "catalogTitle": "カタログ",
      "activeWorkflowsTitle": "アクティブなワークフロー",
      "archivedWorkflowsTitle": "アーカイブされたワークフロー",
      "gridViewTitle": "グリッド表示",
      "listViewTitle": "リスト表示",
      "openInAgentWorkflows": "Agent Workflows で開く",
      "noSearchResults": "検索に一致するワークフローはありません。",
      "noArchivedWorkflows": "このプロジェクトにアーカイブされたワークフローはありません。",
      "noWorkflows": "このプロジェクトにワークフローはありません。",
      "goToAgentWorkflows": "Agent Workflows へ移動",
      "lastRunStatusTooltip": "最終実行ステータス: {{status}}",
      "lastRunTooltip": "最終実行: {{time}}",
      "updatedTooltip": "更新: {{time}}",
      "noDescriptionProvided": "説明はありません",
      "runsCount": "{{count}} 回実行",
      "lastRunLabel": "最終実行 {{time}}",
      "pageOfTotal": "{{totalPages}} ページ中 {{page}} ページ目",
      "versionTitle": "バージョン"
    },
    "skillsTab": {
      "loadError": "スキルの読み込みに失敗しました",
      "requestedAccessToast": "{{count}} 件のスキルへのアクセスをリクエストしました（承認待ち）",
      "addedToast": "{{count}} 件のスキルをプロジェクトに追加しました",
      "alreadyInProjectToast": "{{count}} 件のスキルは既にプロジェクトに存在します",
      "addFailedToast": "{{count}} 件のスキルの追加に失敗しました",
      "removedToast": "スキルをプロジェクトから削除しました",
      "bulkRemovedToast": "{{count}} 件のスキルをプロジェクトから正常に削除しました",
      "bulkRemoveFailedToast": "{{count}} 件のスキルの削除に失敗しました",
      "removeFromProject": "プロジェクトから削除",
      "pending": "保留中",
      "platform": "プラットフォーム",
      "allModels": "すべてのモデル",
      "columns": {
        "name": "スキル名",
        "category": "カテゴリー",
        "type": "タイプ",
        "model": "モデル",
        "version": "バージョン",
        "added": "追加日",
        "lastUpdated": "最終更新日",
        "actions": "操作"
      },
      "errorBoundaryMessage": "スキルを読み込めませんでした。ページを更新してください。",
      "emptyMessage": "このプロジェクトにはスキルが設定されていません",
      "addSkill": "スキルを追加",
      "addSkillsToProjectTitle": "プロジェクトにスキルを追加",
      "showApprovedSkills": "承認済みのスキルを表示",
      "removeDialogTitle": "スキルを削除",
      "removeDialogMessage": "「{{name}}」をこのプロジェクトから削除しますか？",
      "remove": "削除",
      "bulkRemoveDialogTitle": "スキルを削除",
      "bulkRemoveDialogMessage": "選択した {{count}} 件のスキルをこのプロジェクトから削除してもよろしいですか？"
    },
    "toolsTab": {
      "requestedAccessToast": "{{count}} 件のツールへのアクセスをリクエストしました（承認待ち）",
      "alreadyInProjectToast": "{{count}} 件のツールは既にプロジェクトに存在します",
      "addFailedToast": "{{count}} 件のツールの追加に失敗しました",
      "removedToast": "ツールをプロジェクトから削除しました",
      "bulkRemovedToast": "{{count}} 件のツールをプロジェクトから正常に削除しました",
      "bulkRemoveFailedToast": "{{count}} 件のツールの削除に失敗しました: {{errors}}",
      "removeFromProject": "プロジェクトから削除",
      "exportSelected": "選択項目をエクスポート",
      "pending": "保留中",
      "columns": {
        "name": "ツール名",
        "type": "タイプ",
        "endpoint": "エンドポイント",
        "created": "作成日",
        "lastUpdated": "最終更新日",
        "actions": "操作"
      },
      "errorBoundaryMessage": "ツールを読み込めませんでした。ページを更新してください。",
      "emptyMessage": "このプロジェクトにはツールが設定されていません",
      "addTool": "ツールを追加",
      "addToolsToProjectTitle": "プロジェクトにツールを追加",
      "showApprovedTools": "承認済みのツールを表示",
      "removeDialogTitle": "ツールを削除",
      "removeDialogMessage": "「{{name}}」をこのプロジェクトから削除しますか？",
      "remove": "削除",
      "bulkRemoveDialogTitle": "ツールを削除",
      "bulkRemoveDialogMessage": "選択した {{count}} 件のツールをこのプロジェクトから削除してもよろしいですか？"
    },
    "modelsTab": {
      "requestedAccessToast": "{{count}} 件のモデルへのアクセスをリクエストしました（承認待ち）",
      "alreadyInProjectToast": "{{count}} 件のモデルは既にプロジェクトに存在します",
      "addFailedToast": "{{count}} 件のモデルを追加できませんでした",
      "removedToast": "モデルを正常に削除しました",
      "bulkRemovedToast": "{{count}} 件のモデルをプロジェクトから正常に削除しました",
      "bulkRemoveFailedToast": "{{count}} 件のモデルの削除に失敗しました: {{errors}}",
      "removeFromProject": "プロジェクトから削除",
      "pending": "保留中",
      "columns": {
        "name": "モデル名",
        "provider": "プロバイダー",
        "modelId": "モデルID",
        "created": "作成日",
        "lastUpdated": "最終更新日",
        "actions": "操作"
      },
      "errorBoundaryMessage": "モデルを読み込めませんでした。ページを更新してください。",
      "emptyMessage": "このプロジェクトにはモデルが設定されていません",
      "addModel": "モデルを追加",
      "addModelsToProjectTitle": "プロジェクトにモデルを追加",
      "showApprovedModels": "承認済みのモデルを表示",
      "removeDialogTitle": "モデルを削除",
      "removeDialogMessage": "「{{name}}」をこのプロジェクトから削除しますか？",
      "remove": "削除",
      "bulkRemoveDialogTitle": "モデルを削除",
      "bulkRemoveDialogMessage": "選択した {{count}} 件のモデルをこのプロジェクトから削除してもよろしいですか？"
    },
    "orchestratorsTab": {
      "selectAtLeastOne": "少なくとも1つのオーケストレーターを選択してください",
      "requestedAccessToast": "{{count}} 件のオーケストレーターへのアクセスをリクエストしました（承認待ち）",
      "removedToast": "「{{name}}」をプロジェクトから削除しました",
      "bulkRemovedToast": "{{count}} 件のオーケストレーターをプロジェクトから正常に削除しました",
      "bulkRemoveFailedToast": "{{count}} 件のオーケストレーターの削除に失敗しました: {{errors}}",
      "removeFromProject": "プロジェクトから削除",
      "testConnection": "接続をテスト",
      "testConnectionSuccess": "「{{name}}」の接続テストに成功しました",
      "testConnectionFailure": "「{{name}}」の接続テストに失敗しました: {{message}}",
      "columns": {
        "name": "名前",
        "type": "タイプ",
        "host": "ホスト",
        "status": "ステータス",
        "addedBy": "追加者",
        "addedAt": "追加日",
        "actions": "操作"
      },
      "errorBoundaryMessage": "オーケストレーターを読み込めませんでした。ページを更新してください。",
      "emptyMessage": "このプロジェクトにはオーケストレーターが設定されていません",
      "addOrchestrator": "オーケストレーターを追加",
      "addOrchestratorsToProjectTitle": "プロジェクトにオーケストレーターを追加",
      "removeDialogTitle": "オーケストレーターを削除",
      "removeDialogMessage": "「{{name}}」をこのプロジェクトから削除しますか？",
      "remove": "削除",
      "bulkRemoveDialogTitle": "オーケストレーターを削除",
      "bulkRemoveDialogMessage": "選択した {{count}} 件のオーケストレーターをこのプロジェクトから削除してもよろしいですか？"
    },
    "knowledgeTab": {
      "unknown": "不明",
      "vectorDatabase": "ベクトルデータベース",
      "vectorDbBadge": "ベクトルDB",
      "schemaTitle": "スキーマ: {{schema}}",
      "searchPlaceholder": "テーブルを検索...",
      "clearSearch": "検索をクリア",
      "columns": {
        "name": "名前",
        "database": "データベース",
        "rows": "行数",
        "status": "ステータス",
        "creator": "作成者",
        "actions": "操作"
      },
      "status": {
        "error": "エラー",
        "active": "アクティブ",
        "syncing": "同期中",
        "pending": "保留中"
      },
      "actions": {
        "previewData": "データをプレビュー",
        "removeFromProject": "プロジェクトから削除",
        "remove": "削除"
      },
      "toasts": {
        "requestedAccess": "{{count}} 件の{{tableLabel}}{{plural}}へのアクセスをリクエストしました（承認待ち）",
        "alreadyInProject": "{{count}} 件の{{tableLabel}}{{plural}}はすでにプロジェクトに含まれています",
        "requestAccessFailed": "{{count}} 件の{{tableLabel}}{{plural}}へのアクセスリクエストに失敗しました",
        "removed": "ナレッジテーブルをプロジェクトから削除しました",
        "bulkRemoved": "{{count}} 件の{{typeLabel}}テーブル{{plural}}をプロジェクトから削除しました",
        "bulkRemoveFailed": "{{count}} 件の{{typeLabel}}テーブル{{plural}}の削除に失敗しました: {{errors}}"
      },
      "removeDialogMessage": "「{{name}}」をこのプロジェクトから削除しますか？",
      "bulkRemoveDialogMessage": "選択した {{count}} 件のテーブルをこのプロジェクトから削除してもよろしいですか？",
      "viewToggle": {
        "database": "データベース表示",
        "collection": "コレクション表示"
      },
      "variant": {
        "knowledge": {
          "tableLabel": "ナレッジテーブル",
          "typeLabel": "ナレッジ",
          "addButton": "ナレッジを追加",
          "emptyMessage": "このプロジェクトにはナレッジテーブルが設定されていません",
          "addModalTitle": "プロジェクトにナレッジを追加",
          "membershipToggleLabel": "承認済みテーブルを表示",
          "removeDialogTitle": "ナレッジテーブルを削除",
          "removeDialogTitlePlural": "ナレッジテーブルを削除",
          "errorBoundaryMessage": "ナレッジテーブルを読み込めませんでした。ページを更新してください。"
        },
        "graph": {
          "tableLabel": "グラフテーブル",
          "typeLabel": "グラフ",
          "addButton": "グラフを追加",
          "emptyMessage": "このプロジェクトにはグラフテーブルが設定されていません",
          "addModalTitle": "プロジェクトにグラフテーブルを追加",
          "membershipToggleLabel": "承認済みグラフテーブルを表示",
          "removeDialogTitle": "グラフテーブルを削除",
          "removeDialogTitlePlural": "グラフテーブルを削除",
          "errorBoundaryMessage": "グラフテーブルを読み込めませんでした。ページを更新してください。"
        },
        "vector": {
          "tableLabel": "ベクトルテーブル",
          "typeLabel": "ベクトル",
          "addButton": "ベクトルを追加",
          "emptyMessage": "このプロジェクトにはベクトルテーブルが設定されていません",
          "addModalTitle": "プロジェクトにベクトルテーブルを追加",
          "membershipToggleLabel": "承認済みベクトルテーブルを表示",
          "removeDialogTitle": "ベクトルテーブルを削除",
          "removeDialogTitlePlural": "ベクトルテーブルを削除",
          "errorBoundaryMessage": "ベクトルテーブルを読み込めませんでした。ページを更新してください。"
        }
      }
    },
    "storageTab": {
      "unknown": "不明",
      "addButton": "ストレージを追加",
      "addModalTitle": "プロジェクトにストレージを追加",
      "emptyMessage": "このプロジェクトにはストレージフォルダーが設定されていません",
      "errorBoundaryMessage": "ストレージフォルダーを読み込めませんでした。ページを更新してください。",
      "membershipToggleLabel": "承認済みストレージを表示",
      "removeDialogTitle": "ストレージフォルダーを削除",
      "removeDialogTitlePlural": "ストレージフォルダーを削除",
      "removeDialogMessage": "「{{name}}」をこのプロジェクトから削除しますか？",
      "bulkRemoveDialogMessage": "選択した {{count}} 件のストレージフォルダーをこのプロジェクトから削除してもよろしいですか？",
      "columns": {
        "folder": "フォルダー",
        "connector": "コネクタ",
        "files": "ファイル",
        "size": "サイズ",
        "status": "ステータス",
        "creator": "作成者",
        "actions": "操作"
      },
      "status": {
        "active": "アクティブ",
        "error": "エラー",
        "pending": "保留中"
      },
      "actions": {
        "previewFiles": "ファイルをプレビュー",
        "sync": "同期",
        "syncing": "同期中...",
        "removeFromProject": "プロジェクトから削除",
        "remove": "削除"
      },
      "toasts": {
        "requestedAccess": "{{count}} 件のストレージフォルダー{{plural}}へのアクセスをリクエストしました（承認待ち）",
        "alreadyInProject": "{{count}} 件のストレージフォルダー{{plural}}はすでにプロジェクトに含まれています",
        "addFailed": "{{count}} 件のストレージフォルダー{{plural}}の追加に失敗しました",
        "synced": "「{{name}}」のメタデータを同期しました。",
        "removed": "ストレージフォルダーをプロジェクトから削除しました",
        "bulkRemoved": "{{count}} 件のストレージフォルダー{{plural}}をプロジェクトから削除しました",
        "bulkRemoveFailed": "{{count}} 件のストレージフォルダー{{plural}}の削除に失敗しました"
      }
    },
    "registryTab": {
      "columnAgent": "エージェント",
      "columnFramework": "フレームワーク",
      "columnStatus": "ステータス",
      "columnEnv": "環境",
      "columnOrchestrator": "オーケストレータ",
      "columnRegisteredBy": "登録者",
      "columnRegisteredAt": "登録日時",
      "columnActions": "操作",
      "columnWorkflow": "ワークフロー",
      "actionOpenCanvas": "キャンバスを開く",
      "actionRuns": "実行",
      "registryViewsAriaLabel": "レジストリビュー",
      "agentRegistryTitle": "エージェントレジストリ",
      "agentsLabel": "エージェント",
      "workflowRegistryTitle": "ワークフローレジストリ",
      "workflowsLabel": "ワークフロー",
      "registryStatusTitle": "レジストリステータス",
      "activeItemsTitle": "アクティブなレジストリ項目",
      "archivedItemsTitle": "アーカイブされたレジストリ項目",
      "openInRegistryTitle": "レジストリで開く",
      "emptyActiveAgents": "このプロジェクトに登録されたエージェントはありません。",
      "emptyArchivedAgents": "このプロジェクトにアーカイブされた登録エージェントはありません。",
      "emptyActiveWorkflows": "このプロジェクトに登録されたワークフローはありません。",
      "emptyArchivedWorkflows": "このプロジェクトにアーカイブされた登録ワークフローはありません。",
      "goToRegistry": "エージェントレジストリへ移動",
      "searchRegistryPlaceholder": "レジストリを検索…",
      "searchWorkflowsPlaceholder": "ワークフローを検索…"
    },
    "promptsTab": {
      "columnName": "プロンプト名",
      "columnCategory": "カテゴリ",
      "columnDescription": "説明",
      "columnCreated": "作成日",
      "columnLastUpdated": "最終更新",
      "columnActions": "操作",
      "noDescription": "説明なし",
      "viewVersionsTitle": "プロンプトのバージョンを表示",
      "errorBoundaryMessage": "プロンプトを読み込めません。ページを更新してください。",
      "emptyMessage": "このプロジェクトにプロンプトはありません。プロンプトはプロンプトページで管理されます。",
      "dialogCloseAriaLabel": "ダイアログを閉じる",
      "categoryLabel": "カテゴリ:",
      "versionsHeading": "バージョン ({{count}})",
      "loadingVersions": "バージョンを読み込み中...",
      "noVersionsFound": "バージョンが見つかりません",
      "versionLabel": "バージョン {{version}}",
      "latestBadge": "最新",
      "selectVersionPrompt": "内容を表示するにはバージョンを選択してください"
    },
    "deploymentsTab": {
      "columnAgent": "エージェント",
      "columnEnv": "環境",
      "columnStatus": "ステータス",
      "columnDeployedBy": "デプロイ担当者",
      "columnDeployedAt": "デプロイ日時",
      "columnActions": "操作",
      "columnWorkflow": "ワークフロー",
      "actionOpen": "開く",
      "actionChat": "チャット",
      "actionRuntimeSettings": "ランタイム設定",
      "actionOpenInMonitoring": "モニタリングで開く",
      "actionManageArchive": "モニタリングでアーカイブを管理",
      "actionGuardrails": "ガードレール",
      "deploymentViewsAriaLabel": "デプロイビュー",
      "agentDeploymentsTitle": "エージェントデプロイ",
      "agentsLabel": "エージェント",
      "workflowDeploymentsTitle": "ワークフローデプロイ",
      "workflowsLabel": "ワークフロー",
      "deploymentStatusTitle": "デプロイステータス",
      "activeDeploymentsTitle": "アクティブなデプロイ",
      "archivedDeploymentsTitle": "アーカイブされたデプロイ",
      "openInMonitoringTitle": "モニタリングで開く",
      "emptyActiveAgents": "このプロジェクトにアクティブなエージェントデプロイはありません。",
      "emptyArchivedAgents": "このプロジェクトにアーカイブされたエージェントデプロイはありません。",
      "emptyActiveWorkflows": "このプロジェクトにアクティブなワークフローデプロイはありません。",
      "emptyArchivedWorkflows": "このプロジェクトにアーカイブされたワークフローデプロイはありません。",
      "goToMonitoring": "モニタリングへ移動",
      "searchDeploymentsPlaceholder": "デプロイを検索…",
      "searchWorkflowDeploymentsPlaceholder": "ワークフローデプロイを検索…"
    },
    "evalsTab": {
      "columnAgent": "エージェント",
      "columnLatestSession": "最新セッション",
      "columnActions": "操作",
      "actionOpenEvals": "評価を開く",
      "actionManageInEvals": "評価で管理",
      "portfolioSubtitle": "このプロジェクトの評価ポートフォリオ",
      "openInEvalsTitle": "評価で開く",
      "emptyMessage": "このプロジェクトの評価データはありません。",
      "goToEvals": "評価とシミュレーションへ移動",
      "searchAgentsPlaceholder": "エージェントを検索…"
    }
  },
  "prompts": {
    "exportFileName": "プロンプト",
    "searchPlaceholder": "プロンプトを検索...",
    "columns": {
      "name": "プロンプト名",
      "description": "説明",
      "category": "カテゴリ",
      "model": "モデル",
      "project": "プロジェクト",
      "visibility": "公開範囲",
      "createdBy": "作成者",
      "updatedAt": "更新日時",
      "actions": "操作"
    },
    "filters": {
      "title": "フィルター",
      "visibility": "公開範囲",
      "category": "カテゴリ",
      "project": "プロジェクト",
      "creator": "作成者",
      "all": "すべて",
      "favorites": "お気に入り"
    },
    "visibility": {
      "project": "プロジェクト",
      "public": "プラットフォーム"
    },
    "list": {
      "uncategorized": "未分類",
      "allModels": "すべてのモデル",
      "platformBadge": "プラットフォーム",
      "platformBadgeTooltip": "コードで管理されるシステムプロンプト — 読み取り専用",
      "versionCount": "{{count}} バージョン",
      "versionCount_other": "{{count}} バージョン",
      "unknownProject": "不明",
      "emptyState": {
        "permissionDenied": "プロンプトを表示する権限がありません。アクセスについては管理者にお問い合わせください。",
        "noResultsSearch": "検索条件に一致するプロンプトが見つかりません。",
        "default": "プロンプトが見つかりません。最初のプロンプトを作成して始めましょう。"
      }
    },
    "actions": {
      "view": "表示",
      "chat": "チャット",
      "exportYaml": "YAMLとしてエクスポート",
      "optimize": "最適化",
      "cloneForModel": "モデル用に複製",
      "edit": "編集",
      "delete": "削除",
      "exportSelected": "選択項目をエクスポート",
      "deleteSelected": "選択項目を削除",
      "createPrompt": "プロンプトを作成",
      "newPrompt": "新規プロンプト",
      "creating": "作成中..."
    },
    "quota": {
      "loading": "クォータを読み込み中...",
      "label": "プロンプト"
    },
    "toast": {
      "projectFilterReset": "以前選択していたプロジェクトは存在しません。フィルターがリセットされました。",
      "draftInserted": "プロンプトの下書きを挿入しました。必要に応じて編集し、作成してください — 保存後にプロンプトエディターから最適化を実行できます。",
      "clonedForModel": "モデル「{{model}}」用にプロンプトを複製しました",
      "bulkDeletePartial": "{{deleted}} 件のプロンプトを削除、{{skipped}} 件失敗: {{errors}}",
      "bulkDeleteSuccess": "{{count}} 件のプロンプトを削除しました",
      "platformDeleteBlocked": "プラットフォームのプロンプトは削除できません"
    },
    "form": {
      "modelAgnostic": "モデル非依存（すべてのモデル）",
      "selectProjectFirst": "まずプロジェクトを選択してください。",
      "selectProjectModel": "このプロジェクトに割り当てられたLLMモデルを選択してください。",
      "selectModel": "LLMモデルを選択してください。",
      "minBusinessContext": "ビジネスコンテキストを10文字以上入力してください。",
      "selectProjectAndModelFirst": "まずプロジェクトとモデルを選択してください",
      "selectModelFirst": "まずモデルを選択してください",
      "minCharsRequired": "最低10文字が必要です",
      "selectProjectFirstPlaceholder": "まずプロジェクトを選択",
      "loadingModels": "モデルを読み込み中…",
      "noLlmForProject": "このプロジェクトに割り当てられたLLMがありません",
      "noLlmAvailable": "利用可能なLLMがありません",
      "nameAlreadyExists": "この名前のプロンプトは既に存在します",
      "promptNameLabel": "プロンプト名 *",
      "promptNamePlaceholder": "例：カスタマーサポートアシスタント",
      "categoryLabel": "カテゴリ",
      "categoryPlaceholder": "例：サポート、営業",
      "targetModelLabel": "対象モデル",
      "targetModelRequiredLabel": "対象モデル *",
      "selectModelPlaceholder": "モデルを選択...",
      "descriptionLabel": "説明",
      "descriptionPlaceholder": "このプロンプトの内容を簡単に説明してください",
      "charCount": "{{count}}/{{max}} 文字",
      "modelLabel": "モデル",
      "selectAiModelPlaceholder": "AIモデルを選択",
      "generating": "生成中…",
      "generate": "生成",
      "businessContextPlaceholder": "対象者、トーン、タスク、制約 — これらを基にモデルがプロンプトを作成します。生成には最低10文字必要です。",
      "aiGenerateHint": "生成後は手動モードに切り替えてプロンプトを確認・編集してから作成してください。",
      "contentPlaceholderPrefix": "あなたは親切なアシスタントです...\n\nここにシステムプロンプトを記述してください。実行時に解決される状態変数を参照するには ",
      "contentPlaceholderSuffix": " を使用します。",
      "variableNamePlaceholder": "variable_name",
      "addVariable": "変数を追加",
      "nameLabel": "名前 *",
      "fixValidationErrors": "保存前に入力エラーを修正してください",
      "saving": "保存中...",
      "saveChanges": "変更を保存",
      "quotaExceeded": "プロンプトのクォータを超過しました",
      "fillRequiredFields": "すべての必須項目を入力してください",
      "cloning": "複製中..."
    },
    "modal": {
      "detailsHeader": "詳細",
      "describePromptHeader": "プロンプトに行わせたい内容を記述してください",
      "promptDetailsHeader": "プロンプトの詳細",
      "createTitle": "新規プロンプトを作成",
      "creationModeAriaLabel": "プロンプト作成モード",
      "modeManual": "手動",
      "modeAi": "AI",
      "editorSectionsAriaLabel": "プロンプトエディターのセクション",
      "tabPrompt": "プロンプト",
      "tabState": "状態",
      "editorHintPrefix": "状態変数には",
      "editorHintSuffix": "を使用してください",
      "aiGeneratedNote": "AI生成 — 必要に応じて編集してください。さらに調整するには最適化を利用してください。",
      "loadingEditor": "プロンプトエディターを読み込み中...",
      "stateVariablesHintPrefix": "プロンプト内で",
      "stateVariablesHintSuffix": "とともに使用する状態変数を定義してください。プロンプト内で参照される各変数はここに一覧表示する必要があります。",
      "noStateVariables": "まだ状態変数が定義されていません。",
      "stateVariableNameAriaLabel": "状態変数名 {{name}}",
      "removeStateVariableAriaLabel": "状態変数 {{name}} を削除",
      "newVariableFallback": "新規",
      "editTitle": "プロンプトのメタデータを編集",
      "deleteTitle": "プロンプトを削除",
      "deleteMessage": "「{{name}}」を削除してもよろしいですか？この操作は元に戻せません。",
      "bulkDeleteTitle": "選択したプロンプトを削除",
      "bulkDeleteMessage": "{{count}} 件のプロンプトを削除してもよろしいですか？この操作は元に戻せません。",
      "bulkDeleteMessage_other": "{{count}} 件のプロンプトを削除してもよろしいですか？この操作は元に戻せません。",
      "bulkDeleteConfirm": "{{count}} 件のプロンプトを削除",
      "bulkDeleteConfirm_other": "{{count}} 件のプロンプトを削除",
      "cloneTitle": "モデル用に複製",
      "cloneMessage": "「{{name}}」を別のモデル用にすべてのバージョンで複製します。",
      "cloneSubmit": "プロンプトを複製"
    },
    "optimizeModal": {
      "header": {
        "title": "プロンプトを最適化",
        "subtitlePlaceholder": "プロンプトを選択"
      },
      "stepper": {
        "configure": "設定",
        "running": "実行中",
        "result": "結果"
      },
      "framework": {
        "sectionTitle": "フレームワークを選択",
        "bestFor": "最適な用途: {{value}}",
        "catalog": {
          "dspy": {
            "label": "DSPy",
            "tier": "ティア1",
            "desc": "宣言的最適化(MIPROv2、COPRO、またはブートストラップ few-shot)。ラベル付き例に最適。",
            "tooltip": "宣言的プログラムを最適化されたプロンプトにコンパイルします。以下でコンパイラの種類を選択してください(デフォルトは MIPROv2)。",
            "bestFor": "分類、質問応答、抽出タスク"
          },
          "cot": {
            "label": "Chain-of-Thought",
            "tier": "ティア2",
            "desc": "推論の最適化:段階的推論、トレース品質、ステップ分解。",
            "tooltip": "複数の CoT 戦略(例:「ステップごとに考える」)を試し、推論トレースの品質とステップ分解を最適化します。すべての戦略を使うにはプロンプトタイプ「Chain-of-Thought」を使用してください。",
            "bestFor": "推論、数学、複数ステップのタスク"
          },
          "opro": {
            "label": "OPRO",
            "tier": "ティア2",
            "desc": "LLM を最適化器として使用。(プロンプト、スコア)の履歴を渡し改善を求めます。",
            "tooltip": "LLM 自体を最適化器として使い、スコアの推移を分析して反復的により良いプロンプトを提案します。勾配計算不要でシンプルに導入可能。",
            "bestFor": "あらゆるタスクでの高速な反復"
          },
          "reflexion": {
            "label": "Reflexion",
            "tier": "ティア2",
            "desc": "自己内省的な言語的強化学習。批評→書き直しのループを生成。",
            "tooltip": "各試行後に自己批評を生成し、特定した失敗を修正するようプロンプトを書き直します。内省とエピソード記憶を組み合わせ、持続的な改善を実現します。",
            "bestFor": "複雑な推論、複数ステップのタスク"
          },
          "gepa": {
            "label": "GEPA",
            "tier": "ティア3",
            "desc": "例ごとのパレート選択と候補統合を行う上流の Genetic-Pareto エンジン。",
            "tooltip": "リファレンスの GEPA エンジンを実行します。単一の集計スコアではなく検証例ごとにパレートフロンティアを維持するため、一部のケースにのみ有効なプロンプトも統合のために生き残ります。",
            "bestFor": "マルチノードのエージェントグラフ、停滞した実行"
          },
          "gepa_legacy": {
            "label": "GEPA(レガシー)",
            "tier": "ティア3",
            "desc": "LLM による失敗診断を伴う自社製の内省的進化手法。",
            "tooltip": "以前の内蔵 GEPA 近似手法。上流パッケージが利用できない場合のフォールバックとして、また A/B 比較用に保持されています。",
            "bestFor": "gepa パッケージなしのオフラインインストール"
          },
          "optimize_anything": {
            "label": "optimize_anything",
            "tier": "ティア3",
            "desc": "プロンプト以外の成果物(エージェントグラフ、ノード設定)向けの上流 GEPA ランチャー。",
            "tooltip": "同じ Genetic-Pareto エンジンでグラフ JSON やノード設定パラメータを最適化します。無効な候補は検証エラーをフィードバックとしてスコア0になります。永続化は明示的な適用ステップが必要です。",
            "bestFor": "プロンプトを超えたトポロジーと設定の探索"
          },
          "evoprompt": {
            "label": "EvoPrompt",
            "tier": "ティア3",
            "desc": "交叉・突然変異演算子を用いた集団ベースの進化的手法。",
            "tooltip": "プロンプト候補の集団を維持し、遺伝的アルゴリズムに着想を得た交叉/突然変異演算子を適用します。多様なプロンプト表現の探索に最適。",
            "bestFor": "多様なプロンプト探索"
          },
          "ape": {
            "label": "APE",
            "tier": "ティア3",
            "desc": "自動プロンプトエンジニア。生成→スコアリング→再サンプリング。",
            "tooltip": "入出力デモから多数の候補指示を生成し、スコアリングした後、上位の周辺で再サンプリングします。指示発見に高速かつ効果的。",
            "bestFor": "例からの指示発見"
          },
          "textgrad": {
            "label": "TextGrad",
            "tier": "ティア4",
            "desc": "テキストによる逆伝播。的を絞った修正のためのテキスト勾配を計算。",
            "tooltip": "テキストの「勾配」— 自然言語のフィードバック — をプロンプト内で逆方向に伝播し、修正すべき箇所を正確に特定します。精密で外科的な改良。",
            "bestFor": "長いプロンプトの精密編集"
          },
          "rl_tuning": {
            "label": "RL-PPO",
            "tier": "ティア5",
            "desc": "カスタム報酬関数を用いた PPO スタイルの方策最適化。",
            "tooltip": "プロンプト選択を方策として扱い、Proximal Policy Optimization で最適化します。最適化目標を完全に制御するため独自の報酬関数を定義できます。",
            "bestFor": "カスタム報酬目標"
          },
          "rag_aware": {
            "label": "RAG-Aware",
            "tier": "ティア6",
            "desc": "プロンプトと検索パイプラインの共同最適化。",
            "tooltip": "プロンプトと検索設定を一緒に共同最適化します。RAG 主体のワークフロー向けにクエリのフォーマット、コンテキストの配置、指示の言い回しを調整します。",
            "bestFor": "検索拡張生成"
          },
          "multi_obj": {
            "label": "多目的",
            "tier": "横断",
            "desc": "精度、レイテンシ、コストにわたるパレートフロント最適化。",
            "tooltip": "複数の競合する目標(精度、レイテンシ、トークンコスト)にわたってパレートフロンティアを探索します。単一の勝者ではなく、トレードオフ最適なプロンプトの集合を返します。",
            "bestFor": "精度とコストのバランス"
          },
          "ensemble": {
            "label": "アンサンブル",
            "tier": "横断",
            "desc": "複数の最適化器を並行実行し、結果を統合(トーナメント、マージ、投票)。",
            "tooltip": "2つ以上の補完的なフレームワーク(例:Reflexion + OPRO + TextGrad)を同時に実行し、最良の候補を組み合わせます。単一フレームワークよりコストが高く、堅牢で多角的なプロンプト改善を望む場合に最適。",
            "bestFor": "最大限のカバレッジと堅牢性"
          }
        }
      },
      "promptVersion": {
        "sectionTitle": "プロンプトとバージョン",
        "projectLabel": "プロジェクト",
        "promptLabel": "プロンプト",
        "promptPlaceholder": "プロンプトを選択...",
        "promptSearchPlaceholder": "名前で検索...",
        "promptRequiredError": "プロンプトの選択が必要です。",
        "versionLabel": "バージョン",
        "versionPlaceholder": "バージョンを選択...",
        "versionRequiredError": "プロンプトバージョンの選択が必要です。",
        "versionCurrentSuffix": "(現在)",
        "compilerTypeLabel": "コンパイラの種類",
        "compilerTypeTitle": "どの DSPy テレプロンプターを実行するか(MIPROv2 がデフォルトの多重最適化器です)。",
        "compilerOptions": {
          "miprov2": "MIPROv2",
          "copro": "COPRO",
          "bootstrapFewShot": "ブートストラップ Few-shot"
        },
        "promptTypeLabel": "プロンプトの種類",
        "promptTypeTitle": "Chain-of-Thought 最適化戦略。",
        "promptTypeOptions": {
          "standard": "標準",
          "cot": "Chain-of-Thought",
          "fewShot": "Few-shot",
          "structuredOutput": "構造化出力(JSON/XML)"
        },
        "allProjectsLabel": "すべてのプロジェクト"
      },
      "model": {
        "sectionTitle": "モデル設定",
        "responseModelLabel": "応答モデル",
        "responseModelPlaceholder": "LLM モデルを選択...",
        "responseModelRequiredError": "応答モデルが必要です(またはマルチモデルを有効にして2つ以上のターゲットを指定してください)。",
        "judgeModelLabel": "ジャッジモデル",
        "judgeModelPlaceholder": "ジャッジモデルを選択",
        "gepaMutationModelLabel": "GEPA 変異モデル",
        "gepaMutationModelTitle": "GEPA の内省と変異に使用する LLM(LiteLLM モデル ID またはプラットフォームモデル UUID)。",
        "gepaMutationModelPlaceholder": "変異モデルを選択",
        "gepaMutationModelHint": "内省と変異体生成に使用。評価には引き続き上記のジャッジ/応答モデルが使われます。",
        "multiModelLabel": "複数モデルにわたって最適化",
        "multiModelHint": "2つ以上のモデルでプロンプトを評価し集約する(モデル非依存のプロンプト)",
        "targetModelsLabel": "対象モデル(2つ以上選択)",
        "selectAtLeast2Hint": "少なくとも2つのモデルを選択してください。",
        "modelsSelectedCount": "{{count}} 個のモデルを選択済み。",
        "aggregationStrategyLabel": "集約戦略",
        "aggregationOptions": {
          "mean": "平均 — 全モデルの平均",
          "min": "最小 — 最悪ケース(どのモデルも取り残さない)",
          "pareto": "パレート — 最小と平均のバランス"
        },
        "aggregationHint": "最小 = 最も弱いモデルに合わせて最適化;平均 = 平均;パレート = バランス。",
        "noModelsHint": "このプロジェクトに紐づく LLM モデルがありません。プロジェクト → モデルでモデルを追加してください。追加しない場合、最適化はバックエンドの既定値にフォールバックすることがあります。",
        "selectPromptHint": "プロンプトを選択すると、そのプロジェクトの応答モデルとジャッジモデルが読み込まれます。"
      },
      "ensemble": {
        "sectionTitle": "アンサンブル設定",
        "subFrameworksLabel": "サブフレームワーク(2つ以上選択)",
        "subFrameworksHint": "選択した各最適化器が並行して実行され、結果は以下の戦略で統合されます。",
        "fusionLabel": "統合戦略",
        "fusionOptions": {
          "tournament": "トーナメント — 候補をデータセット全体で評価し最良を選択",
          "merge": "マージ — LLM が上位候補を1つのプロンプトに合成",
          "voting": "投票 — テストセットで候補を評価し重み付き結合"
        },
        "minTwoToast": "アンサンブルには少なくとも2つのサブフレームワークを選択してください"
      },
      "metrics": {
        "sectionTitle": "評価指標",
        "autoDiscoverLabel": "データセットとプロンプトから指標を自動検出(コンテキストがある場合は忠実度や関連性などを推奨)",
        "selectPromptHint": "プロンプトを選択すると、そのプロジェクトの指標カタログが読み込まれます。",
        "weightsTitle": "指標の重み(任意 — 複合スコア)",
        "weightsHint": "空欄の場合は均等な重み。重みは合計が1になるよう正規化されます。",
        "weightPlaceholder": "均等",
        "noMetricsWarning": "指標が選択されていません — 既定で Answer Correctness が使用されます。",
        "embeddingLabel": "埋め込みモデル(選択した指標に必要)",
        "embeddingPlaceholder": "埋め込みモデルを選択…",
        "embeddingNoModelsHint": "このプロジェクトにアクティブな埋め込みモデルがありません。プロジェクト → モデルで登録してください。",
        "sqlLabel": "実行用データベース(Text2SQL EX/VES に必要)",
        "sqlPlaceholder": "データベースコネクタを選択…",
        "sqlNoConnectorsHint": "登録済みのデータベースコネクタがありません。Knowledge → Connectors で追加してください。",
        "schemaLabel": "スキーマ定義(JSON、スキーマ準拠に必要)",
        "schemaPlaceholder": "{\"tables\": [{\"name\": \"orders\", \"columns\": [\"id\", \"amount\"]}]}"
      },
      "dataset": {
        "sectionTitle": "ベンチマークデータセット",
        "optionalGepaSuffix": "(GEPA では任意)",
        "selectPromptHint": "プロンプトを選択すると、そのプロジェクトのナレッジに紐づくベンチマークデータセットが一覧表示されます。",
        "datasetPlaceholder": "登録済みテーブルを選択...",
        "datasetSearchPlaceholder": "名前またはテーブルでデータセットを検索...",
        "datasetRowsSuffix": "({{count}} 行)",
        "datasetRequiredError": "ベンチマークデータセットの選択が必要です。",
        "noDatasetsHint": "このプロジェクトにマップされたナレッジテーブルがありません。プロジェクト → ナレッジでテーブルをマップしてください。",
        "inputColumnLabel": "入力カラム",
        "columnPlaceholder": "カラムを選択...",
        "expectedOutputColumnLabel": "期待出力カラム",
        "expectedOutputRequiredError": "DSPy には期待出力カラムが必要です。",
        "contextColumnsLabel": "コンテキストカラム(任意)",
        "selectDatasetFirst": "先にデータセットを選択してください",
        "contextColumnsHint": "複数のカラムは評価コンテキストとして結合されます(RAGAS / DeepEval)。",
        "samplingStrategyLabel": "サンプリング戦略",
        "samplingOptions": {
          "random": "ランダム",
          "stratified": "層化(期待出力別)",
          "difficultyWeighted": "難易度加重(難しい例に焦点)",
          "progressive": "段階的(最適化の収束に応じてサブセットを拡大)"
        },
        "samplingHint": "層化と難易度加重は、少ない行数でもシグナルを改善できます。"
      },
      "dspyContext": {
        "title": "DSPy コンテキスト統合",
        "modeLabel": "コンテキスト渡しモード",
        "modeOptions": {
          "auto": "自動 — 検出時にコンテキストを DSPy 入力として注入",
          "injectField": "フィールド注入 — 常にコンテキストを DSPy 入力として追加",
          "ragModule": "RAG モジュール — 予測前にコンテキストコーパスから検索"
        },
        "modeHints": {
          "auto": "プロンプトテンプレートが参照していなくても、データセットのコンテキストを DSPy シグネチャに自動注入します。",
          "injectField": "コンテキスト注入を DSPy 入力フィールドとして強制します。DSPy はコンパイル時にコンテキストの使い方を学習します。",
          "ragModule": "Retrieve + Predict の複合 DSPy モジュールを構築します。MIPROv2 は検索と予測を共同最適化できます。"
        },
        "demoStrategyLabel": "デモ選択戦略",
        "demoOptions": {
          "default": "デフォルト — DSPy コンパイラに任せる",
          "diverseContext": "多様なコンテキスト — デモ間のコンテキスト多様性を最大化",
          "maxCoverage": "最大カバレッジ — コンテキストトピックの最も広い範囲をカバー"
        },
        "demoHint": "多様なコンテキストと最大カバレッジは、より豊かなコンテキストの多様性を持つデモを選択し、few-shot の品質を高めます。",
        "topKLabel": "検索 Top-K",
        "topKHint": "ゴールデンデータセットからクエリごとに検索するコンテキストパッセージの数。",
        "truncateLabel": "長いコンテキストを切り詰める",
        "truncateHint": "トークン予算に収まるようコンテキストパッセージを制限",
        "maxTokensLabel": "最大コンテキストトークン数",
        "maxTokensHint": "パッセージごとのおおよその単語レベルの切り詰め。"
      },
      "advanced": {
        "sectionTitle": "詳細オプション",
        "warmStartLabel": "メタ学習によるウォームスタート",
        "warmStartHint": "類似する過去の実行からシードする",
        "adversarialLabel": "敵対的ロバスト性テスト",
        "adversarialHint": "摂動を加えた入力でテストし、クリーンスコアと組み合わせる",
        "adversarialWeightLabel": "敵対的重み(0〜1)",
        "adversarialWeightHint": "robust_score = (1 − α)×クリーン + α×敵対的;α が高いほど敵対的要素を重視。",
        "requireApprovalLabel": "保存前に承認を必須にする",
        "requireApprovalHint": "最適化されたプロンプトが新バージョンになる前にレビューする",
        "driftGuardLabel": "意味的ドリフトガード",
        "driftGuardHint": "元の意図から大きく逸脱した候補を拒否する",
        "maxDriftLabel": "最大ドリフト(0〜1)",
        "maxDriftHint": "この値を超えるドリフトの候補は拒否されます。低いほど厳格(例:0.3)。",
        "driftMethodLabel": "ドリフト手法",
        "driftMethodOptions": {
          "jaccard": "Jaccard(トークンベース)",
          "vector": "ベクトル(埋め込みコサイン類似度)"
        },
        "driftMethodHint": "ベクトルドリフトは下記の埋め込みモデルを使用します。Jaccard は語彙ベースのみです。",
        "embeddingModelLabel": "埋め込みモデル",
        "embeddingLoading": "モデルを読み込み中…",
        "embeddingNoModelsHint": "このプロジェクトにアクティブな埋め込みモデルがありません。Jaccard ドリフトを使用するか、Foundation Models でモデルを登録してください。",
        "embeddingPlaceholder": "埋め込みモデルを選択",
        "embeddingRequiredHint": "ドリフト手法がベクトルの場合に必要です(drift_embedding_model_id として保存されます)。",
        "guardrailsLabel": "コンテンツ安全ガードレール",
        "guardrailsHint": "毒性、個人情報、プロンプトインジェクション、またはブランド安全性チェックに失敗した候補を拒否する",
        "guardrailBackendLabel": "ガードレールバックエンド",
        "guardrailBackendOptions": {
          "builtin": "内蔵(パターンベース)",
          "azureContentSafety": "Azure Content Safety",
          "awsBedrock": "AWS Bedrock Guardrails",
          "custom": "カスタム(HTTP エンドポイント)"
        },
        "guardrailBackendHint": "内蔵バックエンドは外部 API なしで個人情報、毒性、脱獄、任意のブランド安全性チェックを実行します。",
        "checksLabel": "実行するチェック",
        "checksHint": "選択したチェックに失敗した候補は評価前に拒否されます。",
        "checkLabels": {
          "piiCheck": "個人情報",
          "toxicity": "毒性",
          "promptInjection": "プロンプトインジェクション",
          "jailbreak": "脱獄",
          "brandSafety": "ブランド安全性",
          "lengthCheck": "長さチェック"
        }
      },
      "parameters": {
        "sectionTitle": "パラメータ",
        "maxIterationsLabel": "最大反復回数",
        "maxIterationsEnsembleLabel": "最大反復回数(サブフレームワークごと)",
        "maxIterationsHint": "高いほど改良が進みますが、実行時間も長くなります",
        "maxIterationsEnsembleHint": "並行実行される各最適化器はこの回数まで反復します(アンサンブルは sub_max_iterations を使用)。",
        "timeBudgetLabel": "時間予算(秒)",
        "timeBudgetHint": "実時間の実行時間の上限(60〜14,400秒)。予算に達すると実行は停止します。",
        "maxCostLabel": "最大コスト(USD、任意)",
        "maxCostPlaceholder": "無制限",
        "maxCostHint": "推定支出上限。超過するとセッションは中止されます。上限なしの場合は空欄にしてください。",
        "targetScoreLabel": "目標スコア(任意)",
        "targetScorePlaceholder": "なし",
        "targetScoreHint": "複合スコアがこの値(0〜1)に達したら早期停止します。反復回数や他の制限まで実行する場合は空欄にしてください。",
        "candidateCountHint": "この最適化器が1反復あたりに生成または評価する候補プロンプトの数。",
        "evalMaxRowsLabel": "評価データセットの最大行数",
        "evalMaxRowsHint": "評価ごとにベンチマークから取得する行数(ベースラインは上限をすべて使用し、内部ループはより少なく使用することがあります)。",
        "rowsPerIterationLabel": "候補評価あたりの行数(任意)",
        "rowsPerIterationPlaceholder": "自動",
        "rowsPerIterationHint": "提案された各プロンプトを評価する際の行数を制限します。空欄の場合は自動(最大行数の約半分、最小5)。",
        "earlyStoppingLabel": "早期停止",
        "patienceHint": "忍耐度(改善のないラウンド数)",
        "candidateLabels": {
          "gepa": "反復あたりの変異体数",
          "ape": "ラウンドあたりの候補数",
          "opro": "反復あたりの提案数",
          "evoprompt": "母集団サイズ",
          "rl_tuning": "反復あたりのロールアウト数"
        }
      },
      "reward": {
        "sectionTitle": "報酬関数(Python)",
        "description": "カスタム報酬関数を定義してください。各評価行を受け取り、[-1, 1] の範囲で報酬シグナルを返します。方策はこの報酬を最大化します。"
      },
      "estimate": {
        "title": "推定リソース",
        "summary": "約 {{calls}} 回の LLM 呼び出し · 約 ${{low}}〜${{high}} USD",
        "monthlyUsed": "月間使用量: ${{used}} / ${{limit}}",
        "acknowledge": "推定コスト(最大 ${{cost}} USD)を承認し、この実行を開始します"
      },
      "start": {
        "button": "{{framework}} 最適化を開始",
        "confirmButton": "確認して開始",
        "changeParams": "パラメータを変更"
      },
      "toast": {
        "selectPrompt": "プロンプトを選択してください",
        "selectVersion": "プロンプトバージョンを選択してください",
        "selectDataset": "ベンチマークデータセットを選択してください",
        "selectResponseModel": "応答モデルを選択するか、少なくとも2つのモデルでマルチモデルを有効にしてください",
        "multiModelMin2": "マルチモデル最適化には少なくとも2つの対象モデルが必要です",
        "dspyExpectedOutput": "DSPy では期待出力カラムを選択してください",
        "vectorDriftEmbedding": "ベクトルドリフトには埋め込みモデルが必要です。または、ドリフト手法を Jaccard に設定してください。",
        "embeddingForMetrics": "選択した指標に対して埋め込みモデルを選択してください。",
        "sqlForMetrics": "選択した Text2SQL 指標に対して実行用データベースを選択してください。",
        "schemaForMetrics": "スキーマ準拠指標には有効な JSON スキーマ定義を指定してください。",
        "ensembleMin2": "アンサンブルには少なくとも2つのサブフレームワークが必要です",
        "unsupportedSubframework": "サポートされていないサブフレームワーク: {{list}}",
        "maxCostInvalid": "最大コスト(USD)は非負の数値である必要があります",
        "targetScoreInvalid": "目標スコアは0から1の間である必要があります",
        "llmCapExceeded": "推定 LLM 呼び出し数({{calls}})がセッションあたりの上限({{cap}})を超えています。反復回数または母集団サイズを減らしてください。",
        "cancelRequested": "最適化実行のキャンセルをリクエストしました",
        "cancelFailed": "最適化実行のキャンセルに失敗しました"
      },
      "running": {
        "title": "「{{name}}」を最適化中",
        "engineLabel": "エンジン:",
        "jobLabel": "ジョブ:",
        "progressLabel": "進捗",
        "statusLabel": "ステータス:",
        "statusStarting": "開始中",
        "iterationSuffix": " · 反復 {{current}}/{{max}}",
        "initializing": "{{engine}} エンジンを初期化中...",
        "loadingDataset": "ベンチマークデータセットを読み込み中",
        "completedIterations": "{{current}}/{{max}} 回の反復が完了",
        "errorPrefix": "エラー: {{message}}",
        "cancelButton": "実行をキャンセル"
      },
      "result": {
        "awaitingApproval": "承認待ち",
        "complete": "最適化完了",
        "cancelled": "最適化はキャンセルされました",
        "failed": "最適化に失敗しました",
        "approvalHint": "最適化されたプロンプトは、新しいバージョンとして保存される前に人による承認が必要です。実行詳細ページでレビューし承認してください。",
        "baseline": "ベースライン",
        "optimized": "最適化後",
        "iterationsSuffix": "反復回数: {{count}}",
        "evaluationsSuffix": " · 評価回数: {{count}}",
        "reviewApprove": "レビューして承認",
        "viewRunDetails": "実行詳細を表示",
        "viewOptimizedVersion": "最適化されたバージョンを表示"
      }
    },
    "runDetail": {
      "pageTitle": "プロンプト最適化",
      "backToRuns": "実行一覧に戻る",
      "backToOptimizationRuns": "最適化実行一覧に戻る",
      "notFound": "最適化実行が見つかりません",
      "loading": "最適化の詳細を読み込んでいます...",
      "status": {
        "completed": "完了",
        "failed": "失敗",
        "cancelled": "キャンセル済み",
        "running": "実行中",
        "queued": "キュー待ち",
        "pending_approval": "承認待ち"
      },
      "approvalBadge": {
        "pending": "承認待ち",
        "approved": "承認済み",
        "rejected": "却下"
      },
      "viewOptimizedPrompt": "最適化されたプロンプトを表示",
      "errorBanner": {
        "title": "最適化に失敗しました"
      },
      "createdAt": "作成日: {{date}}",
      "approval": {
        "reviewTitle": "最適化されたプロンプトのレビュー",
        "reviewSubtitle": "この最適化は、最適化されたプロンプトが新しいバージョンとして保存される前に承認が必要です。",
        "reasonPlaceholder": "承認/却下の理由（任意）...",
        "reject": "却下",
        "approve": "承認して新しいバージョンとして保存",
        "approvedMessage": "プロンプトは承認され、新しいバージョンとして保存されました。",
        "rejectedMessage": "プロンプトは却下されました。新しいバージョンは作成されませんでした。",
        "promptApprovedTitle": "プロンプトが承認されました",
        "promptRejectedTitle": "プロンプトが却下されました",
        "approvedSubtitle": "この最適化されたプロンプトは承認され、新しいバージョンとして保存されました。",
        "rejectedSubtitle": "この最適化されたプロンプトは却下されました。新しいバージョンは作成されませんでした。"
      },
      "diff": {
        "originalPrompt": "元のプロンプト",
        "optimizedPrompt": "最適化されたプロンプト"
      },
      "tabs": {
        "overview": "概要",
        "insights": "インサイト",
        "rowMetrics": "行メトリクス",
        "candidates": "候補",
        "trace": "トレース",
        "abTest": "A/Bテスト",
        "configuration": "構成"
      },
      "metrics": {
        "baselineScore": "ベースラインスコア",
        "optimizedScore": "最適化後スコア",
        "improvement": "改善率",
        "holdoutScore": "ホールドアウトスコア",
        "holdoutSubValue": "ホールドアウトセットでの実際のスコア",
        "iterations": "反復回数",
        "iterationsSubValue": "最大 {{max}} 回中",
        "evaluations": "評価回数",
        "duration": "所要時間",
        "totalTokens": "合計トークン数",
        "tokensSubValue": "プロンプト {{prompt}} / 完了 {{completion}}",
        "estimatedCost": "推定コスト",
        "estimatedCostSubValue": "LLM使用量"
      },
      "orchestrator": {
        "label": "オーケストレーター",
        "openRun": "ワークフロー実行を開く"
      },
      "earlyStopping": {
        "label": "早期停止",
        "completedOf": "設定された {{max}} 回中 {{completed}} 回が完了しました。"
      },
      "perModelScores": {
        "title": "モデル別スコア（モデル非依存の実行）",
        "desc": "上記の集計スコアはこれらのモデル別スコアから算出されています。プロンプトは各基盤モデルで評価されました。"
      },
      "coproDescription": "COPRO: <strong>最大反復回数</strong>の設定は最適化の深さ（{{depth}}）です。各深さで複数の提案プロンプトを評価するため（幅 {{breadth}}）、スコアチャートには{{candidatesTracked}}が表示されます。深さのステップごとに1点というわけではありません。",
      "coproScoredCandidates": "{{count}} 件の採点済み候補",
      "coproOneRowPerCandidate": "採点済み候補ごとに1行",
      "miproDescription": "MIPROv2: <strong>最大反復回数</strong>（{{trials}}）はベイズ最適化の試行回数です。チャートと候補リストは<strong>完全な</strong>検証セットで評価されたプロンプトを示します（ミニバッチのみのプローブは除外）。そのため行数（{{rows}}）は試行回数と異なる場合があります。特にミニバッチが有効な場合です。",
      "scoreChartTitle": "スコアの推移",
      "chartTooltip": "反復 {{iteration}}: {{score}}",
      "chartTooltipBestSuffix": "（ベスト）",
      "insights": {
        "title": "オプティマイザーのインサイト",
        "foundationModel": "基盤モデル",
        "judgeModel": "審査モデル",
        "evalMetrics": "評価メトリクス",
        "mutationModel": "変異モデル",
        "targetScore": "目標スコア",
        "timeBudget": "時間予算",
        "defaultModel": "デフォルト（サーバーデフォルト）"
      },
      "componentsTitle": "最適化されたコンポーネント",
      "rowEvaluations": {
        "title": "行レベルの評価",
        "sourceLabel": "ソース:",
        "source": {
          "optimization_trace": "オプティマイザートレースからの最良ベンチマークパス",
          "final_eval": "データセットに対する最適化後プロンプトの実行後評価",
          "none": "この実行ではデータセット行が評価されませんでした",
          "failed": "行スナップショットを取得できませんでした"
        },
        "metricsConfigured": "設定されたメトリクス: {{metrics}}。",
        "emptyFailed": "オプティマイザーは完了しましたが、行ごとのスコアの保存に失敗しました。サーバーログを確認してください。",
        "emptyNoDataset": "この実行では行レベルのスコアが生成されませんでした（データセットまたは評価行がありません）。",
        "emptyDefault": "このセッションでは行レベルの行が返されませんでした。",
        "columns": {
          "index": "#",
          "input": "入力 / 質問",
          "generatedAnswer": "生成された回答",
          "metrics": "メトリクス",
          "score": "スコア",
          "reasoning": "推論"
        },
        "expectedOutput": "期待される出力"
      },
      "candidates": {
        "title": "候補プロンプト ({{count}})",
        "iteration": "反復 {{iteration}}",
        "candidateLabel": "候補 {{index}}",
        "best": "最良",
        "driftRejected": "ドリフトにより却下",
        "guardrails": "ガードレール",
        "rejectionReason": "却下理由:"
      },
      "trace": {
        "title": "最適化トレース（{{count}} 件のエントリ）",
        "iter": "反復 {{iteration}}"
      },
      "abTest": {
        "dailyTrafficLabel": "予想日次トラフィック（任意）:",
        "dailyTrafficPlaceholder": "例: 10000",
        "generateButton": "A/Bテストを生成",
        "generating": "生成中…",
        "variantsLabel": "バリアント",
        "sampleSizeLabel": "バリアントごとのサンプルサイズ",
        "sampleSizeValue": "{{perVariant}}（合計 {{total}}）",
        "improvementCiLabel": "改善率（信頼区間）",
        "recommendedDurationLabel": "推奨期間",
        "durationDays": "約{{days}}日",
        "durationHours": "約{{hours}}時間",
        "variantPromptsSummary": "バリアントプロンプト",
        "controlLabel": "コントロール (A)",
        "treatmentLabel": "処置群 (B)"
      },
      "metadataLabels": {
        "meta_model": "メタモデル",
        "reflection_model": "リフレクションモデル",
        "stale_rounds": "停滞ラウンド数",
        "population_size": "個体数",
        "gradient_model": "勾配モデル",
        "mutation_model": "変異モデル",
        "gen_model": "生成モデル",
        "policy_model": "ポリシーモデル",
        "optimizer_model": "オプティマイザーモデル",
        "compiler": "DSPyコンパイラ",
        "dspy_version": "DSPyバージョン",
        "dspy_copro": "COPRO（深さ / 幅）",
        "final_avg_reward": "最終平均報酬",
        "baseline_reward": "ベースライン報酬",
        "reward_function": "報酬関数",
        "objectives": "目的",
        "pareto_size": "パレートフロントサイズ",
        "early_stopping_reason": "早期停止",
        "ensemble_frameworks": "アンサンブルサブフレームワーク",
        "fusion_strategy": "融合戦略"
      },
      "frameworkTier": {
        "dspy": "宣言的プログラム最適化",
        "opro": "メタプロンプティング / LLM最適化器",
        "reflexion": "自己反省的リファインメント",
        "gepa": "反省的進化探索",
        "evoprompt": "進化的 + LLM探索",
        "ape": "自動プロンプトエンジニアリング",
        "textgrad": "テキスト逆伝播",
        "rl_tuning": "RLベースのポリシー最適化",
        "rag_aware": "検索拡張の統合最適化",
        "multi_obj": "多目的パレート最適化",
        "ensemble": "マルチフレームワーク融合",
        "cot": "推論構造化プロンプティング"
      }
    },
    "comparison": {
      "backAriaLabel": "戻る",
      "title": "最適化実行の比較",
      "subtitle": "プロンプトを選択し、2つ以上の完了した実行を選んで、軌跡・フレームワーク・最適化された出力を比較します",
      "promptFieldLabel": "プロンプト",
      "promptPlaceholder": "プロンプトを選択...",
      "runsFieldLabel": "最適化実行",
      "runsFilterLabel": "最適化実行",
      "selectPromptFirst": "まずプロンプトを選択してください",
      "loadingRuns": "読み込み中…",
      "noCompletedRuns": "完了した実行がありません",
      "clearSelection": "選択を解除",
      "compareButton": "比較する（{{count}} 件選択中）",
      "selectAtLeastTwo": "比較するには少なくとも2つの実行を選択してください。",
      "genericCompareError": "セッションの比較に失敗しました",
      "scoreTrajectoriesTitle": "スコア推移",
      "yAxisScore": "スコア",
      "xAxisIteration": "反復",
      "summaryTitle": "サマリー",
      "exportCsvTitle": "CSVをエクスポート",
      "columns": {
        "framework": "フレームワーク",
        "original": "オリジナル",
        "optimized": "最適化後",
        "improvement": "改善率",
        "holdout": "ホールドアウト",
        "duration": "所要時間",
        "iterations": "反復回数",
        "actions": "操作"
      },
      "view": "表示",
      "promptComparisonTitle": "プロンプト比較",
      "selectPromptVersion": "プロンプトバージョンを選択...",
      "originalPromptLabel": "オリジナル",
      "optimizedPromptLabel": "最適化後",
      "originalPromptOption": "元のプロンプト",
      "noPromptContent": "（プロンプトの内容はありません）",
      "csv": {
        "sessionId": "セッションID",
        "framework": "フレームワーク",
        "originalScore": "元のスコア",
        "optimizedScore": "最適化後スコア",
        "improvementPct": "改善率 %",
        "holdoutScore": "ホールドアウトスコア",
        "duration": "所要時間",
        "iterations": "反復回数",
        "evaluations": "評価回数"
      }
    },
    "editPage": {
      "backAriaLabel": "プロンプト一覧に戻る",
      "backToPrompts": "プロンプト一覧に戻る",
      "platformTooltip": "コードに組み込まれたシステムプロンプト — 読み取り専用",
      "platformBadge": "プラットフォーム",
      "versionsCount": "{{count}} バージョン",
      "targetModelTooltip": "対象モデル",
      "allModels": "すべてのモデル",
      "changeModelTooltip": "モデルの変更または複製",
      "changeModelHeader": "モデルを変更",
      "modelAgnostic": "モデル非依存（すべてのモデル）",
      "autoSavingAriaLabel": "説明を自動保存しています",
      "autoSaving": "自動保存中...",
      "autoSaveTooltip": "自動保存されるのは説明のみです。プロンプト内容の変更には手動のコミットが必要です。",
      "loadingPrompt": "プロンプトを読み込み中...",
      "notFound": "プロンプトが見つかりません",
      "contentPlaceholder": "プロンプトの内容を入力してください... 状態変数を参照するには {{syntax}} を使用します。",
      "comingSoon": "近日公開...",
      "targetModelLabel": "対象モデル *",
      "selectModelPlaceholder": "モデルを選択...",
      "cloning": "複製中...",
      "tabs": {
        "text": "プロンプトテキスト",
        "diffs": "プロンプトの差分",
        "testing": "プロンプトテスト",
        "evals": "プロンプト評価",
        "metrics": "メトリクス"
      },
      "testing": {
        "title": "プロンプトテスト",
        "description": "さまざまな入力とモデルでプロンプトをテストします"
      },
      "evals": {
        "title": "プロンプト評価",
        "description": "プロンプトのパフォーマンスと品質メトリクスを評価します"
      },
      "metrics": {
        "title": "最適化メトリクス",
        "description": "このバージョンはAI最適化によって作成されました",
        "descriptionWithFramework": "このバージョンはAI最適化（{{framework}}）によって作成されました",
        "baselineScore": "ベースラインスコア",
        "optimizedScore": "最適化後スコア",
        "improvement": "改善率",
        "iterations": "反復回数",
        "evaluations": "評価回数",
        "duration": "所要時間",
        "viewAllRuns": "すべての最適化実行を表示"
      },
      "toast": {
        "retagged": "「{{modelId}}」に再タグ付けしました",
        "setModelAgnostic": "モデル非依存に設定しました",
        "cloned": "「{{modelId}}」用にプロンプトを複製しました",
        "forkedSuccess": "バージョンを正常にフォークしました",
        "noChangesToCommit": "コミットする変更はありません",
        "enterCommitMessage": "コミットメッセージを入力してください",
        "platformReadOnlyFork": "プラットフォームプロンプトは読み取り専用のため、フォークできません",
        "platformReadOnlyModify": "プラットフォームプロンプトは読み取り専用のため、変更できません"
      }
    },
    "playground": {
      "loadingPlayground": "プレイグラウンドを読み込み中...",
      "unableToLoad": "プロンプトを読み込めませんでした。再試行してください。",
      "unableToLoadSessions": "チャットセッションを読み込めませんでした。",
      "headerTitle": "{{name}} — プレイグラウンド",
      "versionOption": "v{{version}}",
      "versionOptionCurrent": "v{{version}}（現在）",
      "selectModelOption": "モデルを選択...",
      "loadingSession": "セッションを読み込み中...",
      "noModelSelected": "モデルが選択されていません",
      "typeMessage": "メッセージを入力...",
      "emptyStateTitleFallback": "プレイグラウンド",
      "emptyStateMessage": "プロンプトのテストを開始してください",
      "noResponseGenerated": "（応答が生成されませんでした）",
      "toast": {
        "noModelsAvailable": "利用可能なモデルがありません",
        "promptNotLoaded": "プロンプトが読み込まれていません",
        "noModelsAvailableAddOne": "利用可能なモデルがありません。先にモデルを追加してください。",
        "switchedModel": "{{name}} に切り替えました",
        "stopBeforeSending": "新しいメッセージを送信する前に、現在の応答を停止してください",
        "uploadAttachmentsFailed": "添付ファイルのアップロードに失敗しました",
        "messageNotFoundForRetry": "再試行するメッセージが見つかりません",
        "noUserMessageToRegenerate": "再生成するユーザーメッセージが見つかりません",
        "cannotRegenerateEmptyContent": "再生成できません：ユーザーメッセージに内容がありません",
        "cannotRetryMessageType": "このメッセージタイプは再試行できません",
        "addAttachmentFailed": "添付ファイルの追加に失敗しました: {{name}}"
      }
    },
    "runsPage": {
      "title": "プロンプト最適化",
      "subtitle": "すべてのプロンプトにわたる最適化実行の履歴",
      "backToPrompts": "プロンプトに戻る",
      "compareRuns": "実行を比較",
      "newOptimization": "新規最適化",
      "loadingMessage": "最適化実行を読み込み中...",
      "emptyMessage": "まだ最適化実行がありません。「新規最適化」をクリックして開始してください。",
      "status": {
        "queued": "待機中",
        "running": "実行中",
        "completed": "完了",
        "failed": "失敗",
        "cancelled": "キャンセル済み"
      },
      "columns": {
        "promptName": "プロンプト名",
        "framework": "フレームワーク",
        "status": "ステータス",
        "metrics": "メトリクス",
        "improvementPct": "改善率 %",
        "cost": "コスト",
        "tokens": "トークン",
        "createdBy": "作成者",
        "createdAt": "作成日時",
        "updatedAt": "更新日時",
        "actions": "アクション"
      },
      "tokensTooltip": "プロンプト: {{prompt}} | 補完: {{completion}}",
      "actions": {
        "retry": "再試行",
        "delete": "削除"
      },
      "retryConfirm": "「{{label}}」に対して、この実行と同じフレームワークとオプションで新しい最適化を開始しますか?",
      "retryDefaultLabel": "このプロンプト",
      "deleteConfirm": "「{{label}}」の最適化セッションを削除しますか? この操作は元に戻せません。",
      "deleteDefaultLabel": "このセッション",
      "toast": {
        "newRunStarted": "新しい最適化実行を開始しました。",
        "retryFailed": "最適化の再試行に失敗しました。",
        "sessionDeleted": "最適化セッションを削除しました。",
        "deleteSessionFailed": "セッションの削除に失敗しました。",
        "bulkDeleteWarning": "{{deleted}} 件の実行を削除しました。{{skipped}} 件は削除できませんでした。{{detail}}",
        "bulkDeleteSuccess_other": "{{count}} 件の最適化実行を削除しました。",
        "bulkDeleteFailed": "選択した最適化実行の削除に失敗しました。"
      },
      "bulkDelete": {
        "selectedLabel": "選択項目を削除",
        "title": "選択した実行を削除",
        "message_other": "{{count}} 件の最適化実行を削除しますか? この操作は元に戻せません。",
        "confirmLabel_other": "{{count}} 件を削除"
      }
    },
    "optimizationLogModal": {
      "title": {
        "complete": "最適化完了",
        "cancelled": "最適化がキャンセルされました",
        "failed": "最適化に失敗しました",
        "running": "最適化中..."
      },
      "subtitleDefault": "プロンプト",
      "closeAriaLabel": "閉じる",
      "progressLabel": "進行状況",
      "statusLabel": "ステータス:",
      "statusStarting": "開始中",
      "iterationSuffix": " · イテレーション {{iteration}}/{{max}}",
      "bestSuffix": " · ベスト: {{value}}",
      "runIdLabel": "実行ID:",
      "jobIdLabel": "ジョブID:",
      "initializingEngine": "{{framework}} エンジンを初期化中...",
      "loadingDataset": "ベンチマークデータセットを読み込み中",
      "completedIterations": "{{completed}}/{{max}} イテレーションが完了しました",
      "cancelRun": "実行をキャンセル",
      "viewResults": "結果を表示"
    },
    "commitMessageModal": {
      "title": "バージョンをコミット",
      "closeAriaLabel": "閉じる",
      "description": "このバージョンの変更内容を説明するコミットメッセージを入力してください。",
      "placeholder": "例: プロンプトの誤字を修正、新しい例を追加...",
      "commit": "コミット",
      "committing": "コミット中..."
    },
    "diffView": {
      "noVersionsTitle": "比較するバージョンがありません",
      "noVersionsDesc": "バージョンを追加で作成すると、その差分を確認できます。",
      "baseLabel": "ベース:",
      "compareLabel": "比較:",
      "swapTooltip": "ベースと比較を入れ替え",
      "fileLabel": "prompt.txt",
      "collapseContextTooltip": "コンテキストを折りたたむ",
      "expandContextTooltip": "コンテキストを展開",
      "copyDiffTooltip": "差分をコピー",
      "loadingDiff": "差分を読み込み中...",
      "expandHiddenLines": "非表示の {{count}} 行を表示",
      "sameVersionTitle": "同じバージョンが選択されています",
      "sameVersionDesc": "異なるバージョンを選択して差分を確認してください。",
      "noDifferencesTitle": "差分なし",
      "noDifferencesDesc": "これらのバージョンは同一です。",
      "toast": {
        "copied": "差分をクリップボードにコピーしました"
      }
    },
    "versionList": {
      "title": "バージョン",
      "refreshTooltip": "バージョンを更新",
      "searchPlaceholder": "バージョンを検索...",
      "emptyMessage": "バージョンが見つかりません"
    },
    "versionItem": {
      "commitTooltip": "バージョンをコミット",
      "commitLabel": "コミット",
      "forkTooltip": "バージョン {{version}} をフォーク",
      "forkLabel": "フォーク",
      "createdByPrefix": "作成者: {{name}}",
      "wordCount_other": "{{count}} 語"
    },
    "visibilitySelector": {
      "label": "公開範囲",
      "platformDescription": "プラットフォーム内のすべてのプロジェクトで利用可能",
      "projectDescription": "選択したプロジェクト内でのみ利用可能",
      "platformHint": "このプロンプトはプラットフォーム内のすべてのプロジェクトで利用できます。",
      "projectHint": "このプロンプトは選択したプロジェクト内でのみ利用できます。",
      "projectLabel": "プロジェクト",
      "selectProjectPlaceholder": "プロジェクトを選択",
      "searchProjectsPlaceholder": "プロジェクトを検索..."
    }
  },
  "data": {
    "tabs": {
      "knowledge": "ナレッジ",
      "graph": "グラフ",
      "vector": "ベクトルDB",
      "storage": "ストレージ"
    }
  },
  "knowledge": {
    "connections": {
      "tabs": {
        "databases": "データベース",
        "storage": "ストレージアカウント",
        "orchestrators": "オーケストレーター",
        "telephony": "テレフォニー"
      }
    },
    "connectorsTab": {
      "testErrorToast": "接続テストに失敗しました",
      "batchTestSuccessToast_one": "インポートした{{count}}件の接続の接続テストに成功しました",
      "batchTestSuccessToast_other": "インポートした{{count}}件の接続の接続テストに成功しました",
      "batchTestFailedToast_one": "インポートした{{count}}件の接続の接続テストに失敗しました",
      "batchTestFailedToast_other": "インポートした{{count}}件の接続の接続テストに失敗しました",
      "batchTestFinishedToast": "接続テストが完了しました: 成功{{success}}件、失敗{{fail}}件",
      "loadErrorToast": "コネクタの読み込みに失敗しました",
      "loadingMessage": "接続を読み込み中...",
      "filterResourceLabel": {
        "database": "データベースエンジン",
        "storage": "ストレージタイプ",
        "orchestrator": "オーケストレータータイプ",
        "telephony": "テレフォニータイプ"
      },
      "filterAllTypesPlaceholder": "すべてのタイプ",
      "filterCreatorLabel": "作成者",
      "filterAllCreatorsPlaceholder": "すべての作成者",
      "filterStatusLabel": "ステータス",
      "filterAllStatusesPlaceholder": "すべてのステータス",
      "filterStatusError": "エラー",
      "deletePermissionDeniedToast": "このコネクタを削除する権限がありません",
      "deleteErrorToast": "コネクタの削除に失敗しました",
      "bulkDeletePermissionDeniedToast": "コネクタを削除する権限がありません",
      "bulkDeletePartialWarning": "{{deleted}}件のコネクタを削除、{{skipped}}件が失敗しました: {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}}件のコネクタを削除しました",
      "bulkDeleteSuccessToast_other": "{{count}}件のコネクタを削除しました",
      "bulkDeleteErrorToast": "コネクタの削除に失敗しました",
      "unsetDefaultToast": "{{name}}はデフォルトの{{category}}ではなくなりました",
      "setDefaultToast": "{{name}}がデフォルトの{{category}}になりました",
      "unsetDefaultErrorToast": "デフォルトの{{category}}の解除に失敗しました",
      "setDefaultErrorToast": "デフォルトの{{category}}の設定に失敗しました",
      "status": {
        "active": "アクティブ",
        "failed": "失敗",
        "notTested": "未テスト",
        "unknown": "不明"
      },
      "statusTooltip": "ステータス: {{status}}",
      "authModeTooltip": "認証: {{mode}}",
      "columnName": "名前",
      "columnCloud": "クラウド",
      "columnResource": "リソース",
      "columnType": "タイプ",
      "columnHost": "ホスト",
      "columnStatus": "ステータス",
      "columnLastTested": "最終テスト",
      "columnCreatedBy": "作成者",
      "columnUpdatedBy": "更新者",
      "columnActions": "アクション",
      "actionView": "表示",
      "actionTestConnection": "接続テスト",
      "actionRemoveAsDefault": "デフォルトの{{category}}を解除",
      "actionSetAsDefault": "デフォルトに設定",
      "actionExport": "エクスポート",
      "actionEdit": "編集",
      "actionDelete": "削除",
      "entityFilterAllLabel": "すべて",
      "entityFilterFavoritesLabel": "お気に入り",
      "bulkExportSelected": "選択項目をエクスポート",
      "bulkDeleteSelected": "選択項目を削除",
      "emptyMessage": "コネクタが見つかりません。データベース、ストレージ、またはその他のデータソースに接続するには、接続を追加してください。",
      "addConnection": "接続を追加",
      "deleteDialogTitle": "コネクタを削除",
      "deleteDialogMessage": "「{{name}}」を削除してもよろしいですか?このコネクタに登録されているすべてのテーブルも削除されます。",
      "deleteDialogConfirmLabel": "削除",
      "bulkDeleteDialogTitle": "選択したコネクタを削除",
      "bulkDeleteDialogMessage_one": "{{count}}件のコネクタを削除してもよろしいですか?これらのコネクタに登録されているすべてのテーブルも削除されます。この操作は元に戻せません。",
      "bulkDeleteDialogMessage_other": "{{count}}件のコネクタを削除してもよろしいですか?これらのコネクタに登録されているすべてのテーブルも削除されます。この操作は元に戻せません。",
      "bulkDeleteDialogConfirmLabel_one": "{{count}}件のコネクタを削除",
      "bulkDeleteDialogConfirmLabel_other": "{{count}}件のコネクタを削除"
    },
    "tab": {
      "unknownConnectorType": "不明",
      "filterEngineLabel": "データベースエンジン",
      "filterAllEnginesPlaceholder": "すべてのエンジン",
      "filterCreatorLabel": "作成者",
      "filterAllCreatorsPlaceholder": "すべての作成者",
      "deleteErrorToast": "ナレッジテーブルの削除に失敗しました",
      "bulkDeletePartialWarning": "{{deleted}}件のテーブルを削除、{{skipped}}件が失敗しました: {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}}件のテーブルを削除しました",
      "bulkDeleteSuccessToast_other": "{{count}}件のテーブルを削除しました",
      "bulkDeleteErrorToast": "テーブルの削除に失敗しました",
      "deleteSchemaErrorToast": "スキーマの削除に失敗しました",
      "deleteSchemaPartialWarning": "{{schemaCount}}件のスキーマにわたり{{deleted}}件のテーブルを削除、{{skipped}}件が失敗しました",
      "deleteSchemaSuccessToast_one": "スキーマを削除しました({{count}}件のテーブル)",
      "deleteSchemaSuccessToast_other": "スキーマを削除しました({{count}}件のテーブル)",
      "deleteSchemaSuccessToastNamed_one": "スキーマ「{{schema}}」を削除しました({{count}}件のテーブル)",
      "deleteSchemaSuccessToastNamed_other": "スキーマ「{{schema}}」を削除しました({{count}}件のテーブル)",
      "deleteSchemasSuccessToast_one": "{{schemaCount}}件のスキーマを削除しました({{count}}件のテーブル)",
      "deleteSchemasSuccessToast_other": "{{schemaCount}}件のスキーマを削除しました({{count}}件のテーブル)",
      "syncRequeuedToast": "「{{name}}」のメタデータ同期を再登録しました(停止していました)",
      "syncQueuedToast": "「{{name}}」のメタデータ同期をキューに登録しました",
      "syncQueueErrorToast": "「{{name}}」のメタデータ同期のキュー登録に失敗しました",
      "bulkSyncStartedRequeuedToast_one": "{{count}}件のテーブルのメタデータ同期を開始しました(停止していたインスペクションを再登録)",
      "bulkSyncStartedRequeuedToast_other": "{{count}}件のテーブルのメタデータ同期を開始しました(停止していたインスペクションを再登録)",
      "bulkSyncStartedToast_one": "{{count}}件のテーブルのメタデータ同期を開始しました",
      "bulkSyncStartedToast_other": "{{count}}件のテーブルのメタデータ同期を開始しました",
      "bulkSyncStartErrorToast": "一括メタデータ同期の開始に失敗しました",
      "columnName": "名前",
      "defaultBadgeTooltip": "デフォルト",
      "schemaTooltip": "スキーマ: {{schema}}",
      "columnDatabase": "データベース",
      "columnType": "タイプ",
      "columnRows": "行数",
      "columnIntrospection": "インスペクション",
      "syncStatus": {
        "queued": "キュー待ち",
        "running": "実行中",
        "synced": "同期済み",
        "failed": "失敗",
        "active": "アクティブ"
      },
      "viewSyncLogsTooltip": "同期ログを表示",
      "columnStatus": "ステータス",
      "columnCreated": "作成日",
      "columnUpdated": "更新日",
      "columnCreator": "作成者",
      "unknownCreator": "不明",
      "columnLogs": "ログ",
      "viewLink": "表示",
      "columnActions": "アクション",
      "actionViewDetails": "詳細を表示",
      "actionPreviewData": "データをプレビュー",
      "actionApprovals": "承認",
      "actionEvals": "評価",
      "actionEdit": "編集",
      "actionRequeueSync": "メタデータ同期を再登録",
      "actionSyncMetadata": "メタデータを同期",
      "actionExport": "エクスポート",
      "actionDelete": "削除",
      "databaseViewLabel": "データベース表示",
      "collectionViewLabel": "コレクション表示",
      "addGraphTable": "グラフテーブルを追加",
      "addKnowledgeTable": "ナレッジテーブルを追加",
      "leafTitleTables": "テーブル",
      "leafTitleGraphTables": "グラフテーブル",
      "defaultSchemaLabel": "(デフォルト)",
      "entityFilterAllLabel": "すべて",
      "entityFilterFavoritesLabel": "お気に入り",
      "noGraphConnectorsEmptyMessage": "グラフDBコネクタはまだありません。",
      "noDataConnectorsEmptyMessage": "データコネクタはまだありません。",
      "schemasPaneTitle": "スキーマ",
      "bulkExportSelected": "選択項目をエクスポート",
      "bulkSyncMetadata": "メタデータを同期",
      "bulkDeleteSelected": "選択項目を削除",
      "graphDataExplorerAriaLabel": "グラフデータエクスプローラー",
      "knowledgeDataExplorerAriaLabel": "ナレッジデータエクスプローラー",
      "deleteDialogTitle": "ナレッジテーブルを削除",
      "deleteDialogMessage": "「{{name}}」を削除してもよろしいですか?この操作は元に戻せません。",
      "deleteDialogConfirmLabel": "削除",
      "deleteSchemaDialogTitle": "スキーマを削除",
      "deleteSchemasDialogTitle": "スキーマを削除",
      "deleteSchemaDialogMessage_one": "スキーマ「{{schema}}」とその中の登録済みテーブル{{count}}件をすべて削除してもよろしいですか?これは{{brand}}のメタデータのみを削除し、元に戻せません。",
      "deleteSchemaDialogMessage_other": "スキーマ「{{schema}}」とその中の登録済みテーブル{{count}}件をすべて削除してもよろしいですか?これは{{brand}}のメタデータのみを削除し、元に戻せません。",
      "deleteSchemasDialogMessage_one": "{{schemaCount}}件のスキーマとその中の登録済みテーブル{{count}}件をすべて削除してもよろしいですか?これは{{brand}}のメタデータのみを削除し、元に戻せません。",
      "deleteSchemasDialogMessage_other": "{{schemaCount}}件のスキーマとその中の登録済みテーブル{{count}}件をすべて削除してもよろしいですか?これは{{brand}}のメタデータのみを削除し、元に戻せません。",
      "deletingLabel": "削除中…",
      "deleteSchemasDialogConfirmLabel": "{{count}}件のスキーマを削除",
      "andOthersLabel": "{{names}} 他{{count}}件",
      "bulkDeleteDialogTitle": "選択したテーブルを削除",
      "bulkDeleteDialogMessage_one": "{{count}}件のテーブルを削除してもよろしいですか?この操作は元に戻せません。",
      "bulkDeleteDialogMessage_other": "{{count}}件のテーブルを削除してもよろしいですか?この操作は元に戻せません。",
      "bulkDeleteDialogConfirmLabel_one": "{{count}}件のテーブルを削除",
      "bulkDeleteDialogConfirmLabel_other": "{{count}}件のテーブルを削除",
      "emptyStatePermissionDenied": "{{resource}}を表示する権限がありません。管理者にお問い合わせください。",
      "emptyStateSearching": "検索条件に一致する{{resource}}が見つかりません。",
      "emptyStateDefault": "{{resource}}が見つかりません。最初の{{resourceSingular}}を作成して開始してください。",
      "resourceGraphTables": "グラフテーブル",
      "resourceGraphTable": "グラフテーブル",
      "resourceKnowledgeTables": "ナレッジテーブル",
      "resourceKnowledgeTable": "ナレッジテーブル"
    },
    "addTableModal": {
      "title": "ナレッジテーブルを追加",
      "closeDialogAriaLabel": "ダイアログを閉じる",
      "cancelButton": "キャンセル",
      "loadConnectorsError": "コネクタの読み込みに失敗しました",
      "noDatabasesFoundWarning": "データベースが見つかりません。コネクタがデータベースにアクセスできない可能性があります。",
      "loadTablesTimedOut": "テーブルの読み込みがタイムアウトしました。範囲を狭めるか、接続を確認してください。",
      "loadTablesForSchemaError": "スキーマのテーブルの読み込みに失敗しました",
      "loadingTablesForSchema": "{{schema}} のテーブルを読み込み中...",
      "schemaFallbackLabel": "スキーマ",
      "inlineSearch": {
        "defaultPlaceholder": "検索",
        "clearAriaLabel": "検索をクリア"
      },
      "breadcrumb": {
        "backAriaLabel": "戻る",
        "schemasCount_one": "{{count}} スキーマ",
        "schemasCount_other": "{{count}} スキーマ"
      },
      "connectorSelection": {
        "emptyTitle": "コネクタがありません",
        "emptyMessage": "ナレッジテーブルを追加するには、まずコネクタを作成してください",
        "filterByTypeLabel": "コネクタタイプで絞り込み",
        "connectorTypeLabel": "コネクタタイプ",
        "allConnectorTypesPlaceholder": "すべてのコネクタタイプ ({{count}})",
        "searchPlaceholder": "コネクタを検索",
        "noMatchingConnections": "一致する接続がありません。検索条件を調整するか、別のコネクタタイプを選択してください。"
      },
      "databaseSelection": {
        "loadingCatalog": "カタログを読み込み中…",
        "catalogUnavailableTitle": "カタログを利用できません",
        "catalogUnavailableMessage": "カタログを読み込めませんでした。コネクタの設定を確認して再試行してください。",
        "noDatabasesTitle": "データベースが見つかりません",
        "noDatabasesMessage": "コネクタがどのデータベースにもアクセスできないか、内省処理が失敗しました。",
        "title": "データベースを選択",
        "countLabel_one": "{{count}} 件中 {{shown}} 件のデータベース",
        "countLabel_other": "{{count}} 件中 {{shown}} 件のデータベース",
        "searchPlaceholder": "データベースを検索",
        "noMatchMessage": "検索条件に一致するデータベースがありません。",
        "schemaCount_one": "{{count}} スキーマ",
        "schemaCount_other": "{{count}} スキーマ"
      },
      "schemaSelection": {
        "title": "スキーマを選択",
        "countLabel_one": "{{count}} 件中 {{shown}} 件のスキーマ",
        "countLabel_other": "{{count}} 件中 {{shown}} 件のスキーマ",
        "selectedCount": "{{count}} 件選択中",
        "deselectAll": "すべて選択解除",
        "selectAll": "すべて選択",
        "continueWith_one": "{{count}} 件のスキーマで続行",
        "continueWith_other": "{{count}} 件のスキーマで続行",
        "searchPlaceholder": "スキーマを検索",
        "hint": "スキーマにチェックして「続行」をクリックすると1つずつ参照できます。または、カードをクリックして1つのスキーマを開きます。",
        "noMatchMessage": "検索条件に一致するスキーマがありません。",
        "selectSchemaAriaLabel": "スキーマ {{schema}} を選択",
        "tableCount_one": "{{count}} テーブル",
        "tableCount_other": "{{count}} テーブル",
        "clickToLoadTables": "クリックしてテーブルを読み込む"
      },
      "tableSelection": {
        "loadingTables": "テーブルを読み込み中…",
        "noTablesFoundTitle": "テーブルが見つかりません",
        "noTablesInSchema": "このスキーマには利用可能なテーブルがありません",
        "noTablesInDatabase": "このデータベースには利用可能なテーブルがありません",
        "hint": "テーブルは開いているスキーマのみ読み込まれます。行をクリックするか、ヘッダーのチェックボックスを使用して選択してください。",
        "searchPlaceholder": "テーブルを検索",
        "showingCount": "{{count}} 件中 {{shown}} 件を表示中",
        "selectedAcrossSchemas": "スキーマ全体で {{count}} 件選択中",
        "deselectAllAriaLabel": "すべてのテーブルを選択解除",
        "selectAllAriaLabel": "すべてのテーブルを選択",
        "columnTable": "テーブル",
        "columnDatabase": "データベース",
        "columnRows": "行数",
        "columnCols": "列数",
        "noMatchMessage": "検索条件に一致するテーブルがありません。",
        "selectTableAriaLabel": "{{label}} を選択",
        "updateAvailableTooltip": "新しいノード/ラベルが利用可能です",
        "updateAvailableBadge": "更新あり",
        "alreadyRegisteredTooltip": "このテーブルは既に登録済みです",
        "registeredBadge": "登録済み"
      },
      "registrationStep": {
        "loadingTables": "テーブルを読み込み中…",
        "selectedSchemasAriaLabel": "選択したスキーマ",
        "multiGraphRegistrationLabel": "マルチグラフ登録:",
        "multiGraphRegistrationTextPrefix": "選択した各",
        "multiGraphRegistrationTextSuffix": "行は、そのグラフのナレッジアセットとして登録されます。",
        "graphSchemaRegistrationLabel": "グラフスキーマ登録:",
        "graphSchemaRegistrationText": "選択したグラフテーブルは、1つのグラフスキーマエントリとして登録されます。",
        "relationshipTypesDetected_one": "{{count}} 件のリレーションシップタイプを検出しました。",
        "relationshipTypesDetected_other": "{{count}} 件のリレーションシップタイプを検出しました。",
        "finalizeAndRegisterTitle": "確定して登録",
        "subtitleRegisterPrefix": "登録:",
        "subtitleChoosePrefix": "このナレッジの使用方法を選択してから、登録:",
        "subtitleGraphSchemaSuffix_one": "グラフテーブルを1つのグラフスキーマエントリとして。",
        "subtitleGraphSchemaSuffix_other": "グラフテーブルを1つのグラフスキーマエントリとして。",
        "subtitleGraphsSuffix_one": "グラフを1ステップで。",
        "subtitleGraphsSuffix_other": "グラフを1ステップで。",
        "subtitleGraphTablesSuffix_one": "グラフテーブルを1ステップで。",
        "subtitleGraphTablesSuffix_other": "グラフテーブルを1ステップで。",
        "subtitleTablesSuffix_one": "テーブルを1ステップで。",
        "subtitleTablesSuffix_other": "テーブルを1ステップで。",
        "selectGraphTablesAbove": "上でグラフテーブルを選択してください",
        "selectGraphsAbove": "上でグラフを選択してください",
        "selectTablesAbove": "上でテーブルを選択してください",
        "registerGraphSchema_one": "グラフスキーマを登録 ({{count}} 件のグラフテーブル)",
        "registerGraphSchema_other": "グラフスキーマを登録 ({{count}} 件のグラフテーブル)",
        "registerGraphs_one": "{{count}} 件のグラフを登録",
        "registerGraphs_other": "{{count}} 件のグラフを登録",
        "registerGraphTables_one": "{{count}} 件のグラフテーブルを登録",
        "registerGraphTables_other": "{{count}} 件のグラフテーブルを登録",
        "registerTables_one": "{{count}} 件のテーブルを登録",
        "registerTables_other": "{{count}} 件のテーブルを登録"
      },
      "introspectionError": {
        "thisConnection": "この接続",
        "timedOut": "{{name}} の応答に時間がかかりすぎました。",
        "forbidden": "{{name}} を参照する権限がありません。プロジェクト管理者に確認してください。",
        "credentialsRejected": "{{name}} が保存された認証情報を拒否しました。",
        "missingSecret": "{{name}} にパスワードまたはシークレットが設定されていません。",
        "databaseNotFound": "{{name}} に保存されたデータベースまたはカタログはもう存在しません。",
        "hostUnreachable": "{{name}} に設定されたホストに到達できません。",
        "serviceBusy": "{{name}} は現在混み合っています。",
        "notConnecting": "{{name}} が接続していません。",
        "genericFailure": "{{name}} からカタログを読み込めませんでした。",
        "validateInConnections": "接続で検証",
        "tryAgain": "再試行"
      }
    },
    "editModal": {
      "title": "ナレッジテーブルを編集",
      "closeDialogAriaLabel": "ダイアログを閉じる",
      "vectorDbBadge": "ベクトルDB",
      "displayNameLabel": "表示名",
      "displayNamePlaceholder": "表示名を入力",
      "nameAlreadyExistsToast": "この名前のナレッジテーブルは既に存在します",
      "descriptionLabel": "説明",
      "descriptionPlaceholder": "説明を入力(任意)",
      "knowledgeTypeLabel": "ナレッジタイプ",
      "knowledgeTypeData": "データ",
      "knowledgeTypeDataHint": "= 一般的なナレッジ。",
      "knowledgeTypeBenchmarks": "ベンチマーク",
      "knowledgeTypeBenchmarksFull": "ベンチマーク(評価とシミュレーション)",
      "knowledgeTypeBenchmarksHint": "= 評価とシミュレーションに表示されます。",
      "knowledgeTypePlaceholder": "ナレッジタイプを選択...",
      "benchmarkTypeLabel": "ベンチマークタイプ",
      "benchmarkTypeHint": "ベンチマークタブに表示されるワークロードカテゴリ(Text2SQL、RAG、ツール利用など)。",
      "benchmarkTypePlaceholder": "ベンチマークタイプを選択…",
      "benchmarkIconLabel": "ベンチマークアイコン",
      "benchmarkIconHint": "評価とシミュレーションのベンチマークカードに表示されます。画像が設定されていない場合はコネクタアイコンが使用されます。",
      "embeddingModelLabel": "埋め込みモデル",
      "embeddingModelHint": "このテーブルでベクトルを作成するために使用する埋め込みモデルを選択してください。",
      "embeddingModelPlaceholder": "埋め込みモデルを選択...",
      "searchModelsPlaceholder": "モデルを検索...",
      "loadingModelsMessage": "埋め込みモデルを読み込み中...",
      "noModelsRegisteredMessage": "登録済みの埋め込みモデルがありません。先に埋め込みモデルを登録してください。",
      "noModelSelectedWarning": "埋め込みモデルが選択されていません。ベクトル検索が失敗するか、誤った結果が返される可能性があります。",
      "defaultBadge": "デフォルト",
      "loadModelsErrorToast": "埋め込みモデルの読み込みに失敗しました",
      "updateErrorToast": "ナレッジテーブルの更新に失敗しました",
      "cancelButton": "キャンセル",
      "savingButton": "保存中...",
      "saveChangesButton": "変更を保存"
    },
    "modal": {
      "title": "ナレッジベース用のテーブルを登録",
      "closeDialogAriaLabel": "ダイアログを閉じる",
      "registeringTooltip_one": "{{name}}から{{count}}件のテーブルを登録しています",
      "registeringTooltip_other": "{{name}}から{{count}}件のテーブルを登録しています",
      "registeringText_one": "{{name}}から{{count}}件のテーブルを登録しています",
      "registeringText_other": "{{name}}から{{count}}件のテーブルを登録しています",
      "registerSubmitLabel_one": "{{count}}件のテーブルを登録",
      "registerSubmitLabel_other": "{{count}}件のテーブルを登録",
      "tablesToRegisterLabel": "登録するテーブル",
      "columnsCount_one": "{{count}}列",
      "columnsCount_other": "{{count}}列",
      "rowsCount_one": "{{formattedCount}}行",
      "rowsCount_other": "{{formattedCount}}行",
      "columnsHeader": "列",
      "notNullBadge": "NOT NULL",
      "cancelButton": "キャンセル"
    },
    "viewModal": {
      "title": "ナレッジテーブルの詳細",
      "closeDialogAriaLabel": "ダイアログを閉じる",
      "closeButton": "閉じる",
      "notAvailable": "N/A",
      "yesLabel": "はい",
      "noLabel": "いいえ",
      "noneDetectedMessage": "検出されませんでした",
      "statusUnknown": "不明",
      "statusActive": "有効",
      "statusError": "エラー",
      "statusSyncing": "同期中",
      "noErrorsMessage": "エラーはありません",
      "noColumnInfoMessage": "列情報がありません",
      "basicInformationHeader": "基本情報",
      "tableInformationHeader": "テーブル情報",
      "graphInformationHeader": "グラフ情報",
      "embeddingModelHeader": "埋め込みモデル",
      "columnsHeader": "列",
      "errorInformationHeader": "エラー情報",
      "metadataHeader": "メタデータ",
      "auditInformationHeader": "監査情報",
      "fieldId": "ID",
      "fieldConnector": "コネクタ",
      "fieldStatus": "ステータス",
      "fieldDatabase": "データベース",
      "fieldSchema": "スキーマ",
      "fieldTableName": "テーブル名",
      "fieldRowCountNodes": "行数(ノード)",
      "fieldTotalNodes": "ノード合計",
      "fieldTotalEdges": "エッジ合計",
      "fieldRelationshipTypes": "リレーションシップタイプ",
      "fieldNodeLabels": "ノードラベル",
      "fieldModel": "モデル",
      "fieldErrorMessage": "エラーメッセージ",
      "fieldCreatedAt": "作成日時",
      "fieldUpdatedAt": "更新日時",
      "fieldCreatedBy": "作成者",
      "fieldUpdatedBy": "更新者",
      "noEmbeddingModelConfiguredTitle": "埋め込みモデルが設定されていません",
      "noEmbeddingModelConfiguredHint": "ベクトル検索が失敗するか、誤った結果が返される可能性があります。保存されているベクトルの作成に使用したものと一致する埋め込みモデルを割り当てるには、このテーブルを編集してください。",
      "columnName": "名前",
      "columnType": "タイプ",
      "columnNullable": "NULL許可"
    },
    "registerFields": {
      "embeddingModelLabel": "埋め込みモデル",
      "embeddingModelHint": "これらのベクトルテーブルでのセマンティック検索に使用するモデル。",
      "loadingModelsMessage": "埋め込みモデルを読み込み中…",
      "noModelsRegisteredMessage": "登録済みの埋め込みモデルがありません。先に1つ登録してください。",
      "selectEmbeddingModelOption": "— 埋め込みモデルを選択 —",
      "defaultBadge": "デフォルト",
      "managedVectorDbHint": "このコネクタはインデックスと埋め込みを内部で管理するため、列のマッピングは不要です。選択した埋め込みモデルは、検索クエリを埋め込む際にクエリ実行時に使用されます。",
      "columnMappingLabel": "列のマッピング",
      "columnMappingHint": "ベクトル検索のためにID、コンテンツ、埋め込みの各列をマッピングしてください。",
      "columnLabelId": "ID",
      "columnLabelContent": "コンテンツ",
      "columnLabelEmbedding": "埋め込み",
      "columnFieldLabel": "{{column}}列",
      "selectOption": "— 選択 —",
      "vectorSuffix": "ベクトル",
      "knowledgePurposeLabel": "ナレッジの用途",
      "knowledgeTypeData": "データ",
      "knowledgeTypeDataHint": "一般的なRAG用。",
      "knowledgeTypeBenchmarks": "ベンチマーク",
      "knowledgeTypeBenchmarksHint": "評価とシミュレーションでこのデータを表示します。",
      "knowledgeTypeGroupAriaLabel": "ナレッジタイプ",
      "encryptDataLabel": "閲覧者向けにテーブルデータを保存時に暗号化する",
      "encryptDataHint": "作成者のみが平文の値を確認できます。他の人には暗号文が表示されます。ツールのシークレットと同じキーを使用します。",
      "selectEmbeddingModelTooltip": "埋め込みモデルを選択してください",
      "mapColumnsTooltip": "ID、コンテンツ、埋め込みの各列をマッピングしてください",
      "registeringButton": "登録中…"
    },
    "groupedView": {
      "loadingMessage": "テーブルを読み込み中...",
      "emptyMessage": "ナレッジテーブルが見つかりません",
      "emptySearchHint": "検索条件を変更してみてください",
      "tableCount_one": "{{count}}件のテーブル",
      "tableCount_other": "{{count}}件のテーブル",
      "rowsCount_one": "{{formattedCount}}行",
      "rowsCount_other": "{{formattedCount}}行",
      "vectorDbTooltip": "ベクトルデータベース",
      "vectorDbBadge": "ベクトルDB",
      "createdTooltip": "作成日時",
      "updatedTooltip": "更新日時",
      "statusUnknown": "不明",
      "statusError": "エラー",
      "statusActive": "有効",
      "statusSyncing": "同期中",
      "actionViewDetails": "詳細を表示",
      "actionPreviewData": "データをプレビュー",
      "actionEdit": "編集",
      "actionVectorSearch": "ベクトル検索",
      "actionSync": "同期",
      "actionManageAccess": "アクセスを管理",
      "actionDelete": "削除"
    },
    "addStorageFolderModal": {
      "title": "ストレージフォルダを追加",
      "closeDialogAriaLabel": "ダイアログを閉じる",
      "selectConnectorTitle": "ストレージコネクタを選択",
      "noConnectorsFoundMessage": "ストレージコネクタが見つかりません。先にストレージコネクタを作成してください。",
      "searchConnectorsPlaceholder": "コネクタを検索",
      "countOf": "{{count}} 件中 {{shown}} 件",
      "noConnectorsMatchFilters": "フィルターに一致するコネクタがありません。",
      "connectorTypeLabel": "コネクタタイプ",
      "allConnectorTypesPlaceholder": "すべてのコネクタタイプ ({{count}})",
      "selectBucketTitle": "バケットを選択",
      "noBucketsFoundMessage": "バケットが見つかりません。",
      "searchBucketsPlaceholder": "バケットを検索",
      "noBucketsMatchSearch": "検索に一致するバケットがありません。",
      "selectFoldersTitle": "フォルダを選択",
      "selectAllButton": "すべて選択",
      "deselectAllButton": "すべて選択解除",
      "searchFoldersPlaceholder": "フォルダを検索",
      "fileCount_one": "{{count}} 件のファイル",
      "fileCount_other": "{{count}} 件のファイル",
      "openSubfolderTooltip": "サブフォルダを開く",
      "noFoldersMatchSearch": "検索に一致するフォルダがありません。",
      "noSubfoldersMessage": "サブフォルダがありません。ファイルが含まれている場合は、このフォルダパスを登録できます。",
      "noFoldersInBucketMessage": "このバケットにフォルダが見つかりません。",
      "selectFolderButton": "フォルダ「{{name}}」を選択",
      "selectedFoldersCount_one": "{{count}} 件のフォルダを選択中",
      "selectedFoldersCount_other": "{{count}} 件のフォルダを選択中",
      "cancelButton": "キャンセル",
      "registeringButton": "登録中...",
      "registerFoldersButton_one": "{{count}} 件のフォルダを登録",
      "registerFoldersButton_other": "{{count}} 件のフォルダを登録",
      "registerSuccessToast_one": "{{count}} 件のストレージフォルダを登録しました",
      "registerSuccessToast_other": "{{count}} 件のストレージフォルダを登録しました"
    },
    "splitView": {
      "storageBucketPane": {
        "title": "バケット",
        "columnBucket": "バケット",
        "columnFolders": "フォルダ",
        "defaultBucketLabel": "（デフォルト）",
        "searchPlaceholder": "バケットを検索…",
        "emptyMessage": "登録されたバケットがありません。",
        "emptySearchMessage": "この検索に一致するバケットがありません。",
        "loadErrorMessage": "バケットの読み込みに失敗しました"
      },
      "connectorPane": {
        "columnCreatedAt": "作成日時",
        "columnDatabase": "タイプ",
        "columnName": "名前",
        "columnStatus": "ステータス",
        "columnUpdatedAt": "更新日時",
        "emptyMessage": "コネクタが見つかりません。",
        "emptySearchMessage": "検索条件に一致するコネクタが見つかりません。",
        "loadErrorMessage": "コネクタの読み込みに失敗しました。",
        "searchPlaceholder": "コネクタを検索…",
        "title": "コネクタ"
      },
      "schemaPane": {
        "ariaDeleteMany_one": "選択した {{count}} 件のスキーマを削除",
        "ariaDeleteMany_other": "選択した {{count}} 件のスキーマを削除",
        "ariaDeleteOne": "選択したスキーマを削除",
        "columnName": "名前",
        "columnObjects": "オブジェクト数",
        "defaultLabel": "デフォルト",
        "deleteTitleEmpty": "スキーマを削除",
        "deleteTitleMany_one": "{{count}} 件のスキーマを削除",
        "deleteTitleMany_other": "{{count}} 件のスキーマを削除",
        "deleteTitleOne": "スキーマを削除",
        "deleteTitleOneNamed": "{{schema}} を削除",
        "emptyMessage": "スキーマが見つかりません",
        "emptySearchMessage": "検索条件に一致するスキーマがありません",
        "loadErrorMessage": "スキーマの読み込みに失敗しました",
        "searchPlaceholder": "{{title}} を検索…",
        "title": "スキーマ"
      }
    },
    "connectorFields": {
      "extraParamField": {
        "authApiKey": "APIキー",
        "authBasic": "ベーシック認証",
        "configured": "設定済み",
        "engineMssql": "SQL Server",
        "engineMysql": "MySQL",
        "enginePostgres": "PostgreSQL",
        "payloadBase64Json": "Base64 JSON",
        "payloadBinary": "バイナリ",
        "provisioned": "プロビジョニング済み",
        "schemeBolt": "bolt",
        "schemeBoltS": "bolt+s",
        "schemeNeo4j": "neo4j",
        "schemeNeo4jS": "neo4j+s",
        "serverless": "サーバーレス"
      },
      "extraParams": {
        "advancedLabel": "詳細オプション"
      },
      "scopeSelector": {
        "projectDescription": "特定のプロジェクト内でのみ利用可能",
        "projectFieldLabel": "プロジェクト",
        "projectHint": "このコネクタは選択したプロジェクト内でのみ利用可能です。",
        "projectLabel": "プロジェクト",
        "projectPlaceholder": "プロジェクトを選択",
        "projectSearchPlaceholder": "プロジェクトを検索…",
        "tenantDescription": "このテナント内のすべてのプロジェクトで利用可能",
        "tenantHint": "このコネクタはこのテナント内のすべてのプロジェクトで利用可能です。",
        "tenantLabel": "テナント",
        "title": "スコープ"
      },
      "shared": {
        "aihubSubscriptionKeySecretNameLabel": "AI Hub サブスクリプションキーのシークレット名",
        "authHelp": {
          "awsDefault": "このコネクタの AWS 認証情報を入力してください。",
          "awsKeyBoto": "boto3 経由で使用される AWS アクセスキーとシークレットキーです。",
          "awsKeySql": "データベースへの接続に使用される AWS アクセスキーとシークレットキーです。",
          "awsWif": "長期間有効なアクセスキーの代わりに AWS ワークロードアイデンティティフェデレーションを使用します。",
          "azureAiSearchKey": "管理者用 API キーを使用して Azure AI Search に接続します。",
          "azureAihub": "Azure AD 認証情報の代わりに AI Hub サブスクリプションキーを使用して接続します。",
          "azureBlobKey": "アカウントキーを使用して Azure Blob Storage に接続します。",
          "azureDocIntelligenceKey": "API キーを使用して Azure Document Intelligence に接続します。",
          "azureKeyDefault": "キーまたは接続文字列を使用して接続します。",
          "azureOboAiSearch": "サインインユーザーに代わって Azure AI Search にアクセスします（委任認証）。",
          "azureOboBlob": "サインインユーザーに代わって Azure Blob Storage にアクセスします（委任認証）。",
          "azureOboDefault": "サインインユーザーに代わってこのリソースにアクセスします（委任認証）。",
          "azureOboDocIntelligence": "サインインユーザーに代わって Azure Document Intelligence にアクセスします（委任認証）。",
          "azureOboSharePoint": "サインインユーザーに代わって SharePoint にアクセスします（委任認証）。",
          "azureSharePointKey": "クライアントシークレットを使用して SharePoint に接続します。",
          "azureSpAiSearch": "登録済みのサービスプリンシパルを使用して {brand} の Azure AI Search にアクセスします。",
          "azureSpBlob": "登録済みのサービスプリンシパルを使用して Azure Blob Storage にアクセスします。",
          "azureSpDefault": "登録済みのサービスプリンシパルを使用して {brand} 内のこのリソースにアクセスします。",
          "azureSpDocIntelligence": "登録済みのサービスプリンシパルを使用して {brand} の Azure Document Intelligence にアクセスします。",
          "azureSpRlsDeprecated": "このサービスプリンシパルモードは非推奨です。サポートされている認証モードに切り替えてください。",
          "azureSpSharePoint": "登録済みのサービスプリンシパルを使用して SharePoint にアクセスします。",
          "gcpDefault": "このコネクタの GCP 認証情報を入力してください。",
          "gcpKey": "GCP サービスアカウントキーを使用して接続します。",
          "gcpSaDefault": "GCP サービスアカウントを使用して接続します。",
          "gcpSaGcs": "GCP サービスアカウントを使用して Google Cloud Storage にアクセスします。",
          "gcpSaRlsDeprecated": "このサービスアカウントモードは非推奨です。サポートされている認証モードに切り替えてください。",
          "gcpWifDefault": "GCP ワークロードアイデンティティフェデレーションを使用して接続します。",
          "gcpWifGcs": "GCP ワークロードアイデンティティフェデレーションを使用して Google Cloud Storage にアクセスします。",
          "oracleIamRequired": "この Oracle 認証モードには Cloud IAM エントリが必要です。",
          "oracleUsernamePassword": "Oracle データベースのユーザー名とパスワードを使用して接続します。",
          "oracleWallet": "Oracle ウォレットを使用して接続します。"
        },
        "authModeLabel": "認証モード",
        "authModePlaceholder": "認証モードを選択",
        "databaseEngineHelpText": "この Azure Managed SQL 接続で使用するデータベースエンジンを選択してください。",
        "databaseEngineLabel": "データベースエンジン",
        "databaseLabel": "データベース",
        "databaseUsernameEntraLabel": "Entra 表示名",
        "descriptionLabel": "説明",
        "descriptionPlaceholder": "このコネクタの説明（任意）",
        "displayNameLabel": "表示名",
        "displayNamePlaceholder": "例：本番データベース",
        "docIntelVerifySslHelpText": "自己署名証明書を使用する Document Intelligence エンドポイントに接続する場合のみ無効にしてください。",
        "engineMysql": "MySQL",
        "enginePostgresql": "PostgreSQL",
        "engineSqlServer": "SQL Server",
        "entraDisplayNamePlaceholder": "例：john.doe@company.com",
        "entraUsernameHelpText": "データベースプリンシパルの Entra ID 表示名または UPN を入力してください。",
        "fromIamSuffix": "（Cloud IAM から）",
        "iamEmptyWarning": {
          "awsBasicAuth": "AWS ベーシック認証の Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "awsIamUser": "AWS IAM ユーザーの Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "awsWif": "AWS ワークロードアイデンティティフェデレーションの Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "azureBasicAuth": "Azure ベーシック認証の Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "azureBlobIamOnly": "Azure Blob Storage の Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "azureBlobKey": "Azure Blob Storage キーの Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "azureServicePrincipal": "Azure サービスプリンシパルの Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "databricks": "Databricks の Cloud IAM エントリが見つかりません。続行する前に個人用アクセストークンを追加してください。",
          "default": "Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "gcp": "GCP の Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "gcpBasicAuth": "GCP ベーシック認証の Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "gcpServiceAccount": "GCP サービスアカウントの Cloud IAM エントリが見つかりません。続行する前に追加してください。",
          "tokenBasedOnprem": "アクセストークンの Cloud IAM エントリが見つかりません。続行する前に追加してください。"
        },
        "iamHelp": {
          "awsAccessKeys": "AWS アクセスキーとシークレットキーを含む Cloud IAM エントリを選択してください。",
          "awsBasicAuth": "AWS データベース認証情報を含む Cloud IAM エントリを選択してください。",
          "awsWif": "AWS ワークロードアイデンティティフェデレーション用に設定された Cloud IAM エントリを選択してください。",
          "azureBasicAuth": "Azure ベーシック認証の認証情報を含む Cloud IAM エントリを選択してください。",
          "azureBlobIamOnly": "Azure Blob Storage へのアクセス用の Cloud IAM エントリを選択してください。",
          "azureBlobKey": "Azure Blob Storage のアカウントキーを含む Cloud IAM エントリを選択してください。",
          "azureServicePrincipal": "Azure サービスプリンシパルの Cloud IAM エントリを選択してください。",
          "databricks": "Databricks の個人用アクセストークンを含む Cloud IAM エントリを選択してください。",
          "default": "このコネクタの Cloud IAM エントリを選択してください。",
          "gcp": "この GCP コネクタの Cloud IAM エントリを選択してください。",
          "gcpBasicAuth": "GCP ベーシック認証の認証情報を含む Cloud IAM エントリを選択してください。",
          "gcpServiceAccount": "GCP サービスアカウントキーを含む Cloud IAM エントリを選択してください。",
          "gcpTokenMode": "アクセストークンの生成に使用する Cloud IAM エントリを選択してください。",
          "gcpWif": "GCP ワークロードアイデンティティフェデレーション用に設定された Cloud IAM エントリを選択してください。",
          "oracleOptional": "認証情報を直接入力する代わりに、任意で Cloud IAM エントリを選択できます。",
          "oracleRequired": "この Oracle 認証モードに必要な Cloud IAM エントリを選択してください。",
          "tokenBasedOnprem": "アクセストークンを含む Cloud IAM エントリを選択してください。"
        },
        "iamLabel": {
          "accessToken": "アクセストークン",
          "awsAccessKeys": "AWS アクセスキー",
          "awsBasicAuth": "AWS ベーシック認証",
          "awsWif": "AWS ワークロードアイデンティティフェデレーション",
          "azureBasicAuth": "Azure ベーシック認証",
          "azureBlobStorage": "Azure Blob Storage",
          "azureOrGraph": "Azure AD / Microsoft Graph",
          "azureServicePrincipal": "Azure サービスプリンシパル",
          "azureStorage": "Azure Storage",
          "cloudIam": "Cloud IAM",
          "cloudIamOptional": "Cloud IAM（任意）",
          "databricksIam": "Databricks IAM（PAT またはサービスプリンシパル）",
          "databricksPat": "Databricks 個人用アクセストークン",
          "gcp": "GCP Cloud IAM",
          "gcpBasicAuth": "GCP ベーシック認証",
          "gcpServiceAccount": "GCP サービスアカウント",
          "gcpWif": "GCP ワークロードアイデンティティフェデレーション"
        },
        "iamPlaceholder": {
          "accessToken": "アクセストークンを選択",
          "awsAccessKeys": "AWS アクセスキーを選択",
          "awsBasicAuth": "AWS ベーシック認証の認証情報を選択",
          "awsWif": "AWS ワークロードアイデンティティフェデレーションのエントリを選択",
          "azureBasicAuth": "Azure ベーシック認証の認証情報を選択",
          "azureBlobIamOnly": "Azure Blob Storage の Cloud IAM エントリを選択",
          "azureBlobKey": "Azure Blob Storage キーを選択",
          "azureServicePrincipal": "Azure サービスプリンシパルを選択",
          "databricksIam": "Databricks IAM エントリを選択（PAT またはサービスプリンシパル）",
          "databricksPat": "Databricks 個人用アクセストークンを選択",
          "default": "Cloud IAM エントリを選択",
          "gcp": "GCP の Cloud IAM エントリを選択",
          "gcpBasicAuth": "GCP ベーシック認証の認証情報を選択",
          "gcpServiceAccount": "GCP サービスアカウントを選択",
          "gcpWif": "GCP ワークロードアイデンティティフェデレーションのエントリを選択"
        },
        "loadingIamEntries": "Cloud IAM エントリを読み込み中…",
        "passwordSecretKeyNameOptionalLabel": "パスワードのシークレットキー名（任意）",
        "portLabel": "ポート",
        "schemaLabel": "スキーマ",
        "secretKeyNameLabel": "シークレットキー名",
        "secretKeyNamePlaceholder": "例：my-connector-password",
        "serverHostHelpMssql": "SQL Server のホスト名を入力してください（例：myserver.database.windows.net）",
        "serverHostHelpMysql": "MySQL のホスト名を入力してください（例：myserver.mysql.database.azure.com）",
        "serverHostHelpPostgres": "PostgreSQL のホスト名を入力してください（例：myserver.postgres.database.azure.com）",
        "serverHostLabel": "サーバーホスト",
        "usernameLabel": "ユーザー名"
      },
      "testSection": {
        "cancel": "キャンセル",
        "connectionFailed": "接続に失敗しました",
        "connectionSuccessful": "接続に成功しました",
        "latency": "レイテンシ: {{ms}} ms",
        "subtitle": "保存する前に接続設定を確認してください",
        "testConnection": "接続をテスト",
        "title": "接続をテスト",
        "version": "バージョン: {{version}}"
      }
    },
    "connectorModal": {
      "aria": {
        "backToSelection": "コネクタ選択に戻る",
        "closeDialog": "ダイアログを閉じる"
      },
      "buttons": {
        "addConnector": "コネクタを追加",
        "back": "戻る",
        "cancel": "キャンセル",
        "creating": "作成中…",
        "updateConnector": "コネクタを更新",
        "updating": "更新中…"
      },
      "connectorsLabel": "コネクタ",
      "errors": {
        "aiHubSecretRequired": "AI Hub サブスクリプションキーのシークレット名が必要です",
        "awsIamUserRequired": "AWS IAM ユーザーの Cloud IAM エントリを選択してください",
        "awsWifIamRequired": "AWS ワークロードアイデンティティフェデレーションの Cloud IAM エントリを選択してください",
        "azureBasicAuthIamRequired": "Azure ベーシック認証の Cloud IAM エントリを選択してください",
        "azureBlobIamRequired": "Azure Blob Storage の Cloud IAM エントリを選択してください",
        "azureBlobIamRequiredFull": "Azure Blob Storage へのアクセスには Cloud IAM エントリが必要です",
        "azureSpIamRequiredObo": "On-Behalf-Of 委任アクセス用の Cloud IAM エントリを選択してください",
        "azureSpIamRequiredSp": "Azure サービスプリンシパルの Cloud IAM エントリを選択してください",
        "cloudIamOrSecretRequired": "Cloud IAM エントリまたはシークレットキー名のいずれかを指定してください",
        "cloudIamRequired": "Cloud IAM エントリが必要です",
        "cloudIamRequiredForMode": "この認証モードには Cloud IAM エントリが必要です",
        "displayNameRequired": "表示名は必須です",
        "fieldRequired": "{{field}} は必須です",
        "gcpBasicAuthIamRequired": "GCP ベーシック認証の Cloud IAM エントリを選択してください",
        "gcpServiceAccountIamRequired": "GCP サービスアカウントの Cloud IAM エントリを選択してください",
        "hostNoUnderscores": "ホストにはアンダースコアを含めることはできません",
        "nameAlreadyExists": "この名前のコネクタは既に存在します",
        "oracleCloudIamRequired": "この Oracle 認証モードには Cloud IAM エントリが必要です",
        "oracleSecretOrIamRequired": "{{field}} が必要です。または Cloud IAM エントリを選択してください",
        "portRange": "ポート番号は 1〜65535 の範囲で指定してください",
        "projectRequired": "プロジェクトを選択してください",
        "provideCloudIamOrSecret": "テストする前に Cloud IAM エントリまたはシークレットを指定してください",
        "schemaRequired": "スキーマは必須です",
        "sharepointCredentialsRequired": "SharePoint の認証情報が必要です",
        "testFailedCheckConfig": "接続テストに失敗しました。設定を確認して再試行してください。",
        "usernameRequired": "ユーザー名は必須です",
        "walletLocationRequired": "ウォレットの場所は必須です"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "AI Hub サブスクリプションキーのシークレット名",
        "awsIamUserCloudIamEntry": "AWS IAM ユーザーの Cloud IAM エントリ",
        "awsWifCloudIamEntry": "AWS ワークロードアイデンティティフェデレーションの Cloud IAM エントリ",
        "azureBasicAuthIamRequired": "Azure ベーシック認証の Cloud IAM エントリ",
        "azureBlobIamEntry": "Azure Blob Storage の Cloud IAM エントリ",
        "azureBlobIamRequiredForMode": "Azure Blob Storage の Cloud IAM エントリ",
        "azureSpIamObo": "Azure サービスプリンシパル（On-Behalf-Of）の Cloud IAM エントリ",
        "azureSpIamSp": "Azure サービスプリンシパルの Cloud IAM エントリ",
        "cloudIamEntry": "Cloud IAM エントリ",
        "cloudIamOrPasswordSecretKeyName": "Cloud IAM エントリまたはパスワードのシークレットキー名",
        "connectorFallback": "コネクタ",
        "database": "データベース",
        "displayName": "表示名",
        "gcpIamEntryBasicAuth": "GCP ベーシック認証の Cloud IAM エントリ",
        "gcpIamEntryServiceAccount": "GCP サービスアカウントの Cloud IAM エントリ",
        "host": "ホスト",
        "passwordSecretKeyName": "パスワードのシークレットキー名",
        "project": "プロジェクト",
        "secretKeyName": "シークレットキー名",
        "sharepointCredentialsRequired": "SharePoint の認証情報",
        "walletLocation": "ウォレットの場所"
      },
      "loadingQuota": "クォータを読み込み中…",
      "missingFieldsTitle": "未入力の必須項目: {{fields}}",
      "requiredFieldsHint": "不足: {{fields}}",
      "titles": {
        "configureConnector": "{{name}} を設定",
        "editConnector": "コネクタを編集",
        "selectConnectorType": "コネクタタイプを選択"
      },
      "toasts": {
        "createFailed": "コネクタの作成に失敗しました",
        "updateFailed": "コネクタの更新に失敗しました"
      }
    },
    "connectorSelectionGrid": {
      "categories": {
        "aws": "AWS",
        "azure": "Azure",
        "databricks": "Databricks",
        "gcp": "GCP",
        "onprem": "オンプレミス",
        "orchestrators": "オーケストレーター",
        "snowflake": "Snowflake",
        "storage": "ストレージ",
        "telephony": "電話",
        "vectorDb": "ベクトルDB"
      },
      "loading": "コネクタタイプを読み込み中…"
    },
    "connectorViewModal": {
      "aria": {
        "backToSelection": "コネクタ選択に戻る",
        "closeDialog": "ダイアログを閉じる"
      },
      "buttons": {
        "addConnector": "コネクタを追加",
        "back": "戻る",
        "cancel": "キャンセル",
        "close": "閉じる",
        "creating": "作成中…",
        "updateConnector": "コネクタを更新",
        "updating": "更新中…"
      },
      "connectorsLabel": "コネクタ",
      "errors": {
        "aiHubSecretRequired": "AI Hub サブスクリプションキーのシークレット名が必要です",
        "awsIamUserRequired": "AWS IAM ユーザーの Cloud IAM エントリを選択してください",
        "awsWifIamRequired": "AWS ワークロードアイデンティティフェデレーションの Cloud IAM エントリを選択してください",
        "azureBasicAuthIamRequired": "Azure ベーシック認証の Cloud IAM エントリを選択してください",
        "azureBlobIamRequired": "Azure Blob Storage の Cloud IAM エントリを選択してください",
        "azureBlobIamRequiredFull": "Azure Blob Storage へのアクセスには Cloud IAM エントリが必要です",
        "azureSpIamRequiredObo": "On-Behalf-Of 委任アクセス用の Cloud IAM エントリを選択してください",
        "azureSpIamRequiredSp": "Azure サービスプリンシパルの Cloud IAM エントリを選択してください",
        "cloudIamOrSecretRequired": "Cloud IAM エントリまたはシークレットキー名のいずれかを指定してください",
        "cloudIamRequired": "Cloud IAM エントリが必要です",
        "cloudIamRequiredForMode": "この認証モードには Cloud IAM エントリが必要です",
        "displayNameRequired": "表示名は必須です",
        "fieldRequired": "{{field}} は必須です",
        "gcpBasicAuthIamRequired": "GCP ベーシック認証の Cloud IAM エントリを選択してください",
        "gcpServiceAccountIamRequired": "GCP サービスアカウントの Cloud IAM エントリを選択してください",
        "oracleCloudIamRequired": "この Oracle 認証モードには Cloud IAM エントリが必要です",
        "oracleSecretOrIamRequired": "{{field}} が必要です。または Cloud IAM エントリを選択してください",
        "portRange": "ポート番号は 1〜65535 の範囲で指定してください",
        "provideCloudIamOrSecret": "テストする前に Cloud IAM エントリまたはシークレットを指定してください",
        "schemaRequired": "スキーマは必須です",
        "sharepointCredentialsRequired": "SharePoint の認証情報が必要です",
        "testFailedCheckConfig": "接続テストに失敗しました。設定を確認して再試行してください。",
        "usernameRequired": "ユーザー名は必須です",
        "walletLocationRequired": "ウォレットの場所は必須です"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "AI Hub サブスクリプションキーのシークレット名",
        "awsIamUserCloudIamEntry": "AWS IAM ユーザーの Cloud IAM エントリ",
        "awsWifCloudIamEntry": "AWS ワークロードアイデンティティフェデレーションの Cloud IAM エントリ",
        "azureBasicAuthIamRequired": "Azure ベーシック認証の Cloud IAM エントリ",
        "azureBlobIamEntry": "Azure Blob Storage の Cloud IAM エントリ",
        "azureBlobIamRequiredForMode": "Azure Blob Storage の Cloud IAM エントリ",
        "azureSpIamObo": "Azure サービスプリンシパル（On-Behalf-Of）の Cloud IAM エントリ",
        "azureSpIamSp": "Azure サービスプリンシパルの Cloud IAM エントリ",
        "cloudIamEntry": "Cloud IAM エントリ",
        "cloudIamOrPasswordSecretKeyName": "Cloud IAM エントリまたはパスワードのシークレットキー名",
        "connectorFallback": "コネクタ",
        "database": "データベース",
        "displayName": "表示名",
        "gcpIamEntryBasicAuth": "GCP ベーシック認証の Cloud IAM エントリ",
        "gcpIamEntryServiceAccount": "GCP サービスアカウントの Cloud IAM エントリ",
        "host": "ホスト",
        "passwordSecretKeyName": "パスワードのシークレットキー名",
        "secretKeyName": "シークレットキー名",
        "sharepointCredentialsRequired": "SharePoint の認証情報",
        "walletLocation": "ウォレットの場所"
      },
      "loadingQuota": "クォータを読み込み中…",
      "missingFieldsTitle": "未入力の必須項目: {{fields}}",
      "requiredFieldsHint": "不足: {{fields}}",
      "titles": {
        "configureConnector": "{{name}} を設定",
        "editConnector": "コネクタを編集",
        "selectConnectorType": "コネクタタイプを選択",
        "viewConnection": "接続を表示"
      },
      "toasts": {
        "createFailed": "コネクタの作成に失敗しました",
        "updateFailed": "コネクタの更新に失敗しました"
      }
    },
    "graphEvals": {
      "backToGraphAriaLabel": "グラフに戻る",
      "cancel": "キャンセル",
      "close": "閉じる",
      "columnConfidence": "信頼度",
      "columnDateTime": "日時",
      "columnGrade": "グレード",
      "columnReport": "レポート",
      "columnSchema": "スキーマ",
      "columnSemantic": "意味論",
      "columnStatus": "ステータス",
      "columnStructural": "構造",
      "confidenceMeta": "信頼度: {{value}}",
      "configModalAriaLabel": "評価の実行設定",
      "derivationsDescFallback": "評価を実行すると、品質グレードの算出方法が表示されます。",
      "emptyRunsMessage": "まだ評価は実行されていません。",
      "entityCompletenessLabel": "エンティティの完全性",
      "gradeConfidenceSummary": "グレード {{grade}} · 信頼度 {{confidence}}",
      "gradeErrorAbbreviation": "エラー",
      "hideFormulas": "計算式を隠す",
      "howScoresCalculatedTitle": "スコアの算出方法",
      "latestScoresAriaLabel": "最新の品質スコア",
      "llmModelLabel": "LLM モデル",
      "llmModelTooltip": "意味的整合性の判定に使用するモデル",
      "loadingEvaluations": "評価を読み込み中…",
      "loadingModelsPlaceholder": "モデルを読み込み中…",
      "loadingReport": "レポートを読み込み中…",
      "missingGraphIdMessage": "グラフテーブルが指定されていません。",
      "modelDefaultLabel": "{{name}}（既定）",
      "noMatchingEvaluations": "検索条件に一致する評価がありません。",
      "noReportAttachedMessage": "この実行にはレポートが添付されていません。",
      "noStructuralBreakdown": "構造の内訳はありません。",
      "pageSubtitle": "{{name}} の品質評価履歴",
      "pageTitle": "グラフ評価",
      "pdfFrameTitle": "検証レポート",
      "qualityGradeHelp": "構造の健全性、スキーマ適合性、意味的整合性を加重平均した総合品質グレードです。",
      "qualityGradeLabel": "品質グレード",
      "refresh": "更新",
      "relationshipRichnessLabel": "関係の豊富さ",
      "reportLoadFailedGeneric": "レポートの読み込みに失敗しました",
      "reportLoadFailedMessage": "レポートファイルの読み込みに失敗しました。",
      "reportModalAriaLabel": "検証レポート",
      "runEvaluationButton": "評価を実行",
      "runEvaluationDescription": "検証対象と、グラフをどの程度サンプリングするかを選択してください。",
      "runEvaluationTitle": "評価を実行",
      "running": "実行中…",
      "runningEvaluation": "評価を実行中…",
      "sampleSizeLabel": "サンプルサイズ",
      "schemaConformanceDerivationHelp": "スキーマ適合性スコアがエンティティと関係の完全性からどのように算出されるか。",
      "schemaConformanceHelp": "グラフ内のエンティティと関係が登録済みスキーマにどれだけ従っているか。",
      "schemaConformanceLabel": "スキーマ適合性",
      "schemaFormulaFallback": "評価を実行すると、スキーマ適合性の計算式が表示されます。",
      "schemaMetaFallback": "スキーマデータはまだありません",
      "schemaPartsFormula": "エンティティ {{entity}} × 関係 {{relationship}} = {{result}}",
      "scopeAll": "グラフ全体",
      "scopeSample": "サンプル",
      "scoreDerivationsAriaLabel": "スコアの算出根拠",
      "searchEvaluationsPlaceholder": "評価を検索…",
      "searchModelsPlaceholder": "モデルを検索…",
      "selectAtLeastOneTargetError": "検証対象を1つ以上選択してください。",
      "selectModelPlaceholder": "モデルを選択",
      "semanticCoherenceCaveat": "意味的整合性はサンプルに基づいて判定されるため、グラフ全体を反映していない場合があります。",
      "semanticCoherenceDerivationHelp": "意味的整合性スコアがサンプリングされたトリプレットからどのように算出されるか。",
      "semanticCoherenceHelp": "グラフ内の関係が論理的・事実的に意味をなしているかどうか。",
      "semanticCoherenceLabel": "意味的整合性",
      "semanticFactScopeLegend": "検証する事実",
      "semanticFormula": "整合 {{coherent}} / サンプル {{sampled}} = {{result}}",
      "semanticMetaCoherent": "{{coherent}} / {{sampled}} 件が整合",
      "semanticMetaFallback": "意味データはまだありません",
      "semanticMetaSampled": "{{total}} 件中 {{sampled}} 件をサンプリング",
      "semanticMetaTotal": "{{total}} 件のトリプレット",
      "showFormulas": "計算式を表示",
      "startEvaluation": "評価を開始",
      "structuralFormula": "ノード/エッジの整合性チェックの加重平均",
      "structuralHealthDerivationHelp": "構造健全性スコアが基礎となる整合性チェックからどのように算出されるか。",
      "structuralHealthHelp": "グラフの構造的整合性 — 参照切れ、孤立ノード、不正な形式のエッジ。",
      "structuralHealthLabel": "構造健全性",
      "structuralMetaFallback": "構造データはまだありません",
      "targetSchema": "スキーマ適合性",
      "targetSemantic": "意味的整合性",
      "targetStructural": "構造健全性",
      "validatingHint": "グラフのサイズによっては数分かかる場合があります。",
      "validationReportTitle": "検証レポート",
      "validationTargetsLegend": "検証対象",
      "view": "表示",
      "weightBitSchema": "スキーマ {{value}}",
      "weightBitSemantic": "意味 {{value}}",
      "weightBitStructural": "構造 {{value}}",
      "weightedMixSummary": "{{bits}} の加重平均 = 信頼度 {{confidence}}"
    },
    "graphApprovalSession": {
      "addToQueue": "キューに追加",
      "addTripletButton": "トリプレットを追加",
      "addTripletDescription": "このセッションに新しい主語–関係–目的語のトリプレットを提案します。",
      "addTripletTitle": "トリプレットを追加",
      "approve": "承認",
      "approveAll": "すべて承認",
      "backToApprovalsAriaLabel": "承認一覧に戻る",
      "cancel": "キャンセル",
      "collapse": "折りたたむ",
      "collapsePanelAriaLabel": "レビューパネルを折りたたむ",
      "collapseSchemaPanelAriaLabel": "スキーマパネルを折りたたむ",
      "collapseSchemaTooltip": "スキーマパネルを折りたたむ",
      "columnConfidence": "信頼度",
      "columnObject": "目的語",
      "columnRelation": "関係",
      "columnSubject": "主語",
      "commit": "コミット",
      "commitSuccessApplied": "変更を適用しました",
      "commitSuccessCounted_one": "{{count}} 件の決定をコミットしました",
      "commitSuccessCounted_other": "{{count}} 件の決定をコミットしました",
      "committing": "コミット中…",
      "confidenceRangeLabel": "信頼度（0～1）",
      "confidenceTooltip": "信頼度: {{value}}",
      "decisionRecorded": "決定を記録しました。",
      "defaultSessionTitle": "承認セッション",
      "emptyAllMessage": "このセッションには提案された変更がありません。",
      "emptyFilteredMessage": "現在のフィルターに一致する{{kind}}はありません。",
      "entityNamePlaceholder": "エンティティ名",
      "expandPanelAriaLabel": "レビューパネルを展開する",
      "expandSchemaPanelAriaLabel": "スキーマパネルを展開する",
      "filterAll": "すべて",
      "filterEntities": "エンティティ",
      "filterProposedUpdatesAriaLabel": "提案された更新を絞り込む",
      "filterTriplets": "トリプレット",
      "graphCanvasAriaLabel": "グラフキャンバス",
      "legendConflict": "競合",
      "legendExisting": "既存",
      "legendNew": "新規",
      "missingIdsMessage": "テーブルまたはセッションが指定されていません。",
      "modify": "変更",
      "modifySnapshotTitle": "スナップショットを変更",
      "noChangesStaged": "保留中の変更はありません",
      "noConfidenceScore": "信頼度スコアなし",
      "pendingBadge_one": "{{count}} 件保留中",
      "pendingBadge_other": "{{count}} 件保留中",
      "proposedUpdatesAriaLabel": "提案された更新",
      "proposedUpdatesTitle": "提案された更新",
      "refresh": "更新",
      "refreshSessionTooltip": "セッションを更新",
      "reject": "却下",
      "rejectAll": "すべて却下",
      "relationPlaceholder": "関係タイプ",
      "reviewerNotePlaceholder": "メモを追加（任意）",
      "schemaLabel": "スキーマ",
      "schemaSidebarAriaLabel": "グラフスキーマ",
      "sessionContextAriaLabel": "セッションのコンテキスト",
      "sessionSummary": "合計 {{total}} 件 · 保留 {{pending}} 件",
      "showSchemaPanelAriaLabel": "スキーマパネルを表示",
      "showSchemaTooltip": "スキーマパネルを表示",
      "stageAllApproveTooltip": "保留中のすべての項目の承認をステージする",
      "stageAllRejectTooltip": "保留中のすべての項目の却下をステージする",
      "stageFilteredApproveTooltip_one": "表示中の {{count}} 件の項目の承認をステージする",
      "stageFilteredApproveTooltip_other": "表示中の {{count}} 件の項目の承認をステージする",
      "stageFilteredRejectTooltip_one": "表示中の {{count}} 件の項目の却下をステージする",
      "stageFilteredRejectTooltip_other": "表示中の {{count}} 件の項目の却下をステージする",
      "stageModification": "変更をステージする",
      "stagedApprove": "承認",
      "stagedCount_one": "{{count}} 件の変更が保留中",
      "stagedCount_other": "{{count}} 件の変更が保留中",
      "stagedModify": "変更",
      "stagedReject": "却下",
      "unappliedCount_one": "承認済みで未反映の変更が {{count}} 件",
      "unappliedCount_other": "承認済みで未反映の変更が {{count}} 件",
      "undo": "元に戻す",
      "undoAll": "すべて元に戻す",
      "undoAllTooltip": "保留中の決定をすべて破棄する"
    },
    "graphApprovals": {
      "auditLog": "監査ログ",
      "auditTrailTitle": "監査証跡",
      "backToGraphAriaLabel": "グラフに戻る",
      "columnAction": "アクション",
      "columnActions": "操作",
      "columnActor": "実行者",
      "columnChangeRun": "変更実行",
      "columnCommit": "コミット",
      "columnCreatedAt": "作成日時",
      "columnCreatedBy": "作成者",
      "columnMessage": "メッセージ",
      "columnMode": "モード",
      "columnPending": "保留中",
      "columnSource": "ソース",
      "columnStatus": "ステータス",
      "columnTriplet": "トリプレット",
      "columnUpdatedAt": "更新日時",
      "columnVersion": "バージョン",
      "columnWhen": "日時",
      "commitHistoryTitle": "コミット履歴",
      "commits": "コミット",
      "emptyAuditMessage": "まだ監査エントリはありません。",
      "emptyCommitsMessage": "まだコミットはありません。",
      "emptyRunsMessage": "まだ変更実行はありません。",
      "exportAuditAriaLabel": "監査ログを CSV でエクスポート",
      "exportCsv": "CSV をエクスポート",
      "filterAll": "すべて",
      "filterModeLabel": "モード",
      "filterStatusLabel": "ステータス",
      "footnoteText": "承認された変更はライブグラフに書き込まれます。 ",
      "hideAudit": "監査ログを隠す",
      "hideCommits": "コミットを隠す",
      "missingTableIdMessage": "グラフテーブルが指定されていません。",
      "modeApprovalRequired": "承認が必要",
      "modeBypassed": "スキップ済み",
      "openLivePreview": "ライブプレビューを開く",
      "openSession": "セッションを開く",
      "pageSubtitle": "{{name}} のレビューキュー",
      "pageTitle": "グラフ承認",
      "refresh": "更新",
      "review": "レビュー",
      "runCount_one": "{{count}} 件の実行",
      "runCount_other": "{{count}} 件の実行",
      "searchAuditPlaceholder": "監査ログを検索…",
      "searchChangeRunsPlaceholder": "変更実行を検索…",
      "searchCommitsPlaceholder": "コミットを検索…",
      "statusApplied": "適用済み",
      "statusAutoApplied": "自動適用済み",
      "statusPartiallyApplied": "一部適用済み",
      "statusPending": "保留中",
      "statusRejected": "却下済み",
      "systemActor": "システム",
      "unknownUser": "不明なユーザー",
      "wholeRun": "実行全体"
    },
    "graphTablePreview": {
      "addedInVersionLegend": "v{{version}} で追加",
      "alreadyThereLegend": "既存",
      "askTheGraphDescription": "自然言語で質問すると、グラフクエリに変換されます。",
      "askTheGraphTitle": "グラフに質問する",
      "back": "戻る",
      "backToDataAriaLabel": "データに戻る",
      "chatAssistantAriaLabel": "グラフチャットアシスタント",
      "chatDisabledLabel": "チャット利用不可",
      "chatDisabledTooltip": "このテナントには LLM モデルが設定されていないため、グラフチャットは利用できません。",
      "chatInputPlaceholder": "このグラフについて質問する…",
      "chatWelcomeMessage": "このグラフについて質問してください。代わりに検索します。",
      "collapse": "折りたたむ",
      "collapseChatAriaLabel": "チャットを折りたたむ",
      "commitLegendAriaLabel": "コミットバージョンの凡例",
      "commitOptionPlain": "v{{version}}{{whenSuffix}}",
      "commitOptionWithMessage": "v{{version}} — {{message}}{{whenSuffix}}",
      "commitVersionPlaceholder": "バージョンを選択",
      "couldNotBuildQueryMessage": "グラフクエリに変換できませんでした。質問を言い換えてみてください。",
      "defaultGraphTitle": "グラフプレビュー",
      "expandChatAriaLabel": "チャットを展開する",
      "graphCanvasAriaLabel": "グラフキャンバス",
      "graphContextAriaLabel": "グラフのコンテキスト",
      "graphSchemaAriaLabel": "グラフスキーマ",
      "highlightingMatchesMessage": "{{nodesPart}}と{{relsPart}}をハイライトしています。",
      "latestLiveOption": "最新（ライブ）",
      "matchedNodesPart_one": "一致するノード {{count}} 件",
      "matchedNodesPart_other": "一致するノード {{count}} 件",
      "matchedRelationshipsPart_one": "一致する関係 {{count}} 件",
      "matchedRelationshipsPart_other": "一致する関係 {{count}} 件",
      "missingTableIdMessage": "グラフテーブルが指定されていません。",
      "modelLabel": "モデル",
      "modelLabelLoading": "モデルを読み込み中…",
      "newestCommitMatchesLatestNotice": "バージョン {{version}} は最新のコミットのため、この表示はライブグラフと一致しています。",
      "noCommitStampsNotice": "このグラフにはコミットバージョンのスタンプがないため、バージョンでの絞り込みはできません。",
      "noModelsConfiguredPlaceholder": "モデルが設定されていません",
      "noNodesMatchedMessage": "質問に一致するノードはありませんでした。",
      "nothingToResetTooltip": "リセットする内容がありません",
      "reset": "リセット",
      "resetViewTooltip": "グラフ全体の表示にリセットする",
      "schemaLabel": "スキーマ",
      "searchModelsPlaceholder": "モデルを検索…",
      "selectModelPlaceholder": "モデルを選択",
      "send": "送信",
      "showSchemaPanelAriaLabel": "スキーマパネルを表示",
      "showSchemaTooltip": "スキーマパネルを表示",
      "statusAsOfVersion": "v{{version}} 時点",
      "statusHighlighted": "ハイライト表示中",
      "statusSample": "サンプル",
      "thinking": "考え中…",
      "unexpectedResponseMessage": "そのクエリはグラフデータを返しませんでした。質問を言い換えてみてください。",
      "updatedGraphFallbackMessage": "更新されたグラフです。",
      "viewCommitVersionTooltip": "特定のコミットバージョンを表示する",
      "wrongTableTypeError": "このテーブルはグラフテーブルではありません。"
    },
    "graphSchemaPanel": {
      "collapseAriaLabel": "スキーマパネルを折りたたむ",
      "collapseTooltip": "スキーマパネルを折りたたむ",
      "defaultEngineName": "グラフデータベース",
      "deselectAll": "すべて選択解除",
      "edgesLabel": "エッジ",
      "emptyLabelTooltip": "このバージョンには {{label}} ノードがありません",
      "engineLabel": "エンジン",
      "graphDetailsTitle": "グラフの詳細",
      "labelCountTooltip_one": "{{label}} ノード {{count}} 件",
      "labelCountTooltip_other": "{{label}} ノード {{count}} 件",
      "labelsTitle": "ラベル",
      "nodesLabel": "ノード",
      "notAvailable": "該当なし",
      "relationshipsTitle_one": "関係（{{count}}）",
      "relationshipsTitle_other": "関係（{{count}}）",
      "schemaTitle": "スキーマ",
      "selectAll": "すべて選択",
      "selectLabelsEmptyState": "関係を表示するには、少なくとも1つのラベルを選択してください。",
      "snapshotLabel": "スナップショット"
    },
    "graphWebglCanvas": {
      "layingOutGraphAriaLabel": "グラフを配置しています…"
    },
    "neo4jGraphView": {
      "canvasControlsAriaLabel": "キャンバス操作",
      "clearSearchAriaLabel": "検索をクリア",
      "closeDetailsAriaLabel": "詳細を閉じる",
      "closeDetailsKeepHighlightTooltip": "閉じる（ハイライトは維持）",
      "closeDetailsTooltip": "閉じる",
      "fitToViewTooltip": "全体表示に合わせる",
      "focusHintAfter": "でフォーカスをリセットできます。",
      "focusHintBefore": "1つのノードにフォーカス中 —",
      "genericNodeLabel": "ノード",
      "hiddenPropertiesFoot_one": "他に {{count}} 件のプロパティは表示されていません",
      "hiddenPropertiesFoot_other": "他に {{count}} 件のプロパティは表示されていません",
      "lodHintDefault": "ズームインすると詳細が表示されます",
      "noMatchingNodes": "一致するノードがありません",
      "nodeDetailsAriaLabel": "{{name}} の詳細",
      "relationshipDetailsAriaLabel": "関係の詳細",
      "resetFocusTooltip": "フォーカスをリセット",
      "searchAriaLabel": "ノードを検索",
      "searchPlaceholder": "ノードを検索…",
      "searchingEllipsis": "検索中…",
      "zoomInTooltip": "ズームイン",
      "zoomOutTooltip": "ズームアウト"
    },
    "vectorTab": {
      "actionDelete": "削除",
      "actionEdit": "編集",
      "actionPreviewData": "データをプレビュー",
      "actionRemoveAsDefault": "デフォルト解除",
      "actionSetAsDefault": "デフォルトに設定",
      "actionSync": "同期",
      "actionVectorSearch": "ベクトル検索",
      "actionViewDetails": "詳細を表示",
      "addVectorDbTableButton": "ベクターDBテーブルを追加",
      "allLabel": "すべて",
      "andOthersLabel_one": "{{names}} 他 {{count}} 件",
      "andOthersLabel_other": "{{names}} 他 {{count}} 件",
      "bulkActionDeleteSelected": "選択項目を削除",
      "bulkActionSyncMetadata": "メタデータを同期",
      "bulkDeletePartialWarning": "{{deleted}} 件削除、{{skipped}} 件スキップ: {{errors}}",
      "bulkDeleteSuccessToast_one": "{{count}} 件のテーブルを削除しました",
      "bulkDeleteSuccessToast_other": "{{count}} 件のテーブルを削除しました",
      "bulkSyncStartedRequeuedToast_one": "{{count}} 件のテーブルのメタデータ同期を再登録しました",
      "bulkSyncStartedRequeuedToast_other": "{{count}} 件のテーブルのメタデータ同期を再登録しました",
      "bulkSyncStartedToast_one": "{{count}} 件のテーブルのメタデータ同期を開始しました",
      "bulkSyncStartedToast_other": "{{count}} 件のテーブルのメタデータ同期を開始しました",
      "clearDefaultErrorToast": "{{name}} のデフォルト解除に失敗しました",
      "collectionViewTooltip": "コレクションビュー",
      "columnActions": "操作",
      "columnCreator": "作成者",
      "columnDatabase": "データベース",
      "columnEmbeddingModel": "埋め込みモデル",
      "columnIntrospection": "イントロスペクション",
      "columnLogs": "ログ",
      "columnName": "名前",
      "columnStatus": "ステータス",
      "columnVectors": "ベクトル数",
      "databaseViewTooltip": "データベースビュー",
      "defaultBadgeTooltip": "デフォルトのテーブル",
      "defaultSchemaLabel": "デフォルト",
      "deleteConfirmLabel": "削除",
      "deleteNamespaceConfirmMessage_one": "名前空間 {{schema}} と登録されている {{count}} 件のテーブルを削除しますか？{{brand}} のメタデータのみが削除され、元に戻せません。",
      "deleteNamespaceConfirmMessage_other": "名前空間 {{schema}} と登録されている {{count}} 件のテーブルを削除しますか？{{brand}} のメタデータのみが削除され、元に戻せません。",
      "deleteNamespacePartialWarning": "{{schemaCount}} 件中 {{deleted}} 件の名前空間を削除、{{skipped}} 件スキップしました",
      "deleteNamespaceSuccessToast_one": "名前空間を削除しました（テーブル {{count}} 件を削除）",
      "deleteNamespaceSuccessToast_other": "名前空間を削除しました（テーブル {{count}} 件を削除）",
      "deleteNamespaceSuccessToastNamed_one": "名前空間 {{schema}} を削除しました（テーブル {{count}} 件を削除）",
      "deleteNamespaceSuccessToastNamed_other": "名前空間 {{schema}} を削除しました（テーブル {{count}} 件を削除）",
      "deleteNamespaceTitle": "名前空間を削除",
      "deleteNamespacesConfirmMessage_one": "{{namespaceCount}} 件の名前空間と、登録されている {{count}} 件のテーブルを削除しますか？{{brand}} のメタデータのみが削除され、元に戻せません。",
      "deleteNamespacesConfirmMessage_other": "{{namespaceCount}} 件の名前空間と、登録されている {{count}} 件のテーブルを削除しますか？{{brand}} のメタデータのみが削除され、元に戻せません。",
      "deleteNamespacesCountLabel_one": "{{count}} 件の名前空間を削除",
      "deleteNamespacesCountLabel_other": "{{count}} 件の名前空間を削除",
      "deleteNamespacesSuccessToast_one": "{{schemaCount}} 件の名前空間を削除しました（テーブル {{count}} 件を削除）",
      "deleteNamespacesSuccessToast_other": "{{schemaCount}} 件の名前空間を削除しました（テーブル {{count}} 件を削除）",
      "deleteNamespacesTitle": "名前空間を削除",
      "deleteSelectedTablesConfirmMessage_one": "選択した {{count}} 件のテーブルを削除しますか？この操作は元に戻せません。",
      "deleteSelectedTablesConfirmMessage_other": "選択した {{count}} 件のテーブルを削除しますか？この操作は元に戻せません。",
      "deleteSelectedTablesTitle": "選択したテーブルを削除",
      "deleteTableConfirmMessage": "{{name}} を削除しますか？この操作は元に戻せません。",
      "deleteTableConfirmTitle": "テーブルを削除",
      "deleteTablesCountLabel_one": "{{count}} 件のテーブルを削除",
      "deleteTablesCountLabel_other": "{{count}} 件のテーブルを削除",
      "deletingLabel": "削除中…",
      "favoritesLabel": "お気に入り",
      "filterAllCreatorsPlaceholder": "すべての作成者",
      "filterAllEnginesPlaceholder": "すべてのエンジン",
      "filterCreatorLabel": "作成者",
      "filterEngineLabel": "エンジン",
      "namespacesTitle": "名前空間",
      "noConnectorsYet": "コネクタがまだありません",
      "notConfigured": "未設定",
      "setDefaultErrorToast": "{{name}} をデフォルトに設定できませんでした",
      "syncMetadataErrorToast": "{{name}} のメタデータ同期に失敗しました",
      "syncStatus": {
        "active": "有効",
        "failed": "失敗",
        "inactive": "無効",
        "queued": "キュー待ち",
        "running": "実行中",
        "synced": "同期済み"
      },
      "unknownConnectorType": "不明",
      "unknownCreator": "不明",
      "vectorDbExplorerAriaLabel": "ベクターデータベースエクスプローラー",
      "vectorTablesLeafTitle": "ベクターテーブル",
      "vectorTablesLeafTitleWithSchema": "ベクターテーブル — {{schema}}",
      "viewLink": "表示",
      "viewSyncLogsTooltip": "同期ログを表示",
      "resourceVectorDatabases": "ベクトルデータベース",
      "resourceVectorDatabase": "ベクトルデータベース"
    },
    "vectorSearchModal": {
      "advancedRagLabel": "高度なRAG",
      "closeDialogAriaLabel": "閉じる",
      "contentLabel": "コンテンツ",
      "coverageLabel": "カバレッジ",
      "embeddingModelLabel": "埋め込みモデル",
      "enhancementsLabel": "拡張機能",
      "foundResultsPrefix": "検索結果:",
      "hideButton": "非表示",
      "hydeEnhancementLabel": "HyDE（仮説文書埋め込み）",
      "idFallbackLabel": "結果 {{id}}",
      "latencyMs": "{{ms}}ms",
      "loadingOption": "読み込み中…",
      "metadataLabel": "メタデータ",
      "missingAspectsLabel": "不足している要素: {{aspects}}",
      "modelDefaultLabel": "{{name}}（デフォルト）",
      "modelLabel": "モデル: {{name}}",
      "modelsWordBold": "モデル",
      "multiQueryExpansionLabel": "マルチクエリ拡張",
      "noEmbeddingModelsOption": "利用可能な埋め込みモデルがありません",
      "noModelRegisteredBody": "このテーブルでベクトル検索を実行するには、1つ以上の",
      "noModelRegisteredBold": "埋め込みモデルが登録されていません。",
      "noModelRegisteredSuffix": "を埋め込み用に登録するか、高度なRAGに切り替えてください。",
      "noResultsBasicHint": "別の検索クエリを試すか、埋め込みモデルを確認してください。",
      "noResultsFoundTitle": "結果が見つかりません",
      "noResultsRagHint": "クエリを言い換えるか、RAG戦略を調整してください。",
      "qualityLabel": "品質:",
      "ragSearchButton": "RAG検索",
      "ragSearchingButton": "検索中…",
      "ragStrategyConfigTitle": "RAG戦略の設定",
      "registerModelFirstTooltip": "先に埋め込みモデルを登録してください",
      "relevanceLabel": "関連性:",
      "rerankingLabel": "リランキング",
      "resultFallbackLabel": "結果 {{index}}",
      "resultsInLatencyMiddle": "件の結果、所要時間",
      "resultsLabel": "結果数:",
      "resultsSuffix": "件の結果",
      "searchButton": "検索",
      "searchFailedTitle": "検索に失敗しました",
      "searchModelsPlaceholder": "モデルを検索…",
      "searchPlaceholder": "検索クエリを入力…",
      "searchingButton": "検索中…",
      "selfCorrectedBadge_one": "自己修正済み（{{count}} 回試行）",
      "selfCorrectedBadge_other": "自己修正済み（{{count}} 回試行）",
      "selfRagCorrectionLabel": "Self-RAG補正",
      "semanticSearchBody": "上のフィールドにクエリを入力すると、このテーブルのベクトル埋め込みを検索します。",
      "semanticSearchTitle": "セマンティック検索",
      "settingsButton": "設定",
      "strategyAutoOption": "自動",
      "strategyDecompositionOption": "分解",
      "strategyDescriptionAuto": "クエリに最適な検索戦略を自動的に選択します。",
      "strategyDescriptionDecomposition": "複雑なクエリをサブクエスチョンに分解し、それぞれで検索します。",
      "strategyDescriptionDirect": "元のクエリテキストを使ってそのまま検索します。",
      "strategyDescriptionHyde": "まず仮説的な回答を生成し、その埋め込みを使って検索します。",
      "strategyDescriptionMultiQuery": "複数のクエリバリエーションを生成し、検索範囲を広げます。",
      "strategyDirectOption": "ダイレクト",
      "strategyHydeOption": "HyDE",
      "strategyLabel": "戦略",
      "strategyMultiQueryOption": "マルチクエリ",
      "title": "ベクトル検索",
      "useDefaultOption": "デフォルトを使用"
    },
    "storageTab": {
      "actionDelete": "削除",
      "actionExport": "エクスポート",
      "actionPreviewFiles": "ファイルをプレビュー",
      "actionSetAsDefault": "デフォルトに設定",
      "actionSync": "同期",
      "actionSyncing": "同期中…",
      "actionViewDetails": "詳細を表示",
      "addStorageButton": "ストレージを追加",
      "allLabel": "すべて",
      "columnActions": "操作",
      "columnConnector": "コネクタ",
      "columnContainer": "コンテナ",
      "columnCreated": "作成日時",
      "columnFolder": "フォルダ",
      "columnLogs": "ログ",
      "columnStatus": "ステータス",
      "columnUpdated": "更新日時",
      "defaultBadgeTooltip": "デフォルトのフォルダ",
      "defaultBucketLabel": "デフォルト",
      "defaultConnectorName": "不明なコネクタ",
      "deleteConfirmLabel": "削除",
      "deleteConfirmMessage": "{{name}} を削除しますか？この操作は元に戻せません。",
      "deleteConfirmTitle": "ストレージフォルダを削除",
      "emptyMessage": "ストレージフォルダが見つかりません",
      "exportSelectedAction": "選択項目をエクスポート",
      "favoritesLabel": "お気に入り",
      "filterAllCreatorsPlaceholder": "すべての作成者",
      "filterAllTypesPlaceholder": "すべてのタイプ",
      "filterCreatorLabel": "作成者",
      "filterStorageTypeLabel": "ストレージタイプ",
      "foldersLeafTitle": "フォルダ",
      "foldersLeafTitleWithBucket": "フォルダ — {{bucket}}",
      "listViewTooltip": "リスト表示",
      "noConnectorsYet": "コネクタがまだありません",
      "pendingBadge": "保留中",
      "setDefaultErrorToast": "{{name}} をデフォルトに設定できませんでした",
      "setDefaultSuccessToast": "{{name}} をデフォルトに設定しました",
      "splitViewTooltip": "分割表示",
      "statusActive": "有効",
      "statusApproved": "承認済み",
      "statusRequested": "申請中",
      "statusUnknown": "不明",
      "storageExplorerAriaLabel": "ストレージエクスプローラー",
      "unknownConnectorType": "不明",
      "viewLink": "表示",
      "viewSyncLogsTooltip": "同期ログを表示"
    },
    "storageViewModal": {
      "auditInformationSectionTitle": "監査情報",
      "basicInformationSectionTitle": "基本情報",
      "closeButton": "閉じる",
      "closeDialogAriaLabel": "閉じる",
      "errorInformationSectionTitle": "エラー情報",
      "fieldBucketName": "バケット名",
      "fieldConnector": "コネクタ",
      "fieldCreatedAt": "作成日時",
      "fieldCreatedBy": "作成者",
      "fieldErrorMessage": "エラーメッセージ",
      "fieldFileCount": "ファイル数",
      "fieldFolderPath": "フォルダパス",
      "fieldId": "ID",
      "fieldStatus": "ステータス",
      "fieldTotalSize": "合計サイズ",
      "fieldUpdatedAt": "更新日時",
      "fieldUpdatedBy": "更新者",
      "metadataSectionTitle": "メタデータ",
      "noErrors": "エラーはありません",
      "notAvailable": "該当なし",
      "status": {
        "active": "有効",
        "error": "エラー",
        "syncing": "同期中",
        "unknown": "不明"
      },
      "storageInformationSectionTitle": "ストレージ情報",
      "title": "ストレージフォルダの詳細"
    },
    "storageFolderPreview": {
      "actionsTooltip": "操作",
      "cancelButton": "キャンセル",
      "clearSearchAriaLabel": "検索をクリア",
      "clearSelectionAriaLabel": "選択をクリア",
      "closeDialogAriaLabel": "閉じる",
      "columnActions": "操作",
      "columnModified": "更新日時",
      "columnName": "名前",
      "columnSize": "サイズ",
      "columnType": "タイプ",
      "downloadErrorToast": "ファイルのダウンロードに失敗しました",
      "downloadResultAllFailed": "選択したファイルをダウンロードできませんでした。",
      "downloadResultAllSuccess": "{{count}} 件すべてのファイルを正常にダウンロードしました。",
      "downloadResultOk": "OK",
      "downloadResultPartial": "{{total}} 件中 {{successCount}} 件をダウンロードしました。失敗: {{failedNames}}",
      "downloadResultTitleFailed": "ダウンロード失敗",
      "downloadResultTitlePartial": "ダウンロード未完了",
      "downloadResultTitleSuccess": "ダウンロード完了",
      "downloadSelectedButton": "選択したファイルをダウンロード",
      "downloadSelectedTooltip": "選択したファイルをダウンロード",
      "downloadingSelectedButton": "ダウンロード中…",
      "emptySearchState": "検索条件に一致するファイルがありません",
      "emptyState": "このフォルダにはファイルがありません",
      "exportAction": "ダウンロード",
      "firstPageTooltip": "最初のページ",
      "lastPageTooltip": "最後のページ",
      "nextPageTooltip": "次のページ",
      "openingFileLabel": "ファイルを開いています…",
      "paginationInfo": "{{total}} 件中 {{from}}–{{to}} 件を表示",
      "previousPageTooltip": "前のページ",
      "searchPlaceholder": "ファイルを検索…",
      "selectAllAriaLabel": "すべてのファイルを選択",
      "selectFileAriaLabel": "{{name}} を選択",
      "selectedCount": "{{count}} 件選択中",
      "selectionLimitWarning": "一度に選択できるファイルは最大10件です。",
      "syncButtonLabel": "同期",
      "syncButtonTooltip": "このフォルダのファイルを同期",
      "syncingButtonLabel": "同期中…",
      "viewAction": "プレビュー"
    },
    "storageFilePreview": {
      "closeDialogAriaLabel": "閉じる",
      "downloadButton": "ダウンロード",
      "downloadErrorToast": "ファイルのダウンロードに失敗しました",
      "emptyTable": "表示する行がありません",
      "imagePreviewAlt": "画像プレビュー",
      "loadErrorToast": "ファイルのプレビューに失敗しました",
      "nullValueLabel": "NULL",
      "rowsUnit": "行",
      "textPreviewAriaLabel": "ファイルの内容",
      "tryAgainButton": "再試行",
      "unableToLoadTitle": "ファイルを表示できません",
      "unsupportedHint": "このファイル形式はブラウザで表示できません。ダウンロードして開いてください。",
      "unsupportedTitle": "プレビューできません"
    },
    "groupedStorageView": {
      "bucketPathTooltip": "{{bucket}}/{{path}}",
      "createdTooltip": "作成日時",
      "emptyState": "ストレージフォルダが見つかりません",
      "emptyStateHint": "別の検索語を試してください",
      "fileCount_one": "{{count}} 件のファイル",
      "fileCount_other": "{{count}} 件のファイル",
      "folderCount_one": "{{count}} 件のフォルダ",
      "folderCount_other": "{{count}} 件のフォルダ",
      "loadingFolders": "フォルダを読み込んでいます…",
      "unknownConnectorName": "不明なコネクタ",
      "updatedTooltip": "更新日時"
    },
    "metadataSyncLogsModal": {
      "bulkJobLabel": "一括ジョブ",
      "closeAriaLabel": "閉じる",
      "collapseDetailAriaLabel": "詳細を折りたたむ",
      "columnMessage": "メッセージ",
      "columnStatus": "ステータス",
      "columnWhen": "日時",
      "emptyState": "同期ログが見つかりません",
      "entryCount_one": "{{count}} 件",
      "entryCount_other": "{{count}} 件",
      "expandDetailAriaLabel": "詳細を展開",
      "loadingLogs": "ログを読み込んでいます…",
      "title": "メタデータ同期ログ",
      "triggerLabel": "トリガー:"
    },
    "bulkMetadataSyncModal": {
      "closeAriaLabel": "閉じる",
      "columnDetail": "詳細",
      "columnStatus": "ステータス",
      "columnTable": "テーブル",
      "jobLabel": "ジョブ",
      "loadingStatus": "同期ステータスを読み込んでいます…",
      "noJobData": "ジョブデータがありません",
      "requeuedToast_one": "{{count}} 件の項目を再試行のためキューに戻しました",
      "requeuedToast_other": "{{count}} 件の項目を再試行のためキューに戻しました",
      "retryFailedButton_one": "失敗した {{count}} 件を再試行",
      "retryFailedButton_other": "失敗した {{count}} 件を再試行",
      "title": "メタデータの一括同期"
    },
    "tableDataPreview": {
      "loadErrorToast": "テーブルデータの読み込みに失敗しました",
      "nullValueLabel": "NULL",
      "columnEdit": "編集",
      "editGoldenAnswerAriaLabel": "正解回答を編集",
      "csvExportedToast_other": "{{count}} 行を CSV にエクスポートしました",
      "jsonExportedToast_other": "{{count}} 行を JSON にエクスポートしました",
      "previewNotAvailable": "このデータソースではプレビューを利用できません",
      "vertexAiDataStoreHint": "このテーブルは Vertex AI Search のデータストアを利用しています。データストアを直接クエリしてプレビューを確認してください。",
      "vertexAiVectorSearchHint": "このテーブルは Vertex AI Vector Search のインデックスを利用しています。ベクター検索を実行してプレビューを確認してください。",
      "closeDialogAriaLabel": "閉じる",
      "unableToLoadTitle": "データを読み込めません",
      "dataUnavailableTitle": "データがありません",
      "syncingButton": "同期中…",
      "refreshMetadataButton": "メタデータを更新",
      "tryAgainButton": "再試行",
      "documentsUnit": "ドキュメント",
      "rowsUnit": "行",
      "elasticsearchSearchPlaceholder": "Lucene クエリ構文で検索…",
      "searchPlaceholder": "検索…",
      "clearSearchAriaLabel": "検索をクリア",
      "luceneQueryHintTitle": "Lucene クエリ構文をサポートしています（例: field:value AND other:value）",
      "paginationFullTextSearchHint": "全文検索はすべての列に適用されます",
      "tableViewTitle": "テーブル表示",
      "tableTab": "テーブル",
      "graphViewTitle": "グラフ表示",
      "graphTab": "グラフ",
      "documentViewJsonTitle": "ドキュメント表示（JSON）",
      "documentsTab": "ドキュメント",
      "tabularViewTitle": "表形式表示",
      "exportJsonButton": "JSON をエクスポート",
      "exportingButton": "エクスポート中…",
      "exportCsvButton": "CSV をエクスポート",
      "documentFallbackLabel": "ドキュメント {{index}}",
      "statusLabel": "ステータス: {{status}}",
      "hideJsonButton": "JSON を非表示",
      "showJsonButton": "JSON を表示",
      "noPreviewFieldsHint": "このドキュメントにはプレビュー用のフィールドが設定されていません。",
      "pageOfLabel": "{{totalPages}} ページ中 {{page}} ページ目",
      "pageSizeLabel": "1 ページあたりの行数",
      "previousButton": "前へ",
      "nextButton": "次へ",
      "noDataFoundEmptyMessage": "データが見つかりません"
    },
    "ontology": {
      "retrievalConfigPanel": {
        "strategyAuto": "自動",
        "strategyAutoDescription": "クエリに応じて最適な取得戦略を自動的に選択します",
        "strategyVector": "ベクター検索",
        "strategyVectorDescription": "埋め込みに対する意味的類似性検索を使用して結果を取得します",
        "strategySql": "SQL",
        "strategySqlDescription": "テーブルに対して SQL クエリを生成・実行して結果を取得します",
        "strategyHybrid": "ハイブリッド",
        "strategyHybridDescription": "ベクター検索とキーワード/SQL 検索を組み合わせて、より正確な結果を得ます",
        "fusionMethodRrf": "Reciprocal Rank Fusion",
        "fusionMethodRrfDescription": "Reciprocal Rank Fusion を使用してランク付けされた結果リストを結合します",
        "fusionMethodWeighted": "加重合計",
        "fusionMethodWeightedDescription": "ベクター結果とキーワード結果の加重合計でスコアを結合します",
        "fusionMethodCascade": "カスケード",
        "fusionMethodCascadeDescription": "最初にキーワード検索を実行し、その後ベクター検索で再ランク付けします",
        "distanceMetricCosine": "コサイン",
        "distanceMetricEuclidean": "ユークリッド",
        "distanceMetricDotProduct": "内積",
        "title": "取得設定",
        "resetToDefaultsTitle": "デフォルトに戻す",
        "resetButton": "リセット",
        "defaultStrategyLabel": "デフォルトの取得戦略",
        "vectorSearchSettingsLabel": "ベクター検索設定",
        "idColumnLabel": "ID 列",
        "autoDetectOption": "自動検出",
        "contentColumnLabel": "コンテンツ列",
        "embeddingColumnLabel": "埋め込み列",
        "distanceMetricLabel": "距離メトリック",
        "hybridFusionSettingsLabel": "ハイブリッド融合設定",
        "fusionMethodLabel": "融合方式",
        "weightDistributionLabel": "重み配分",
        "vectorSliderLabel": "ベクターの重み",
        "keywordSliderLabel": "キーワードの重み",
        "sqlSettingsLabel": "SQL 設定",
        "maxRowsLabel": "返却する最大行数",
        "enableFullTextSearchLabel": "全文検索を有効にする",
        "rerankingLabel": "リランキング",
        "enableCrossEncoderRerankingLabel": "クロスエンコーダーによるリランキングを有効にする",
        "rerankingModelLabel": "リランキングモデル",
        "loadingModelsOption": "モデルを読み込み中…",
        "noRegisteredModelsOption": "登録済みモデルがありません",
        "rerankTopKLabel": "リランク Top K",
        "infoCardText": "これらの設定は、RAG クエリ実行時にこのテーブルがどのように取得されるかを制御します。変更は次回このテーブルにクエリが実行される際に適用されます。"
      },
      "columnEditor": {
        "semanticTypeId": "識別子",
        "semanticTypeIdDescription": "レコードを一意に識別します（例：主キー）",
        "semanticTypeEntity": "エンティティ",
        "semanticTypeEntityDescription": "名前を持つ人物、場所、または物を指します",
        "semanticTypeMetric": "メトリック",
        "semanticTypeMetricDescription": "集計や測定に使用される数値",
        "semanticTypeDimension": "ディメンション",
        "semanticTypeDimensionDescription": "グループ化やフィルタリングに使用されるカテゴリ属性",
        "semanticTypeTimestamp": "タイムスタンプ",
        "semanticTypeTimestampDescription": "日付または時刻の値",
        "semanticTypeText": "テキスト",
        "semanticTypeTextDescription": "自由形式のテキストコンテンツ",
        "closeEditorTitle": "エディタを閉じる",
        "businessNameLabel": "ビジネス名",
        "businessNameHint": "この列に対する分かりやすい名前",
        "businessNamePlaceholder": "例：顧客名",
        "descriptionLabel": "説明",
        "descriptionHint": "この列が何を表すかを説明してください",
        "descriptionPlaceholder": "例：顧客の正式な氏名",
        "semanticTypeLabel": "セマンティックタイプ",
        "semanticTypeHint": "この列が保持するデータの種類を分類します",
        "exampleValuesLabel": "サンプル値",
        "exampleValuesHint": "この列の理解を助けるサンプル値",
        "addExamplePlaceholder": "サンプル値を追加",
        "constraintsLabel": "制約",
        "constraintsHint": "この列に対するビジネスルールまたは検証制約",
        "constraintsPlaceholder": "例：空にできません",
        "relationshipsLabel": "リレーション",
        "relationshipsHint": "この列が関連する他のテーブルまたは列",
        "tableNamePlaceholder": "テーブル名",
        "columnNamePlaceholder": "列名",
        "relationshipTypeForeignKey": "外部キー",
        "relationshipTypeReference": "参照",
        "addRelationshipButton": "リレーションを追加",
        "searchSettingsLabel": "検索設定",
        "searchSettingsHint": "この列が検索と取得でどのように使用されるかを制御します",
        "searchableLabel": "検索可能",
        "searchableHint": "この列を全文検索およびキーワード検索に含めます",
        "embedForVectorSearchLabel": "ベクター検索用に埋め込む",
        "embedForVectorSearchHint": "セマンティック検索をサポートするため、この列の埋め込みを生成します"
      },
      "tableDescriptionEditor": {
        "tablePurposeLabel": "テーブルの目的",
        "tablePurposeHelp": "このテーブルが何に使用されるかを説明してください",
        "tablePurposePlaceholder": "例：レポート用に顧客の注文履歴を保存する",
        "businessContextLabel": "ビジネスコンテキスト",
        "businessContextHelp": "ビジネスコンテキストと、このテーブルが全体のデータモデルにどう組み込まれるかを説明してください",
        "businessContextPlaceholder": "例：営業チームが注文処理を追跡するために使用",
        "sampleQuestionsLabel": "サンプル質問",
        "sampleQuestionsHelp": "このテーブルが回答に役立つ質問の例",
        "removeQuestionTitle": "質問を削除",
        "addQuestionPlaceholder": "サンプル質問を追加",
        "addQuestionTitle": "質問を追加",
        "addButton": "追加",
        "tipsTitle": "ヒント",
        "tip1": "テーブルに含まれる内容と利用者を具体的に記載してください。",
        "tip2": "ユーザーが検索しそうなビジネス用語を含めてください。",
        "tip3": "サンプル質問を追加すると、取得モデルが関連するクエリを照合しやすくなります。",
        "tip4": "説明は簡潔かつ有益に保ってください。"
      },
      "schemaVisualizer": {
        "semanticTypeId": "識別子",
        "semanticTypeTimestamp": "タイムスタンプ",
        "semanticTypeMetric": "メトリック",
        "semanticTypeDimension": "ディメンション",
        "semanticTypeEntity": "エンティティ",
        "semanticTypeText": "テキスト",
        "groupPrimaryKeys": "主キー",
        "groupForeignKeys": "外部キー",
        "groupTimestamps": "タイムスタンプ",
        "groupMetrics": "メトリック",
        "groupDimensions": "ディメンション",
        "groupOther": "その他",
        "subtitle": "テーブル列とその関係の視覚的な概要",
        "columnCount": "{{count}} 列",
        "columnCount_other": "{{count}} 列",
        "hasOntologyLegend": "オントロジー定義あり",
        "foreignKeyLegend": "外部キー"
      }
    },
    "tableOntologyPage": {
      "noTableIdError": "テーブル ID が指定されていません",
      "saveSuccessToast": "オントロジーを保存しました",
      "saveErrorToast": "オントロジーの保存に失敗しました：{{message}}",
      "unsavedChangesConfirm": "保存されていない変更があります。本当に移動しますか？",
      "loadingMessage": "テーブルオントロジーを読み込み中…",
      "schemaEditorUnavailableTitle": "スキーマエディタは利用できません",
      "schemaEditorUnavailableMessage": "このテーブルのコネクタタイプではスキーマエディタを利用できません。",
      "failedToLoadTitle": "テーブルの読み込みに失敗しました",
      "tableNotFoundMessage": "要求されたテーブルが見つかりませんでした。",
      "goBack": "戻る",
      "backToKnowledgeTooltip": "Knowledge に戻る",
      "breadcrumbKnowledge": "Knowledge",
      "breadcrumbTables": "テーブル",
      "breadcrumbOntology": "オントロジー",
      "vectorBadge": "ベクター",
      "unsavedChangesBadge": "未保存の変更",
      "resetToSavedTooltip": "最後に保存したバージョンにリセット",
      "reset": "リセット",
      "saving": "保存中…",
      "saveChanges": "変更を保存",
      "schemaPanelTitle": "スキーマ",
      "databaseLabel": "データベース",
      "schemaLabel": "スキーマ",
      "tableLabel": "テーブル",
      "rowsLabel": "行数",
      "embeddingModelTitle": "埋め込みモデル",
      "loadingModels": "モデルを読み込み中…",
      "noEmbeddingModelsWarning": "登録済みの埋め込みモデルがありません。このテーブルでベクター検索を有効にするには、モデルを登録してください。",
      "selectModelOption": "モデルを選択",
      "modelOptionDefaultLabel": "{{name}}（デフォルト）",
      "modelOptionLabel": "{{name}}",
      "noModelSelectedWarning": "埋め込みモデルが選択されていません。このテーブルではベクター検索を利用できません。",
      "columnsHeader": "列",
      "hasOntologyDefinedTooltip": "この列にオントロジーが定義されています",
      "tabDescription": "説明",
      "tabRetrieval": "取得",
      "tabTest": "テスト",
      "queryTestingTitle": "クエリテスト",
      "queryTestingDescription": "このテーブルの設定に基づいてクエリがどのように取得されるかをテストします。",
      "comingSoon": "近日公開"
    },
    "mongoCompassDocumentView": {
      "documentViewTitle": "ドキュメント表示",
      "documentsTab": "ドキュメント",
      "tabularViewTitle": "表形式表示",
      "tableTab": "テーブル",
      "exportDataButton": "データをエクスポート",
      "closeAriaLabel": "閉じる",
      "filterLabel": "フィルター",
      "filterPlaceholder": "例：{ status: \"active\" }",
      "filterInputAriaLabel": "フィルタークエリ",
      "clearFilterAriaLabel": "フィルターをクリア",
      "applyFilterTitle": "フィルターを適用",
      "findButton": "検索",
      "queryHint": "MongoDB のクエリフィルターを JSON 形式で入力してください",
      "documentCountLabel": "{{count}} 件のドキュメント",
      "documentCountLabel_other": "{{count}} 件のドキュメント",
      "zeroResults": "結果はありません",
      "pageRangeHint": "{{total}} 件中 {{from}}〜{{to}} 件",
      "documentFallbackLabel": "ドキュメント {{index}}",
      "hideDocumentAriaLabel": "ドキュメントを非表示",
      "showDocumentAriaLabel": "ドキュメントを表示",
      "skipLimitLabel": "スキップ：{{skip}}、上限：{{limit}}",
      "pageSizeLabel": "ページサイズ",
      "pageSizeSelectAriaLabel": "ページサイズを選択",
      "previousButton": "前へ",
      "nextButton": "次へ"
    }
  },
  "accessRequests": {
    "manageAccessTitle": "{{assetLabel}}のアクセス管理",
    "assetTypeLabels": {
      "models": "モデル",
      "tools": "ツール",
      "knowledge": "ナレッジ",
      "storage": "ストレージ",
      "skills": "スキル",
      "orchestrators": "オーケストレーター",
      "default": "アセット"
    },
    "statusLabels": {
      "requested": "保留中",
      "approved": "承認済み",
      "open": "取り消し済み"
    },
    "loadingRequests": "アクセスリクエストを読み込んでいます...",
    "clearSearch": "検索をクリア",
    "emptyStateAll": "{{assetType}}のアクセスリクエストはありません。",
    "emptyStateFiltered": "{{assetType}}の{{status}}のアクセスリクエストはありません。",
    "selectedCount": "{{count}}件選択中",
    "selectAll": "すべて選択",
    "deselectAll": "すべて選択解除",
    "approveSelected": "選択項目を承認 ({{count}})",
    "rejectSelected": "選択項目を拒否 ({{count}})",
    "columnAssetName": "アセット名",
    "columnProject": "プロジェクト",
    "columnRequestedBy": "リクエスト者",
    "columnStatus": "ステータス",
    "columnCreated": "作成日",
    "columnLastUpdated": "最終更新",
    "columnActions": "アクション",
    "approve": "承認",
    "reject": "拒否",
    "reApprove": "再承認",
    "revokeAccess": "アクセスを取り消す",
    "rowsPerPage": "1ページあたりの行数:",
    "showingRange": "{{total}}件中{{start}}〜{{end}}件を表示",
    "goToFirstPage": "最初のページに移動",
    "goToPreviousPage": "前のページに移動",
    "goToPage": "ページ{{page}}に移動",
    "goToNextPage": "次のページに移動",
    "goToLastPage": "最後のページに移動",
    "firstPage": "最初のページ",
    "previousPage": "前のページ",
    "nextPage": "次のページ",
    "lastPage": "最後のページ",
    "endOfTableReached": "テーブルの末尾に達しました",
    "statusFilterLabel": "ステータス",
    "statusFilterPlaceholder": "ステータス",
    "projectFilterLabel": "プロジェクト",
    "projectFilterPlaceholder": "プロジェクト",
    "requestedByFilterLabel": "リクエスト者",
    "requestedByFilterPlaceholder": "リクエスト者",
    "bulkApprovePartial": "{{processed}}件承認、{{skipped}}件失敗: {{errors}}",
    "bulkRejectPartial": "{{processed}}件拒否、{{skipped}}件失敗: {{errors}}"
  },
  "skills": {
    "title": "スキル (Skills)",
    "subtitle": "スキルは、エージェントの機能を強化するモジュール式の命令パッケージです。",
    "list": {
      "columns": {
        "name": "スキル名",
        "category": "カテゴリー",
        "type": "タイプ",
        "model": "モデル",
        "visibility": "公開設定",
        "version": "バージョン",
        "access": "アクセス",
        "updated": "更新日",
        "actions": "アクション"
      },
      "actions": {
        "view": "表示",
        "edit": "編集",
        "delete": "削除",
        "export": "エクスポート",
        "clone": "プロジェクトにクローン",
        "manageAccess": "アクセス管理",
        "exportSelected": "選択項目をエクスポート",
        "deleteSelected": "選択項目を削除"
      },
      "badges": {
        "builtin": "組み込み",
        "platform": "プラットフォーム",
        "allModels": "全モデル"
      },
      "bulkDelete": {
        "title": "選択したスキルを削除",
        "noSelection": "スキルが選択されていません",
        "cannotDeleteBuiltin": "組み込みのプラットフォームスキルは削除できません",
        "skippedBuiltin": "{{count}} 個の組み込みスキルはスキップされます。",
        "success": "{{count}} 個のスキルを正常に削除しました",
        "partial": "{{deleted}} 個のスキルを削除し、{{skipped}} 個が失敗しました：{{errors}}",
        "error": "スキルの削除に失敗しました"
      }
    },
    "categories": {
      "data_processing": "データ処理",
      "data_analysis": "データ分析",
      "reasoning": "推論",
      "code_generation": "コード生成",
      "document_analysis": "ドキュメント分析",
      "web_interaction": "Webインタラクション",
      "communication": "コミュニケーション",
      "research": "リサーチ",
      "automation": "自動化",
      "custom": "カスタム"
    },
    "types": {
      "behavioral": "行動",
      "procedural": "手続き型",
      "knowledge": "知識",
      "guardrail": "ガードレール",
      "custom": "カスタム"
    },
    "visibility": {
      "project": "プロジェクト",
      "tenant": "組織",
      "public": "プラットフォーム"
    },
    "filters": {
      "category": "カテゴリー",
      "type": "タイプ",
      "visibility": "公開設定",
      "project": "プロジェクト",
      "all": "すべて",
      "favorites": "お気に入り"
    },
    "newSkill": "新規スキル",
    "loading": "スキルを読み込み中...",
    "empty": {
      "message": "スキルが見つかりません。エージェントの機能を強化するために最初のスキルを作成してください。"
    },
    "delete": {
      "title": "スキルを削除",
      "message": "「{{name}}」を削除してもよろしいですか？この操作は元に戻せません。",
      "bulkMessage": "{{count}} 個のスキルを削除してもよろしいですか？この操作は元に戻せません。",
      "bulkConfirm": "{{count}} 個のスキルを削除",
      "bulkDepsOthers": "{{names}} と他 {{count}} 個"
    },
    "messages": {
      "dependencyCheckFailed": "スキルの依存関係の確認に失敗しました",
      "deleteFailed": "スキルの削除に失敗しました"
    },
    "edit": {
      "subtitle": {
        "new": "モジュール式機能を作成する",
        "readonly": "スキルの設定（読み取り専用）",
        "edit": "スキルの設定を編集する"
      },
      "sidebar": {
        "settings": "スキルの設定",
        "tags": "タグ",
        "loadingQuota": "クォータを読み込み中..."
      },
      "placeholders": {
        "name": "スキル名",
        "description": "このスキルが何をするかの簡単な説明",
        "instructions": "# スキルの手順\nこのスキルが提供する特定の機能を説明します。\n\n## コアルール\n1. エージェントがどのように振る舞うべきかを定義する\n2. 段階的な手順をリストアップする\n3. 制約事項を指定する\n\n## 例\n期待される出力の例を提供してください...",
        "project": "プロジェクトを選択",
        "modelAgnostic": "モデル非依存（すべてのモデル）"
      },
      "hints": {
        "targetModel": "特定のモデルにこのスキルをタグ付けできます。タグ付けされていないスキルはすべてのモデルと互換性があります。",
        "visibilityProject": "スキルは選択したプロジェクトでのみ利用可能になります。",
        "visibilityPlatform": "スキルは承認ワークフローを通じてすべてのプロジェクトで利用可能になります。"
      },
      "editor": {
        "instructions": "手順 (SKILL.md)",
        "markdownSupported": "Markdownをサポート",
        "noInstructions": "プレビューする手順がまだありません。"
      },
      "header": {
        "quotaExceeded": "スキルクォータを超過しました",
        "createSkill": "スキルを作成",
        "saveChanges": "変更を保存"
      }
    }
  },
  "agentAutoTune": {
    "meta": {
      "breadcrumb": "パンくずリスト",
      "agentStudio": "エージェントスタジオ",
      "autoTuneRunsList": "自動調整実行リスト",
      "metaDashboard": "メタダッシュボード"
    },
    "compare": {
      "phaseStep": "フェーズ / ステップ",
      "score": "スコア",
      "metric": "メトリック",
      "baselineScore": "ベースラインスコア",
      "optimizedScore": "最適化されたスコア",
      "improvementPct": "改善率 %",
      "holdoutScore": "ホールドアウトスコア",
      "costUsd": "コスト (USD)",
      "iterations": "イテレーション",
      "nodesOptimized": "最適化されたノード",
      "nodesTotal": "合計ノード",
      "version": "バージョン",
      "node": "ノード",
      "loadingSessions": "比較のためのセッションを読み込んでいます...",
      "selectSessions": "比較するには、少なくとも2つのセッションを選択してください。",
      "backToRuns": "自動調整の実行に戻る",
      "runComparisonTitle": "実行比較",
      "comparingSessions": "{{count}} 個の自動調整セッションを比較中",
      "summaryComparison": "概要比較",
      "noDataToCompare": "比較するデータがありません",
      "scoreTrajectoryOverlay": "スコア軌跡オーバーレイ",
      "comparingRuns": "実行の比較",
      "chartExplainer1": "ノードレベルの帰属用ではありません。シリーズにはギャップが埋め込まれているため、不均等な",
      "chartExplainer2": "軌跡の長さがインデックスによって揃えられます。",
      "labelsMatch": "ラベルは最長セッションと一致します",
      "phasesBaseline": "構造が類似している場合は、ベースライン /",
      "validationLinesUp": "検証が実行全体で一致するフェーズ。",
      "notEnoughTrajectory": "プロットする軌道データが不十分です（1つのセッションに少なくとも2つのポイントが必要です）。",
      "nodeLevelScore": "ノードレベルのスコア比較",
      "noNodeDataToCompare": "比較するノードデータがありません",
      "overlayExplainer": "選択した各実行の複合スコア曲線にオーバーレイします。X軸は最長の実行フェーズに従います。短い実行は途中で停止します。"
    },
    "runs": {
      "title": "エージェント自動調整",
      "subtitle": "エージェントのエンドツーエンド最適化実行",
      "newAutoTune": "新しい自動調整",
      "newAutoTuneButton": "新しい自動調整",
      "selectProjectAgent": "最適化を開始するプロジェクトとエージェントを選択してください",
      "project": "プロジェクト",
      "agent": "エージェント",
      "proceed": "続行",
      "proceedButton": "続行",
      "startAutoTune": "自動調整を開始",
      "metaDashboard": "メタダッシュボード",
      "metaDashboardButton": "メタダッシュボード",
      "compareSelected": "選択した項目を比較",
      "status": "ステータス",
      "approval": "承認",
      "optimizer": "最適化ツール",
      "searchPlaceholder": "セッションを検索...",
      "backToAgentsAria": "エージェントに戻る",
      "loadingMessage": "自動調整の実行を読み込み中...",
      "emptyMessage": "自動調整の実行はまだありません。「新しい自動調整」をクリックして開始してください。",
      "statuses": {
        "all": "すべてのステータス",
        "queued": "キュー詰み",
        "running": "実行中",
        "baseline_running": "ベースライン",
        "optimizing": "最適化中",
        "validating": "検証中",
        "completed": "完了",
        "completed_partial": "一部完了",
        "failed": "失敗",
        "cancelled": "キャンセル済み"
      },
      "approvals": {
        "all": "すべての承認",
        "pending": "保留中",
        "approved": "承認済み",
        "rejected": "却下"
      },
      "optimizers": {
        "all": "すべての最適化ツール"
      },
      "picker": {
        "loadingProjects": "プロジェクトを読み込み中…",
        "selectProject": "プロジェクトを選択…",
        "selectAgent": "エージェントを選択…",
        "selectProjectFirst": "最初にプロジェクトを選択…",
        "loadingAgents": "エージェントを読み込み中…",
        "noAgents": "このプロジェクトにエージェントはいません"
      },
      "columns": {
        "agentName": "エージェント名",
        "dataset": "データセット",
        "optimizer": "最適化ツール",
        "version": "バージョン",
        "status": "ステータス",
        "approval": "承認",
        "baselineScore": "ベースラインスコア",
        "postTuneScore": "調整後スコア",
        "holdout": "ホールドアウト",
        "improvement": "改善率",
        "trajectory": "軌跡",
        "cost": "コスト",
        "nodes": "ノード",
        "healing": "ヒーリング",
        "duration": "所要時間",
        "createdBy": "作成者",
        "createdAt": "作成日時",
        "actions": "アクション",
        "optimizedNodes": "{{optimized}}/{{total}} 最適化済み"
      },
      "actions": {
        "compareSelected": "選択した項目を比較",
        "retry": "再試行",
        "stopRun": "実行停止",
        "delete": "削除",
        "stopConfirm": "「{{label}}」の自動調整をキャンセルしますか？これによりパイプライン（Temporalワークフロー）が即座に停止します。",
        "cancelSuccess": "自動調整をキャンセルしました。",
        "cancelError": "自動調整のキャンセルに失敗しました。もう一度お試しください。",
        "deleteConfirm": "「{{label}}」の自動調整セッションを削除しますか？この操作は取り消せません。",
        "deleteSuccess": "自動調整セッションを削除しました。",
        "deleteError": "セッションの削除に失敗しました。"
      },
      "retryDialog": {
        "title": "自動調整の再試行",
        "message": "次のエージェントの新しい自動調整を開始します: ",
        "messageSuffix": "（この実行と同じデータセットとオプションを使用しますか？）",
        "confirmLabel": "再試行",
        "successToast": "新しい自動調整を開始しました。",
        "errorToast": "自動調整の再試行に失敗しました。"
      }
    },
    "detail": {
      "agentStudio": "エージェントスタジオ",
      "autoTuneRunsList": "自動調整実行リスト",
      "backToList": "リストに戻る",
      "sessionOverview": "セッション概要",
      "configuration": "構成",
      "evaluationDetail": "評価の詳細",
      "nodeFeedback": "ノードのフィードバック",
      "nodeComparison": "ノード比較",
      "iterationHistory": "イテレーション履歴",
      "approveDeploy": "承認とデプロイ",
      "applyChanges": "ドラフトに変更を適用",
      "rejectOptimization": "最適化を拒否",
      "sessionStatus": "セッションステータス",
      "optimizerConfig": "オプティマイザー設定",
      "evaluation": "評価",
      "originalSystemPrompt": "元のシステムプロンプト",
      "optimizedSystemPrompt": "最適化されたシステムプロンプト",
      "loading": {
        "opening": "自動調整実行を開いています…",
        "session": "最適化セッションを読み込み中..."
      },
      "notFound": {
        "message": "自動調整セッションが見つかりません",
        "backButton": "自動調整実行一覧に戻る"
      },
      "header": {
        "defaultTitle": "最適化インテリジェンスセンター",
        "workflow": "ワークフロー",
        "created": "作成日",
        "backToRunsAria": "実行一覧に戻る"
      },
      "banner": {
        "failedTitle": "最適化失敗",
        "rejectedTitle": "最適化プロンプトが却下されました",
        "noReason": "却下理由は提供されませんでした。"
      },
      "tabs": {
        "overview": "概要",
        "objectives": "目的関数",
        "nodes": "ノード分析",
        "prompts": "プロンプトラボ",
        "regression": "回帰分析",
        "execution": "実行トレース",
        "audit": "監査とヒーリング"
      },
      "applyPanel": {
        "title": "適用戦略",
        "applyCurrent": "現在のエージェントに適用",
        "newVersion": "新しいバージョンとして保存",
        "previewOnly": "プレビューのみ",
        "versionBump": "バージョンアップ:",
        "saveAsNewProject": "新しいプロジェクトとして保存",
        "projectName": "プロジェクト名",
        "placeholderReason": "オプションの理由...",
        "reject": "却下",
        "approveApply": "承認して適用",
        "noPermission": "プロジェクトを作成する権限がありません。",
        "previewUnavailable": "プレビューのみでは利用できません — 最初に適用戦略を選択してください。"
      },
      "overview": {
        "pairedBaseline": "ペアのベースライン（訓練）",
        "pairedPostMean": "ペアの調整後平均",
        "evalAccuracyImprovement": "評価精度の改善",
        "baselineTrain": "ベースライン（訓練）",
        "baselineHoldout": "ベースライン（ホールドアウト）",
        "optimizedScoreTrain": "最適化スコア（訓練）",
        "optimizedScoreHoldout": "最適化スコア（ホールドアウト）",
        "improvementTrain": "改善率（訓練）",
        "improvementHoldout": "改善率（ホールドアウト）",
        "estimatedCost": "推定コスト",
        "duration": "所要時間",
        "totalIterations": "総反復回数",
        "optimizer": "最適化ツール",
        "nodesTotal": "総ノード数",
        "tokensSession": "トークン（セッション）",
        "metricsUsed": "使用されたメトリクス",
        "orchestrator": "オーケストレーター",
        "openWorkflowRun": "ワークフロー実行を開く",
        "lightningRuns": "エージェントライトニング実行",
        "runId": "実行ID",
        "start": "開始",
        "end": "終了",
        "optimizedScore": "最適化スコア",
        "improvement": "改善率",
        "iterations": "反復回数",
        "holdoutPostTune": "ホールドアウト（調整後）",
        "cost": "コスト",
        "version": "バージョン",
        "configurationSummary": "構成サマリー",
        "runTimeline": "実行タイムライン",
        "timeline": {
          "created": "作成日時",
          "started": "開始日時",
          "completed": "完了日時",
          "approvedBy": "{{user}} により承認済み"
        },
        "noMetricBreakdown": "このセッションではメトリクスごとの内訳は利用できません（たとえば、スコアがメトリクスごとに保持されていませんでした）。ヘッドラインスコアがどのように定義されているかについては、スコアリングの詳細（情報アイコン）を開いてください。",
        "metricBreakdownTitle": "メトリクス内訳",
        "columnMetric": "メトリクス",
        "columnBaseline": "ベースライン",
        "columnOptimized": "最適化済み",
        "columnDelta": "デルタ",
        "columnChange": "変化",
        "explainerLead": "スコアは評価メトリクスから構築された0〜1の範囲の単一の合成値であり、ベンチマーク行全体で集計されます。",
        "explainerStep1Title": "行ごとの合成（目的）",
        "explainerStep1Desc": "各データセット行について、システムは設定されたエバリュエーター（以下のメトリクスを参照）を実行し、メトリクスごとに1つのスコアを生成します。低い生の値が良いメトリクス（たとえば毒性）は、混合する前につねに高い方が良いことを意味するようにマッピングされます。",
        "explainerWeightedSumPrefix": "行スコアは",
        "explainerWeightedSum": "加重和",
        "explainerWeightedSumMid": "これらの調整済みスコアの：",
        "explainerWeightedSumSuffix1": "、使用する",
        "explainerWeightedSumSuffix2": "このセッションから（合計が1になるように正規化されます）。",
        "explainerUnweightedPrefix": "何も",
        "explainerUnweightedMid": "設定されていないため、行スコアは",
        "explainerUnweighted": "非加重平均",
        "explainerUnweightedSuffix": "その行の調整済みメトリクススコアの。",
        "explainerStep2Title": "ベースラインスコア（訓練分割）",
        "explainerStep2Desc": "ヘッドラインベースラインは、訓練分割（ホールドアウト行を除く）での行ごとの合成スコアの算術平均であり、設定されたセッションメトリクスのみを使用し、実行エラーなしで完了した行を対象とします：",
        "explainerStep3Title": "最適化スコアと軌跡",
        "explainerStep3Desc": "プロンプト変更後にエージェントをスコアリングする場合にも同じ合成定義が使用されます。ヘッドラインの最適化スコアと反復曲線もこの同じスケールを使用します。",
        "explainerMultiObjEnabled": "多目的モードが有効になっています。",
        "explainerMultiObjMid": "（以下）は多目的最適化をガイドする場合があります。ベースラインおよび行合成は引き続き",
        "explainerMultiObjSuffix": "設定されている場合はこれに従い、それ以外の場合は上記のような均等な重み付けになります。",
        "explainerMetricsEvaluated": "このセッションで評価されたメトリクス",
        "explainerRowWeights": "行合成ウェイト",
        "explainerMultiObjWeights": "多目的ウェイト",
        "columnRawWeight": "生のウェイト",
        "columnNormalized": "正規化済み",
        "columnMetricObjective": "メトリクス / 目的",
        "explainerThisSession": "このセッション:",
        "explainerBaselineTrain": "ベースライン（訓練）=",
        "explainerOptimizedEquals": "最適化済み ="
      },
      "objectives": {
        "noObjectives": "目的が定義されていません",
        "columnName": "目的関数名",
        "columnWeight": "ウェイト",
        "columnFormula": "計算式",
        "columnDescription": "説明"
      },
      "nodes": {
        "noNodes": "ノードの結果はありません",
        "columnId": "ノードID",
        "columnOptimizer": "最適化ツール",
        "columnBaseline": "ベースラインスコア",
        "columnOptimized": "最適化スコア",
        "columnImprovement": "改善率",
        "columnTrajectory": "軌跡",
        "columnHoldout": "ホールドアウトスコア",
        "columnHoldoutImp": "ホールドアウト改善率",
        "customPrompt": "カスタムシステムプロンプト",
        "modelOverride": "モデル上書き",
        "instructionsOverride": "DSPy指示上書き",
        "columnNode": "ノード",
        "columnIter": "反復",
        "columnBlame": "ブレーム",
        "columnOriginalTrain": "オリジナル（訓練）",
        "columnOptimizedTrain": "最適化済み（訓練）",
        "columnHealing": "ヒーリング",
        "columnCost": "コスト",
        "collapse": "折りたたむ",
        "showConfig": "設定 / 最適化ツールの詳細を表示",
        "noNodeAnalysisData": "このセッションのノード分析データはありません。"
      },
      "prompts": {
        "nodeLabel": "ノード:",
        "selectNode": "ノードを選択してプロンプトをインスペクトしてください...",
        "originalSystemPrompt": "元のシステムプロンプト",
        "optimizedSystemPrompt": "最適化されたシステムプロンプト",
        "originalInstructions": "元の指示（DSPy）",
        "optimizedInstructions": "最適化された指示（DSPy）",
        "versionBase": "ベース",
        "versionLatest": "最新の最適化",
        "selectVersion": "バージョンを選択",
        "fallbackLeft": "左",
        "fallbackRight": "右",
        "noData": "このセッションのプロンプトまたはパラメータデータはありません。"
      },
      "regression": {
        "noData": "回帰分析データはありません。",
        "columnRowIndex": "行インデックス",
        "columnBaseline": "ベースライン",
        "columnOptimized": "最適化済み",
        "columnChange": "変更",
        "columnInput": "入力プレビュー",
        "columnError": "エラー",
        "columnOutput": "出力プレビュー",
        "improvedRows": "改善された行",
        "degradedRows": "悪化した行",
        "quarantinedRows": "検疫された行",
        "columnRowNumber": "行 #",
        "columnQuestionInput": "質問 / 入力",
        "columnDelta": "デルタ",
        "columnWhatChanged": "変更内容",
        "columnInputPreview": "入力プレビュー",
        "columnOutputPreview": "出力プレビュー",
        "metricNetImprovement": "正味改善率",
        "metricImprovedRows": "改善された行",
        "metricDegradedRows": "悪化した行",
        "metricUnchangedRows": "変更なしの行",
        "metricTotalRows": "全行数",
        "metricHoldoutEvaluated": "評価されたホールドアウト行",
        "noDegradedRows": "悪化した行はありません",
        "noImprovedRows": "改善された行はありません",
        "noQuarantinedRows": "検疫された行はありません",
        "noReport": "このセッションの回帰レポートまたは検疫された行はありません。"
      },
      "execution": {
        "title": "パイプライン実行タイムライン",
        "noData": "実行タイムラインデータはありません。",
        "columnTask": "タスク / フェーズ",
        "columnDuration": "所要時間",
        "columnStatus": "ステータス",
        "columnDetails": "詳細 / 出力",
        "activeRun": "アクティブな実行",
        "currentProcess": "現在のプロセス",
        "activeNode": "アクティブなノード",
        "optimizingNode": "最適化中のノード: {{node}}",
        "nodeId": "ノードID",
        "lastProcess": "最後のプロセス",
        "phaseDurationWaterfall": "フェーズ期間ウォーターフォール",
        "phaseDurationDesc": "完了した実行フェーズの期間（秒、時系列）。",
        "phaseDurationExplainer": "各バーは完了したワークフローフェーズ（ベースライン、ジョイント/Lightning、ノードごとの最適化、検証）です。高さは秒単位の期間です。最後の合計バーは、完了したすべてのフェーズを合計したものです。",
        "phaseDurationsPending": "ステージが完了すると、ここにフェーズ期間が表示されます。",
        "phaseDurationsEmpty": "この実行のフェーズ期間履歴は記録されていません。",
        "phaseLog": "フェーズログ",
        "fallbackPhase": "フェーズ {{num}}"
      },
      "audit": {
        "healingEvents": "ヒーリングイベント",
        "auditTrail": "監査証跡",
        "noData": "このセッションの監査またはヒーリングデータはありません。",
        "auditTrailCount": "監査証跡"
      },
      "charts": {
        "scoreTrajectory": "スコアの軌跡",
        "baselineObjective": "ベースラインと目的のスコアリング",
        "metricComparison": "メトリクス比較: ベースライン vs 最適化",
        "convergenceAnalysis": "収束分析",
        "blameWaterfall": "ブレームウォーターフォール",
        "costTokenBreakdown": "ノード別のコストとトークン内訳",
        "scatterBaselineOpt": "ベースライン vs 最適化の散布図（訓練行）",
        "phaseDuration": "フェーズ期間ウォーターフォール",
        "howToRead": "このチャートの読み方",
        "xAxisPhase": "フェーズ",
        "yAxisDuration": "所要時間（秒）",
        "summaryScoreTrajectory": "各実行マイルストーン（ベースライン、オプションのLightning、最適化反復、検証）での合成スコア。第2軸にステップごとのデルタを表示します。",
        "summaryBaselineObjective": "メトリクスからの0〜1の合成スコア。成功した行にわたるベースラインの平均。数式、ウェイト、このセッションの値については情報アイコンを使用してください。",
        "summaryMetricComparison": "グループ化されたバーは、設定された各メトリクスのベースラインとチューニング後の平均を比較します。",
        "summaryConvergenceAnalysis": "連続する軌跡ポイント間の|Δスコア|—改善が減速または停滞するタイミングを見つけるのに役立ちます。",
        "summaryBlameWaterfall": "キャンバスノードごとの相対的なブレームスコア—バーが高いほど、ベースラインの結果が悪化する原因となったノードであり、最適化の優先度が高くなる傾向があります。",
        "summaryCostTokenBreakdown": "すべての評価を通じて各ノードに割り当てられた、合計プロンプトと完了トークン（左軸）および推定コスト（右軸）。",
        "summaryScatterBaselineOpt": "各ポイントは検証後の1つのトレーニング行です。x = チューニング前の合成スコア、y = チューニングされたプロンプトでの合成スコア。破線の対角線は変化なしの線（y = x）です。"
      }
    }
  },
  "aiTransparency": {
    "title": "AIトランスペアレンシー",
    "loadingInventory": "AIトランスペアレンシーのインベントリを読み込んでいます...",
    "allSystemAgents": "すべてのシステムエージェント",
    "systemAgent": "システムエージェント",
    "registeredBy": "登録者",
    "project": "プロジェクト",
    "agentSubAgent": "エージェント / サブエージェント",
    "env": "環境",
    "subAgentCount": "サブエージェント数",
    "actions": "アクション",
    "viewMetadata": "メタデータを表示",
    "searchAgents": "エージェントを検索...",
    "emptyMessage": "登録されているエージェントはまだありません。エージェントスタジオから公開されたエージェントを登録すると、ここに表示されます。",
    "unknown": "不明",
    "status": "ステータス",
    "metadata": "メタデータ",
    "expandAgent": "{{name}} を展開",
    "collapseAgent": "{{name}} を折りたたむ",
    "subAgentFallback": "サブエージェント {{index}}",
    "subAgentTypes": {
      "agent": "サブエージェント",
      "supervisor": "スーパーバイザー",
      "intent_classifier": "意図分類器",
      "disambiguation": "曖昧性解消",
      "external_agent": "外部エージェント",
      "rlm": "RLM",
      "router": "ルーター",
      "hitl": "人間の承認",
      "sub_agent": "サブエージェント"
    }
  },
  "registry": {
    "agents": {
      "columnAgentName": "エージェント名",
      "registerAgent": "エージェントを登録",
      "searchRegisteredAgents": "登録済みエージェントを検索...",
      "searchArchivedAgents": "アーカイブ済みエージェントを検索...",
      "emptyActiveAgentsDesc": "まだ登録されているエージェントはありません。エージェントスタジオから公開されたエージェントを登録すると、ここに表示されます。",
      "emptyArchivedAgentsDesc": "アーカイブされたエージェントはありません。レジストリからアーカイブされたエージェントがここに表示されます。",
      "registeredAgentsTitle": "登録済みエージェント",
      "archivedAgentsTitle": "アーカイブ済みエージェント",
      "agentsLabel": "エージェント",
      "agentRegistryTitle": "エージェントレジストリ",
      "filterSystemAgent": "システムエージェント",
      "filterAllSystemAgents": "すべてのシステムエージェント",
      "loadingAgents": "エージェントを読み込み中...",
      "searchAgents": "エージェントを検索...",
      "dynamicFilter_agent_type": "タイプ",
      "columnAgent": "エージェント",
      "editAgentTitle": "Edit Agent",
      "configureAgentTitle": "Configure {{platformName}}",
      "registerAgentBtn": "エージェントを登録",
      "selectAgentPlatformDesc": "エージェントが作成されたプラットフォームを選択してください",
      "importAgentsTitle": "CSVからエージェントをインポート",
      "importAgentsDesc": "外部エージェントのみを作成します。プロジェクト内の既存の名前＋バージョンに一致する行はスキップされ、上書きされることはありません。資格情報がCSVから読み取られることはありません。後で編集を通じて添付してください。",
      "agentEntity": "エージェント"
    },
    "workflows": {
      "columnWorkflow": "ワークフロー名",
      "workflowsLabel": "ワークフロー",
      "searchRegisteredWorkflows": "登録済みワークフローを検索...",
      "searchArchivedWorkflows": "アーカイブ済みワークフローを検索...",
      "loadingRegisteredWorkflows": "登録済みワークフローを読み込み中...",
      "loadingArchivedWorkflows": "アーカイブ済みワークフローを読み込み中...",
      "emptyRegisteredWorkflows": "まだワークフローが登録されていません。",
      "emptyArchivedWorkflows": "アーカイブ済みワークフローはありません。",
      "bulkArchiveWorkflows": "選択したアイテムをアーカイブ",
      "bulkRestoreWorkflows": "選択したアイテムを復元",
      "workflowRegistryTitle": "ワークフローレジストリ",
      "registeredWorkflowsTitle": "登録済みワークフロー",
      "archivedWorkflowsTitle": "アーカイブ済みワークフロー",
      "registerExternalWorkflowTitle": "外部ワークフローを登録",
      "selectWorkflowPlatformDesc": "ワークフローが構築されたプラットフォームを選択してください。この登録はカタログのみです（TAGPの実行はありません）。",
      "importWorkflowsTitle": "CSVからワークフローをインポート",
      "importWorkflowsDesc": "スタブドラフトワークフローのみを作成します。一致キーはプロジェクト内の名前＋バージョンです。既存のワークフローはスキップされ、上書きされることはありません。新しいスタブは、公開および登録するまでドラフト/未登録のままになります。",
      "workflowEntity": "ワークフロー",
      "loading": "ワークフローを読み込んでいます..."
    },
    "guardrails": {
      "guardrailsLabel": "ガードレール",
      "actionGuardrails": "ガードレール",
      "guardrailsRepository": "ガードレールリポジトリ",
      "agentGuardrails": "エージェントガードレール",
      "guardrailsCoverage": "カバレッジ",
      "searchProfiles": "プロファイルを検索...",
      "newProfile": "新しいプロファイル",
      "noGuardrailsAccess": "ガードレール機能へのアクセス権がありません。",
      "loadingProfiles": "プロファイルを読み込み中...",
      "columnAttachedProfiles": "添付プロファイル",
      "coverageBanner": "構成されたカバレッジのみ — 強制は変更しません。 ギャップはインベントリシグナルです。",
      "exportCoverageCsv": "CSVをエクスポート",
      "loadingCoverage": "カバレッジマップを読み込み中...",
      "coverageCovered": "対象",
      "coverageGap": "ギャップ",
      "coverageNA": "N/A",
      "coverageUnknown": "不明",
      "createProfileBtn": "プロファイルを作成",
      "savingProfileBtn": "保存中...",
      "updateProfileBtn": "プロファイルを更新",
      "editProfileTitle": "プロファイルを編集",
      "newGuardrailProfileTitle": "新しいGuardrailプロファイル",
      "profileNameLabel": "プロファイル名 *",
      "profileNamePlaceholder": "例: PII保護標準",
      "profileNameHint": "文字、数字、スペース、ハイフン、アンダースコアのみ",
      "profileDescLabel": "説明",
      "profileDescPlaceholder": "このGuardrailプロファイルについて説明してください...",
      "profileDescHint": "プレーンテキストのみ — 絵文字や特殊文字は使用できません",
      "guardrailsEnabled": "Guardrails 有効",
      "guardrailsDisabled": "Guardrails 無効",
      "noEnginesConfigured": "Guardrailエンジンが設定されていません",
      "enginesActive": "{{enabledCount}}/{{totalCount}} エンジンがアクティブ",
      "inactiveDeploymentBanner": "このエージェントの展開は非アクティブです。構成は制限されています。",
      "devFrozenBanner": "このエージェントは公開されています。DEVガードレールは凍結されています — 代わりにQA/UAT/PROD展開ガードレールを編集してください。",
      "adminOnlyBanner": "Deployment guardrails can only be modified by administrators.",
      "recentViolations": "Recent Violations",
      "metricsSummaryTitle": "メトリクス概要",
      "metricTotalChecks": "総チェック数",
      "metricBlocked": "ブロック",
      "metricWarned": "警告",
      "metricPassed": "パス",
      "metricErrors": "エラー",
      "metricLatency": "レイテンシ",
      "searchViolationsPlaceholder": "違反を検索...",
      "noRecentViolations": "最近の違反はありません",
      "violationTimestamp": "タイムスタンプ",
      "violationUser": "ユーザー",
      "violationEngine": "エンジン",
      "violationStatus": "ステータス",
      "violationDetails": "詳細",
      "violationAction": "アクション",
      "violationRule": "ルール",
      "columnEngines": "エンジン",
      "loading": "ガードレールを読み込んでいます...",
      "configMode": "モード",
      "configExecution": "実行",
      "configTimeout": "デフォルトのタイムアウト (秒)",
      "configSafeMessage": "セーフメッセージ",
      "configCircuitBreaker": "サーキットブレーカー",
      "configFailureThreshold": "障害しきい値",
      "configCooldown": "クールダウン (秒)",
      "modeBlock": "ブロック — フラグが付けられたコンテンツをブロック",
      "modeObserve": "監視 — ログのみ、ブロックしない",
      "execSequential": "シーケンシャル",
      "execParallel": "パラレル",
      "safeMessagePlaceholder": "コンテンツポリシーの制限により、このリクエストを処理できません。",
      "mode_block": "ブロック — フラグが付けられたコンテンツをブロック",
      "mode_warn": "警告 — 警告をログに記録し、コンテンツを許可",
      "mode_shadow": "監視 — ログのみ、ブロックしない",
      "exec_sequential": "シーケンシャル",
      "exec_parallel": "パラレル"
    },
    "common": {
      "columnProject": "プロジェクト",
      "columnVersion": "バージョン",
      "exportCsvTitle": "CSVエクスポート（列の設定を含む）",
      "exportCsvAria": "CSVエクスポート",
      "importCsvTitle": "CSVインポート",
      "importCsvAria": "CSVインポート",
      "columnEnv": "環境",
      "columnOrchestrator": "オーケストレーター",
      "columnFramework": "フレームワーク",
      "columnRegisteredBy": "登録者",
      "columnRegisteredAt": "登録日時",
      "columnArchivedAt": "アーカイブ日時",
      "columnActions": "操作",
      "columnStatus": "ステータス",
      "filterBarTitle": "フィルター",
      "filterFramework": "フレームワーク",
      "filterProject": "プロジェクト",
      "filterRegisteredBy": "登録者",
      "filterType": "タイプ",
      "filterStatus": "ステータス",
      "loadingRegistered": "登録済みエージェントを読み込み中...",
      "loadingArchived": "アーカイブ済みエージェントを読み込み中...",
      "bulkArchive": "選択したアイテムをアーカイブ",
      "bulkRestore": "選択したアイテムを復元",
      "bulkDelete": "選択したアイテムを削除",
      "deleteSelected": "選択したアイテムを削除",
      "showLess": "表示を減らす",
      "actionTest": "テスト",
      "actionEdit": "編集",
      "actionViewMetadata": "メタデータを表示",
      "actionEditMetadata": "メタデータを編集",
      "actionEvaluate": "評価",
      "actionViewEvalRuns": "評価実行を表示",
      "actionTraces": "トレース",
      "actionLogs": "ログ",
      "actionApiDocs": "APIドキュメント",
      "actionClone": "クローン",
      "actionDeploy": "デプロイ",
      "actionDelete": "削除",
      "actionArchive": "レジストリからアーカイブ",
      "actionRestore": "レジストリに復元",
      "actionOpen": "開く",
      "actionPromoteToStore": "ストアに昇格",
      "actionRuns": "実行",
      "actionOpenCanvas": "キャンバスを開く",
      "registerExternal": "外部を登録",
      "allCreators": "すべての作成者",
      "searchCreators": "作成者を検索...",
      "creatorLabel": "作成者",
      "tableRows": "行:",
      "tableShowing": "{{totalItems}} 件中 {{startItem}}-{{endItem}} 件を表示",
      "filterResultsOf": "{{totalCount}} 件中 {{resultCount}} 件",
      "filterResultsCount": "{{count}} 件の結果",
      "filterLess": "減らす",
      "filterMore": "さらに表示",
      "filterClearAll": "すべてのフィルターをクリア",
      "filterClear": "クリア",
      "filterSavePreset": "フィルターのプリセットを保存",
      "noDataAvailable": "利用可能なデータがありません",
      "actionView": "View",
      "filterAllEnvironments": "すべての環境",
      "dynamicFilter_status": "ステータス",
      "dynamicFilter_catalog_status": "ステータス",
      "dynamicFilter_type": "タイプ",
      "columnEnvShort": "環境",
      "columnChat": "チャット",
      "columnAPI": "API",
      "columnVoice": "音声",
      "columnRAG": "RAG",
      "columnTools": "ツール",
      "columnEnabled": "有効",
      "columnMode": "モード",
      "columnContentSafety": "コンテンツの安全性",
      "columnJailbreak": "ジェイルブレイク / Prompt Shields",
      "columnDLP": "DLP / PII",
      "columnProfileAttached": "プロファイル添付",
      "columnWorkflowChannel": "ワークフロー",
      "cancelBtn": "キャンセル",
      "globalSettings": "グローバル設定",
      "architectureTitle": "Architecture",
      "reviewSaveTitle": "Review & Save",
      "reviewRegisterTitle": "Review & Register",
      "stepReview": "確認",
      "stepPlatform": "プラットフォーム",
      "stepConfigure": "構成",
      "stepArchitecture": "アーキテクチャ",
      "savingBtn": "保存中...",
      "registeringBtn": "登録中...",
      "saveChangesBtn": "変更を保存",
      "statusActive": "active",
      "statusInactive": "inactive",
      "statusPublished": "PUBLISHED",
      "actionDeleteSelected": "選択した項目を削除",
      "columnName": "名前",
      "columnDescription": "説明",
      "expectedColumns": "期待される列",
      "platformAdminConfigureFields": "プラットフォーム管理者が設定するフィールド",
      "downloadTemplate": "テンプレートをダウンロード",
      "chooseCsv": "CSVを選択",
      "importBtn": "インポート",
      "importingBtn": "インポート中...",
      "nextBtn": "次へ",
      "reviewBtn": "確認",
      "registerWorkflowBtn": "ワークフローを登録",
      "dynamicOption_agent": "エージェント",
      "dynamicOption_sub-agent": "サブエージェント",
      "closeBtn": "閉じる",
      "statRows": "行",
      "statCreated": "作成済み",
      "statDuplicates": "重複",
      "statErrors": "エラー",
      "viewDuplicates": "重複を表示",
      "dupTitle": "インポートの重複がスキップされました",
      "dupRowsProcessed": "処理された行",
      "dupCreated": "作成済み",
      "dupSkipped": "スキップされた重複",
      "dupHint2": "データベースにすでにその名前がありますが、レジストリには表示されませんでした。名前を変更するか、バージョンを上げてください。",
      "dupNoMatch": "このフィルターに一致する重複はありません。",
      "dupSearchPlaceholder": "重複を検索...",
      "dupRowsPerPage": "ページあたりの行数:",
      "hideAll": "すべて隠す",
      "showAll": "すべて表示",
      "loading": "読み込み中..."
    }
  },
  "exportImport": {
    "import": {
      "dialogTitle": "YAMLをインポート",
      "bulkDialogTitle": "一括インポート",
      "filesCount": "{{count}} 件のファイル",
      "filesCount_plural": "{{count}} 件のファイル",
      "validFilesCount": "{{count}} 件の有効なファイル",
      "validFilesCount_plural": "{{count}} 件の有効なファイル",
      "withErrorsCount": "{{count}} 件のエラーあり",
      "withErrorsCount_plural": "{{count}} 件のエラーあり",
      "switchToSingle": "単一ファイルに切り替え",
      "switchToBulk": "一括インポートに切り替え",
      "targetProject": "対象プロジェクト",
      "optional": "(任意)",
      "selectTargetProject": "対象プロジェクトを選択...",
      "selectProjectOptional": "プロジェクトを選択 (任意)...",
      "selectProjectWarning": "{{entity}} をインポートするにはプロジェクトを選択してください",
      "thisEntity": "このエンティティ",
      "dropzoneBulk": "YAMLファイルをドロップするかクリックして参照 (複数可)",
      "dropzoneSingle": "YAMLファイルをドロップするかクリックして参照",
      "fileTypes": ".yaml, .yml",
      "importingProgress": "{{total}} 件中 {{current}} 件をインポート中...",
      "yamlContentLabel": "YAML コンテンツ",
      "yamlPlaceholderComment": "YAMLコンテンツをここに貼り付けまたは編集",
      "importBehavior": "インポートの動作",
      "matchOrCreate": "照合または新規作成",
      "matchOrCreateDesc": "既存のエンティティと関連付け、存在しない場合は新規作成",
      "matchOnly": "照合のみ",
      "matchOnlyDesc": "既存のものにのみ関連付け、存在しない場合はスキップ",
      "createNew": "新規作成",
      "createNewDesc": "常に新規作成、すでに存在する場合は失敗",
      "previewResults": "プレビュー結果",
      "newBadge": "+{{count}} 件 新規",
      "skippedBadge": "{{count}} 件 スキップ",
      "failedBadge": "{{count}} 件 失敗",
      "createdBadge": "+{{count}} 件 作成済み",
      "moreEntities": "+{{count}} 件のその他のエンティティ",
      "moreErrors": "+{{count}} 件のその他のエラー",
      "moreWarnings": "+{{count}} 件 その他",
      "importSuccessful": "インポート成功",
      "bulkImportComplete": "一括インポート完了",
      "importFailed": "インポート失敗",
      "bulkImportCompletedWithErrors": "一括インポートがエラー付きで完了しました",
      "notes": "注記:",
      "errors": "エラー:",
      "done": "完了",
      "cancel": "キャンセル",
      "preview": "プレビュー",
      "import": "インポート",
      "importing": "インポート中...",
      "importAll": "すべてインポート ({{count}})",
      "removeFile": "ファイルを削除",
      "buttonTitle": "YAMLをインポート",
      "buttonAria": "YAMLをインポート",
      "buttonLabel": "インポート",
      "failedToReadFile": "ファイルの読み込みに失敗しました",
      "invalidYaml": "無効なYAMLです",
      "importFailedGeneric": "インポートに失敗しました",
      "typeMismatchError": "このファイルには {{detectedName}} が含まれていますが、現在 {{expectedName}} ページを開いています。正しいページからインポートしてください。"
    },
    "configWarnings": {
      "title": "設定が必要です",
      "subtitle": "以下の項目が設定されるまで、インポートしたエンティティは正常に機能しない可能性があります:",
      "actionRequired": "必要な対応:",
      "actionRequiredDesc": "{{criticalCount}} 件の重要な{{criticalLabel}}と {{warningCount}} 件の{{warningLabel}}が見つかりました。重要な問題を解決しないとエージェントが動作しない可能性があります。",
      "actionRequiredOnlyCritical": "{{criticalCount}} 件の重要な{{criticalLabel}}が見つかりました。重要な問題を解決しないとエージェントが動作しない可能性があります。",
      "issue": "問題",
      "issues": "問題",
      "warning": "警告",
      "warnings": "警告",
      "critical": "重要",
      "categories": {
        "model": "AIモデル",
        "models": "AIモデル",
        "prompt": "プロンプト",
        "prompts": "プロンプト",
        "tool": "ツール",
        "tools": "ツール",
        "knowledge": "ナレッジソース",
        "skill": "スキル",
        "skills": "スキル",
        "connector": "コネクタ",
        "connectors": "コネクタ",
        "iam": "IAM設定",
        "other": "その他"
      }
    },
    "export": {
      "export": "エクスポート",
      "exportSelected": "選択項目をエクスポート",
      "exportYaml": "YAMLをエクスポート",
      "exportAgent": "エージェントをエクスポート",
      "agentAlwaysIncluded": "エージェント (常に含まれます)",
      "included": "対象",
      "dependencies": "依存関係",
      "selectedOf": "{{total}} 件中 {{selected}} 件選択済み",
      "selectAll": "すべて選択",
      "deselectAll": "すべて選択解除",
      "loadingDeps": "依存関係を読み込み中...",
      "noDeps": "依存関係が見つかりませんでした。エージェントのみがエクスポートされます。",
      "permissionDenied": "このエージェントをエクスポートする権限がありません。管理者にお問い合わせください。",
      "failedToLoadDeps": "依存関係の読み込みに失敗しました",
      "filesWillBeExported": "{{count}} 件のYAMLファイルがエクスポートされます",
      "filesWillBeExported_plural": "{{count}} 件のYAMLファイルがエクスポートされます",
      "cancel": "キャンセル",
      "confirmExport": "エクスポートを確定",
      "exporting": "エクスポート中..."
    },
    "entityTypes": {
      "model": "モデル",
      "tool": "ツール",
      "prompt": "プロンプト",
      "skill": "スキル",
      "agent": "エージェント",
      "knowledge": "ナレッジソース",
      "storage_folder": "ストレージフォルダ",
      "connector": "コネクタ",
      "iam": "IAM設定",
      "bundle": "バンドル",
      "workflow": "ワークフロー"
    }
  }
}